import { isPast, format, addMinutes } from 'date-fns';
import { OpportunityManagementService } from './../../../services/opportunity-management/opportunity-management.service';
import { ProcedureTrackerActivityDataService } from './../../../data-services/procedure-tracker-activity/procedure-tracker-activity.data.service';
import { Opportunities, ProcedureTrackerActivity } from './../../../classes/activity/procedure-tracker.activity.class';
import { NewTimeOffComponent } from './../../time-off/new-time-off/new-time-off';
import { debounceTime } from 'rxjs/operators';
import { EventsToolService } from '@omni/services/events-tool/events-tool.service';
import { SurgeryOrderActivityDataService } from '../../../data-services/surgery-order-activity/surgery-order-activity.data.service';
import { QuoteDataService } from './../../../data-services/quote/quote.data.service';
import { Quote, Opportunity, OrderCreationType, OpportunityPrimaryTraget } from './../../../classes/opportunity-management/opportunity.class';
import { ChannelType, EmailActivityChannelDetails, ChannelActivityType } from './../../../classes/consent/channel.class';
import { Component, Output, EventEmitter, Input, OnInit, OnDestroy, ViewChild, ChangeDetectorRef, ChangeDetectionStrategy, Injector, ElementRef } from '@angular/core';
import { UIService, PresentationView, ComponentViewMode } from '../../../services/ui/ui.service';
import {
  MeetingDataService,
  InitiateMeetingPayload,
  UpdateMeetingPayload,
} from '../../../data-services/meeting/meeting.data.service';
import { shouldSkipPostCreateMeetingPatch } from '../../../data-services/meeting/meeting-create-fast-path';
import { MeetingLocationCaptureService } from '../../../data-services/meeting/meeting-location-capture.service';
import { LoadingController, ModalController, IonNav } from '@ionic/angular';
import { Events } from '@omni/events';
import { LogService } from '../../../services/logging/log-service';
import { DeviceService, VIEW_MODE_CHANGE } from '../../../services/device/device.service';
import { ActivityService, ActivitySource } from '../../../services/activity/activity.service';
import { ActivityDataService } from '../../../data-services/activity/activity.service';
import { AppointmentActivity } from '../../../classes/activity/appointment.activity.class';
import { AuthenticationService } from '../../../services/authentication.service';
import { CallPlanOfflineService } from '../../../services/call-plan/call-plan.offline.service';
import { Contact, ContactMeetingState } from '../../../classes/contact/contact.class';
import { ContactOfflineService } from '../../../services/contact/contact.service';
import { FooterService, FooterViews } from '../../../services/footer/footer.service';
import { TrackService, TrackingEventNames } from '../../../services/logging/tracking.service';
import { NavigationService, PageName, ChildNavNames } from '../../../services/navigation/navigation.service';
import { GoAppNavigationService } from '@omni/services/go-app-navigation.service';
import { RepServices } from '../../../data-services/rep/rep.services';
import { SampleService, SamplingDetailsViewMode } from '../../../services/sample/sample.service';
import { SampleActivity, CreateSampleDropRequestBody } from '../../../classes/activity/sample.activity.class';
import { SampleDataService } from '../../../data-services/sample/sample.data.service';
import { FeatureActionsMap, IoConfigurationFeatureCodes } from '../../../classes/authentication/user.class';
import { EmailService } from '../../../services/email-templates/email.service';
import { AccountManagementOfflineService } from '../../../services/account-management/account-management.service';
import { FollowUpActivity, FOLLOW_UP_TYPE } from '../../../classes/activity/follow-up-action.activity.class';
import { FollowUpActivityDataService } from '../../../data-services/follow-up-activity/follow-up-activity.data.service';
import { EmailActivity, EmailViewType, EmailActivityParty, EmailAddress } from '../../../classes/activity/email.activity.class';
import { AccountOfflineService } from '../../../services/account/account.offline.service';
import { PopoverController } from '@ionic/angular';
import { MSEventsService } from '../../../services/ms-events.service';
import { OrderActivity } from '../../../classes/activity/order.activity.class';
import { OperationDetail, OrderActivityDataService } from '../../../data-services/order-activity/order-activity.data.service';
import { ActivityType, Activity, EmbeddedInteraction, EmbeddedInteractionType, ActivityTypeCode, MeetingActivityTypeCode, FormatType, MeetingActivityType, MeetingSubActivityType } from '../../../classes/activity/activity.class';
import { CaseManagementService, AccesingMode } from '../../../services/case-management/case-management.service';
import { CaseType } from '../../../classes/case-intake/case-utility.class';
import { CaseActivity } from '../../../classes/case-intake/case-activity.class';
import { EventsService } from '../../../services/events/events.service';
import { DirectMessagingService } from '../../../services/direct-messaging/direct-messaging.service';
import { TrendingCustomer } from '../../../classes/xperiences/trending.customer.class';
import { XperiencesService, INSIGHT_TYPE } from '../../../services/xperiences/xperiences.service';
import { Utility } from '../../../utility/util';
import { ContentMatchingService } from '../../../services/content-matching/content-matching.service';
import { TranslateService } from '@ngx-translate/core';
import { GlobalUtilityService } from '../../../services/global-utility.service';
import { IndSectionHeaderViewDataModel } from '../../../models/indSectionHeaderDataModel';
import { DateTimeFormatsService, DATE_TIME_CONSTANTS } from '../../../services/date-time-formats/date-time-formats.service';
import { IndPageTitleComponent } from '../../shared/ind-page-title/ind-page-title';
import { IndPageTitleViewDataModel } from '../../../models/indPageTitleDataModel';
import { ToastStyle, NotificationService } from '../../../services/notification/notification.service';
import { DictationFlowService } from '@omni/services/voice-note/dictation-flow.service';
import { PresentationService } from '../../../services/presentation/presentation.service';
import { EmailTemplateType } from '../../../classes/email-templates/email-template.class';
import { InMeetingAllocationComponent } from '../../../components/in-meeting-allocation/in-meeting-allocation';
import { InMeetingCasesComponent } from '../../../components/case-management/in-meeting-cases/in-meeting-cases';
import { SharedDataService } from './../../../data-services/shared-data/shared.data.service';
import { MeetingStructureService } from './../../../services/meeting-structure/meeting-structure.service';
import { Subscription, Subject, combineLatest } from 'rxjs';
import { PhoneCallMeetingStructureService } from '../../../services/phone-call-meeting-structure/phone-call-meeting-structure.service'
import { InitiatePhoneCallPayload, PhoneCallDataService } from '../../../data-services/phone-call/phonecall.data.service';
import { OFFLINE_PHONE_CALL_ID_PREFIX, PhoneActivity } from '../../../classes/activity/phone.activity.class';
import { takeUntil, map, first, filter } from 'rxjs/operators';
import { SurgeryOrderActivity, OrderContact } from '../../../classes/activity/surgery-order.activity.class';
import { AgendaFooterService } from '@omni/services/footer/agenda-footer.service';
import { OpportunityManagementDataService } from '@omni/data-services/opportunity-management/opportunity-management.data.service';
import { IndDateTimeFormViewDataModel } from '@omni/models/indDateTimeFormDataModel';
import { CurViewPageType, DateTimeFieldType, IndDatetimeFormComponent } from '@omni/components/shared/ind-datetime-form/ind-datetime-form';
import { IndDropdownListComponent } from '@omni/components/shared/ind-dropdown-list/ind-dropdown-list';
import { DatePipe } from '@angular/common';
import { AccountManagementDataService } from '@omni/data-services/account-management/account-management.data.service';
import { Guid } from 'typescript-guid';
import { BrandOfflineService } from '@omni/services/brand/brand.service';
import { newActivityConflictCheck, newActivityProximityWarningCheck } from '../../../utility/activity.utility';
import { Account } from '@omni/classes/account/account.class';
import { CustomerSurveyService } from '@omni/services/customer-survey/customer-survey.service';
import { EventActivity, EventParticipant } from '@omni/classes/events-tool/event.class';
import { EventRegistrationStatus } from '@omni/enums/event/event.enum';
import { StoreCheckService } from '@omni/services/store-check/store-check.service';
import { Brand } from '@omni/classes/brand/brand.class';
import { DynamicForm, FormType } from '@omni/classes/dynamic-form/dynamic-form.class';
import { DynamicFormsService } from '@omni/services/dynamic-forms/dynamic-forms-service';
import { DynamicFormComponentModel, DynamicFormType } from '@omni/models/dynamic-form-component.model';
import { AlertService } from '@omni/services/alert/alert.service';
import { SetBookingActivity, SetBookingStatus } from '@omni/classes/activity/set-booking.activity.class';
import { SetBookingDataService } from '@omni/data-services/set-booking/set-booking.data.service';
import { SecInfoConfigDataService } from '@omni/data-services/sec-info-config/sec-info-config-data-service';
import { DiskService } from '@omni/services/disk/disk.service';
import { DB_KEY_PREFIXES } from '@omni/config/pouch-db.config';
import { EmailDataService } from '@omni/data-services/email/email.data.service';
import { FeatureActionsService } from '@omni/services/feature-actions/feature-actions.service';
import { QuotesService } from '@omni/services/quote/quote-tool.service';
import { EntityNameForTranslation, LocalizationService } from '@omni/services/localization/localization.service';
import { MedicalInquiryService } from '../../../services/medical-inquiry/medical-inquiry.service';
import { MedicalInquiryNewComponent } from '../../medical-inquiry/medical-inquiry-new/medical-inquiry-new.component';
import { cloneDeep, isEmpty, range, size, uniqBy } from 'lodash-es';

/**
 * Generated class for the ActivityNewActivityComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: "new-activity",
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: 'new-activity.html',
  styleUrls: ['new-activity.scss']
})
export class NewActivityComponent implements OnInit, OnDestroy {
  private _newTimeOffCmp: NewTimeOffComponent;
  @ViewChild('timeOffCmp') set timeOffCmp(cmp: NewTimeOffComponent) {
    this._newTimeOffCmp = cmp;
  }
  public subject: string;
  public location: string;
  public startTime: string;
  public endTime: string;
  public duration: any;
  public notes: string;
  public cellData: { allDay?: boolean, startDate: Date, endDate: Date };
  public hasTimeoffEnabled: boolean = false;
  public hasSamplingEnabled: boolean = false;
  public hasAllocationOrdersUnrestrictedEnabled: boolean = false;
  hasSampleDeliveryRequestEnabled = false;
  public hasPhonecallEnabled: boolean = false;
  public hasLiveMeetEnabled: boolean = false;
  public hasProcedureLogEnabled: boolean = false;
  public hasProcedureLogConfigEnabled: boolean = false;
  public hasBulkProcedureLogConfigEnabled: boolean = false;
  public hasOpportunityEnabled: boolean = false;
  public hasStoreCheckEnabled: boolean = false;
  public isMeetingEnabled: boolean = true;
  public isAccountVisitEnabled: boolean = false;
  public hasMeetingDurationEnabled = false;
  public hasMeetingDurationRequired = false;
  public hasMeetingEndDateEnabled = false;
  public hasKitBookingEnabled:boolean = false;
  public isSurveyEnabled = false;
  public hasQuoteEnabled = false;
  private currentMasterPage: PageName;
  private prevStartTime: string;
  private prevEndTime: string;
  public minStartDate: string;
  private hasEmailActivityEnabled: boolean = false;
  hasDirectMessagingEnabled: boolean = false;
  // OMNI-61541: true when the single contact in context carries the AMA No-Contact flag
  // (donotemail). The Message option stays visible but is shown disabled.
  public isMessageAMANoContact: boolean = false;
  public hasCustomerInquiryEnabled: boolean = false;
  public hasMedicalInquiryEnabled: boolean = false;
  public hasXperincesEnabled: boolean = false;
  public selectedType: string = null;
  public selectedMessagingChannelType: EmailActivityChannelDetails;
  public selectedConsentCustomer: Contact;
  private contactBeforeMeetingConsent: Contact;
  public newActivityTitle: string = 'NEW_ACTIVITY';
  public forContactName: string = '';
  public isConfirmEnabled: boolean = true;
  public navCtrl: IonNav;
  public isMeetingPresentation: boolean = false;
  public selectedInsightType: INSIGHT_TYPE = INSIGHT_TYPE.CUSTOMER_INSIGHT;
  public insightType = INSIGHT_TYPE;

  private _orientationHandler: (modeChange: VIEW_MODE_CHANGE, curPageName: PageName, curMasterPageName: PageName) => void;

  private followUpMeetingContacts: Array<Contact> = []; //Contacts to add for follow up activity
  private followupMeetingSubject: string = '';

  @Input() NewActivitySource: string;
  public confirmTimeoff: boolean = false;

  @Output() onCancelNewActivity = new EventEmitter();
  noEligibleAllocation: boolean;

  private pageModal: HTMLIonModalElement;

  public isFollowUpActionEnabled: boolean = false;
  public isAccountPlanTaskEnabled: boolean = false;
  public isMarketingPlanTaskEnabled: boolean = false;
  public isEventFollowUpActionEnabled: boolean = false;
  public isScientificPlanTaskEnabled: boolean = false;
  public isOpportunityTaskEnabled: boolean = false;
  public isNoneTaskEnabled: boolean = false;
  public isMeetingTaskEnabled: boolean = false;
  public followUpActionCategory: string = '';
  public procedureCategory: string = '';
  public procedureLogSelection: string = '';
  public isOrderCreationEnabled: boolean = false;
  isQuoteCreationEnabled = false;
  private isLayoverPushView: boolean = false;
  private layoverViewPushedFrom: any;
  private layoverViewPassedData: any;
  public newActivityHeader: IndSectionHeaderViewDataModel;
  isConsentCreationEnabled = false;
  private translatedGlobalCustomerText: string;
  public newActivityPageTitle: IndPageTitleViewDataModel;
  private IcurrentMeetingActivitySubscription: Subscription;
  private selectedMeetingActivity: EmbeddedInteraction;
  public backgroundUploadInProgress: boolean = false;

  private _updateDayClick: () => void;
  private _updateCellClick: () => void;
  private _updateCurrentDate: () => void;

  public isLoaderOn: boolean = false;
  public meetingCreationInProgress: boolean = false;
  public activeActivityCreationView: string = '';
  private orgDiffMinutes = 0;
  type: CaseType;

  get activityCreationInProgress(): boolean {
    return !!this.activeActivityCreationView;
  }

  //@ViewChild(Content, {static:true}) content: Content;
  noPhoneNumber: boolean;
  @Input() from: any
  @Input() plan: any
  @Input() pres: any
  @Input() account: any
  @Input() opportunity: any
  @Input() contact: any
  @Input() surgeryOrder:any
  @Input() setBooking:any
  @Input() isSkipConsentForFirstTimeEmailFlow: boolean;
  private ngDestroy$ = new Subject<boolean>();
  private ItranslatedCustomerTextSubscription: Subscription;
  public translatedCustomerInquiryText: string = "";
  public translatedCustomerInsightPlsText: string = "";

  public startDateField: IndDateTimeFormViewDataModel
  public startTimeField: IndDateTimeFormViewDataModel;
  public endDateField: IndDateTimeFormViewDataModel;
  public endTimeField: IndDateTimeFormViewDataModel;
  public durationField: IndDateTimeFormViewDataModel;
  private startDateTime: string;
  private startDateValue: string;
  private startTimeValue: string;
  private endDateTime: string;
  private endDateValue: string;
  private endTimeValue: string;
  dateFormatSubscription: Subscription;
  timeFormatSubscription: Subscription;
  ContactStatusDisplay = {
    100000000: "assets/imgs/contact_conn.png",
    100000002: "assets/imgs/contact_offline.svg",
    100000003: "assets/imgs/contact_disc.png"
  }
  public displayConflictAlert: boolean = false;
  public conflictMsg: string;
  public readonly uuid: number = new Date().getTime();
  public readonly activityTypeTranslationEntity = EntityNameForTranslation.ActivityType;

  private linkEntitiesReqPayload: any = [];

  public customerInquiryDescription: string;
  public hasOpportunityDisabledOffline:boolean = false;
  public filteredChannelList: EmailActivityChannelDetails[] = [];
  private updateCellClicked: boolean = false;


  private allProperties = [
    "hasProcedureLogEnabled",
    "isMeetingEnabled",
    "hasTimeoffEnabled",
    "isFollowUpActionEnabled",
    "hasPhonecallEnabled",
    "hasDirectMessagingEnabled",
    "isAccountVisitEnabled",
    "isOrderCreationEnabled",
    "hasSamplingEnabled",
    "hasCustomerInquiryEnabled",
    "hasLiveMeetEnabled",
    "hasKitBookingEnabled",
    "hasXperincesEnabled",
    "hasOpportunityEnabled",
    "isSurveyEnabled",
    "isQuoteCreationEnabled",
    "isConsentCreationEnabled",
    "hasStoreCheckEnabled",
    "hasQuoteEnabled",
    "hasMedicalInquiryEnabled",
    "hasSampleDeliveryRequestEnabled"
  ]
  public procedureLogConfigList: {label: string, value: string}[] = [];
  public meetingActivityTypes: MeetingActivityType[] = [];
  public selectedMeetingActivityType: MeetingActivityType = null;
  /** True when activity types have mandatory flag but no default — user must select Format before proceeding */
  get isMeetingFormatRequired(): boolean {
    return this.meetingActivityTypes.some(at => at.indskr_mandatory) && !this.selectedMeetingActivityType;
  }

  @Input() callbackEvent;

  constructor(
    public readonly authService: AuthenticationService,
    public uiService: UIService,
    private meetingService: MeetingDataService,
    private meetingLocationCaptureService: MeetingLocationCaptureService,
    private contactService: ContactOfflineService,
    private logService: LogService,
    public device: DeviceService,
    private activityService: ActivityDataService,
    public activityOfflineService: ActivityService,
    private emailService: EmailService,
    private loadingController: LoadingController,
    private events: Events,
    private authenticationOfflineService: AuthenticationService,
    private callPlanOfflineService: CallPlanOfflineService,
    private footerService: FooterService,
    private trackingService: TrackService,
    private navService: NavigationService,
    public repService: RepServices,
    public samplingService: SampleDataService,
    public samplingOfflineService: SampleService,
    public accountManagementService: AccountManagementOfflineService,
    private followUpActivityDataService: FollowUpActivityDataService,
    private accountService: AccountOfflineService,
    private popoverCtrl: PopoverController,
    public msEventService: MSEventsService,
    private orderActivityDataService: OrderActivityDataService,
    public caseManagementService: CaseManagementService,
    private injector: Injector,
    public directMessagingService: DirectMessagingService,
    private eventService: EventsService,
    private xperiencesService: XperiencesService,
    private contentMatchingService: ContentMatchingService,
    public translate: TranslateService,
    public utilityService: GlobalUtilityService,
    public dateTimeFormatsService: DateTimeFormatsService,
    private notificationService: NotificationService,
    private callPlanService: CallPlanOfflineService,
    private presentationService: PresentationService,
    private modalCtrl: ModalController,
    private sampleDataService: SampleDataService,
    private sharedDataService: SharedDataService,
    private meetingStructureService: MeetingStructureService,
    public _cd: ChangeDetectorRef,
    public phoneCallDataService: PhoneCallDataService,
    private phoneCallMeetingStructureService: PhoneCallMeetingStructureService,
    private surgeryOrderActivityDataService: SurgeryOrderActivityDataService,
    private procedureTrackerActivityDataService: ProcedureTrackerActivityDataService,
    private agendaFooterService: AgendaFooterService,
    private opportunityDataService: OpportunityManagementDataService,
    private readonly opportunityService: OpportunityManagementService,
    private datePipe: DatePipe,
    private eventsToolService: EventsToolService,
    private accountManagementDataService: AccountManagementDataService,
    private brandService: BrandOfflineService,
    private customerSurveyService: CustomerSurveyService,
    private storeCheckService: StoreCheckService,
    private readonly dynamicFormService: DynamicFormsService,
    private readonly alertService: AlertService,
    private readonly setBookingDataService: SetBookingDataService,
    private secondaryInfoService: SecInfoConfigDataService,
    private readonly diskService: DiskService,
    private emailDataService:EmailDataService,
    private featureActionService: FeatureActionsService,
    private quotesOfflineService : QuotesService,
    public localizationService: LocalizationService,
    private medicalInquiryService: MedicalInquiryService,
    private goAppNavigationService: GoAppNavigationService,
  ) {


    // Cleaning up the time initialization.
    // We are assuming that there's no cell selection.
    // Single click on a cell invokes new meeting creation instead of selecting it.
    // It looks like it's designed to pass cell data through the uiService so I'm going to stick with it. (setCellData)
    // [UiService] cellData : { view: string, data: { startDate: Date, endDate: Date } }
    // Start time init:
    //  - Default: Today's next available time
    //  - If a cell data exists and coming from 'day-views' (day/3-day/week): set accroding to the cell data
    //  - If a cell data exists and coming from 'month-views' (month/year): set the time to 8 AM
    //    - If cell data is today's, use the Default.

    this.setCellData();
    this._updateCellClick = () => {
      this.updateCellClicked = true;
      this.setCellData();
      this.initDateTimeFormFields();
      this._cd.markForCheck();
    }

    this._updateDayClick = () => {
      this._initTimeForCalendarPage();
      this.initDateTimeFormFields();
      this._cd.markForCheck();
    }

    this._updateCurrentDate = () => {
      this.uiService.cellData = undefined;
      this._initTimeForCalendarPage();
      this.initDateTimeFormFields();
      this._cd.markForCheck();
    }

    this.events.subscribe('updatedCellClick', this._updateCellClick);
    this.events.subscribe('updatedDayClick', this._updateDayClick);
    this.events.subscribe('updateCurrentDate', this._updateCurrentDate);
    // subscribe to newTimeOff datetime and use it to check validateTimeOffDate
    this.events.subscribe("updateNewTimeOffDateTime", (newTimeOff) => {
      if (newTimeOff.totStartTime) {
        this.startTime = newTimeOff.totStartTime;
      } else if (newTimeOff['preSelectedTime'] && newTimeOff['preSelectedTime'].startTime) {
        this.startTime = newTimeOff['preSelectedTime'].startTime;
      }
      if (newTimeOff.totEndTime) {
        this.endTime = newTimeOff.totEndTime;
      } else if (newTimeOff['preSelectedTime'] && newTimeOff['preSelectedTime'].endTime) {
        this.endTime = newTimeOff['preSelectedTime'].endTime;
      }
      if(this.from == PageName.SetBookingActivityDetailsComponent) {
        let dateTime = { startDateTime: this.startTime, endDateTime: this.endTime };
        this.dateTimeFormatsService.updateLimitedMinTime.next(dateTime);
        this.initDateTimeFormFields();
        this._cd.markForCheck();
      }
    });
    this.IcurrentMeetingActivitySubscription = this.meetingStructureService.selectedMeetingActivityObserver.subscribe(activity => {
      this.selectedMeetingActivity = activity;
    });
    this.dateFormatSubscription = this.dateTimeFormatsService.dateFormat.subscribe(df => {
      if (df) {
        this.initDateTimeFormFields();
        this._cd.markForCheck();
      }
    });
    this.timeFormatSubscription = this.dateTimeFormatsService.timeFormat.subscribe(tf => {
      if (tf) {
        this.initDateTimeFormFields();
        this._cd.markForCheck();
      }
    });

    combineLatest([
      this.activityOfflineService.conflictCheckState$,
      this.activityOfflineService.signalConflictCheck$.asObservable(),
    ]).pipe(
      takeUntil(this.ngDestroy$),
      debounceTime(0),
      filter(([state, signalPayload]) => (
        signalPayload?.componentUuid === this.uuid
        && signalPayload?.signal === true
        && state === 'Done'
        && ((this.uiService.activeViewNewMeeting === 'meeting' && !this.uiService.activeViewNewMeetingType)
          || this.uiService.activeViewNewMeeting === 'accountVisit'
          || this.uiService.activeViewNewMeeting === 'phonecall'
          || this.uiService.activeViewNewMeeting === 'timeoff')
      )),
    ).subscribe(([state, signalPayload]) => {
      this.activityOfflineService.signalConflictCheck$.next({ componentUuid: this.uuid, signal: false, start: null, end: null });
      const startDateToCheck = signalPayload?.start instanceof Date ? signalPayload.start : new Date(this.startDateTime);
      const endDateToCheck = signalPayload?.end instanceof Date ? signalPayload.end : new Date(this.endDateTime);
      const hasConflict = newActivityConflictCheck(
        this.activityOfflineService.activities,
        this.activityOfflineService.conflictCheckStartIdx,
        this.eventsToolService.eventsToolData,
        this.eventsToolService.conflictCheckLastIdx,
        startDateToCheck,
        endDateToCheck,
        this.authenticationOfflineService.user.xSystemUserID,
      );
      let hasWarning = false;
      if (this.contactService.contactInformation?.ID) {
        hasWarning = newActivityProximityWarningCheck(
          this.activityOfflineService.activities,
          startDateToCheck,
          endDateToCheck,
          this.authenticationOfflineService.user.xSystemUserID,
          this.authenticationOfflineService.user.meetingProximityWarningPeriod,
          this.contactService.contactInformation?.ID
        );
      }
      this.conflictMsg = hasWarning ? this.translate.instant('PROXIMITY_MEETING_WARNING') : this.translate.instant('ACTIVITY_CONFLICT_MSG');
      this.displayConflictAlert = hasConflict || hasWarning;
      this._cd.markForCheck();
    });
  }



  ngOnInit() {
    this.translate.onLangChange.subscribe(data => {
      this.resetNewActivityOptions();
      this.initNewActivityScreenFormFields();
      this.initNewActivityPagetitle();
      this.getFormattedTimeInterval();
      this.initGlobalCustomerText();
      this.initDateTimeFormFields();
      this.initDescriptions();
    });
    this.hasAllocationOrdersUnrestrictedEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.ALLOCATION_ORDERS_UNRESTRICTED);
    this.hasVoiceNoteTakerEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.VOICE_NOTE_TAKER);
    if (this.from) {
      if (this.from == 'AccountManagementTool') {
          this.isLayoverPushView = true;
          this.layoverViewPushedFrom = 'AccountManagementTool';
          this.layoverViewPassedData = this.plan;
      } else if (this.from == 'ScientificActivityPage') {
          this.isLayoverPushView = true;
          this.layoverViewPushedFrom = 'ScientificActivityPage';
          this.layoverViewPassedData = this.plan;
      } else if (this.from == 'PresentationToolsPage') {
          this.isLayoverPushView = true;
          this.layoverViewPushedFrom = 'PresentationToolsPage';
          this.layoverViewPassedData = this.pres;
      } else if (this.from == 'AccountTool') {
          this.isLayoverPushView = true;
          this.layoverViewPushedFrom = 'AccountTool';
          this.layoverViewPassedData = this.account;
          this.hasQuoteEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.QUOTES)
      }
      else if (this.from == 'OpportunityManagementTool'
        || this.from == 'AccountProfileOpportunities'
        || this.from == 'AccountPlanOpportunities'
        || this.from == 'MarketingPlanInfoopportunities') {
          this.isLayoverPushView = true;
          this.layoverViewPushedFrom = this.from;
          this.layoverViewPassedData = this.opportunity;
          if (this.from == 'OpportunityManagementTool' || this.from == 'MarketingPlanInfoopportunities') {
            this.hasQuoteEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.QUOTES) && this.opportunity.statusCode === 1;
          }
      } else if (this.from === 'ActivitiesDetailsPane'
        || this.from === PageName.PhoneCallDetailsComponent
        || this.from === 'ContactPageComponent'
        || this.from === 'EventDetailsPane'
        || this.from === PageName.SetBookingActivityDetailsComponent) {
          this.isLayoverPushView = true;
          this.layoverViewPushedFrom = this.from;
          this.NewActivitySource = this.activityOfflineService.activitySource;
      }
      else if (this.from == 'ProcedureLogFrom') {
          this.isLayoverPushView = true;
          this.layoverViewPushedFrom = 'ProcedureLogFrom';
          this.layoverViewPassedData = this.surgeryOrder;
      }
      else if (this.from === PageName.CustomerCallPlanDetails) {
          this.isLayoverPushView = true;
          this.layoverViewPushedFrom = PageName.CustomerCallPlanDetails;
          this.layoverViewPassedData = this.account ? this.account : undefined;
      }
    } else {
      this.activityOfflineService.activitiesPaneNewActivityComponentUUID = this.uuid;
      if (this.activityOfflineService.activitySource === ActivitySource.MEETING_PRESENTATION || this.activityOfflineService.activitySource === ActivitySource.AGENDA) {
        this.NewActivitySource = this.activityOfflineService.activitySource;
      }
    }
    this.hasMeetingDurationEnabled = this.authenticationOfflineService.hasFeatureAction({ featureAction: FeatureActionsMap.MEETING_DURATION, skipLDCheck: true });
    this.hasMeetingDurationRequired = this.authenticationOfflineService.hasFeatureAction({ featureAction: FeatureActionsMap.MEETING_DURATION_REQUIRED, skipLDCheck: true });
    this.hasMeetingEndDateEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.MEETING_REMOVE_END_DATE) ? false : !this.hasMeetingDurationEnabled;

    this.uiService.activeViewNewMeetingType = '';
    // Get the master page that called this new activity component.
    this.currentMasterPage = this.navService.getActiveChildNavViewMasterPageName();
    //whenever the user click + icon default view is agenda
    if (this.NewActivitySource === ActivitySource.MEETING_PRESENTATION) {
      this.uiService.setActiveViewForNewMeeting('MeetingPresentation');
    } else if (this.NewActivitySource == ActivitySource.CONTACT_INFO) {
      if (this.hasAllocationOrdersUnrestrictedEnabled) {
        this.noEligibleAllocation = false;
      }
      else if (this.contactService.contactInformation) {
        this.newActivityTitle = 'NEW_ACTIVITY_FOR';
        this.forContactName = this.contactService.contactInformation.fullName;
        let contactCustomeAllocations = this.samplingOfflineService.contactCustomerSampleAllocations.find(o => {
          return o.contactId == this.contactService.contactInformation.ID
        });
        if (!contactCustomeAllocations ||
          !contactCustomeAllocations.currentCustomerSampleAllocations ||
          contactCustomeAllocations.currentCustomerSampleAllocations.length == 0) {
          this.noEligibleAllocation = true;
        }
      }
      else {
        this.noEligibleAllocation = false;
      }
    } else if (this.NewActivitySource !== ActivitySource.MEETING_DETAIL) {
      this.uiService.setActiveViewForNewMeeting( this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.PROCEDURE_LOG) ? 'surgeryorder' : 'meeting');
    }
    if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.ALLOCATION_TOOL)
      && this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.ALLOCATION_ORDER_ACTIVITY)
    ) {
      if ((this.navService.getCurrentPageName() === PageName.GoAppActivitiesPageComponent
        || this.NewActivitySource === ActivitySource.EVENT_DETAIL
        || this.currentMasterPage === PageName.ContactPageComponent) && !(this.NewActivitySource === ActivitySource.MEETING_PRESENTATION
        || this.NewActivitySource === ActivitySource.MEETING_DETAIL)) {
        this.hasSamplingEnabled = true;
        this.hasAllocationOrdersUnrestrictedEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.ALLOCATION_ORDERS_UNRESTRICTED);
      }
    }

    if (
      this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.SAMPLE_DELIVERY_REQUESTS) &&
      this.NewActivitySource === ActivitySource.CONTACT_INFO &&
      !this.uiService.isConsentFromToolDrawer
    ) {
      this.hasSampleDeliveryRequestEnabled = true;
    }


    if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.ACCOUNT_VISIT)) {
      this.isAccountVisitEnabled = true;
    }
    if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.TIME_OFF_TOOL)
      && (!this.NewActivitySource || (this.NewActivitySource && this.NewActivitySource != 'ContactInfo'))) {
      this.hasTimeoffEnabled = true;
    }
    if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.LIVEMEET)) {
      this.hasLiveMeetEnabled = true;
    }
    if(this.featureActionService.isShortCallLauncherEnabledInMobileDevice && this.authService.hasFeatureAction(FeatureActionsMap.SHOR_CALL_LAUNCHER_DISABLE_APPOINTMENT_IN_NEW_ACTIVITY)) {
      this.isMeetingEnabled = this.isAccountVisitEnabled = false;
    }

    this.prevStartTime = this.dateTimeFormatsService.formatDateForAPI(this.startTime);
    this.prevEndTime = this.dateTimeFormatsService.formatDateForAPI(this.endTime);
    let dt = new Date();
    dt.setHours(0, 0)
    this.minStartDate = this.dateTimeFormatsService.subtractDays(dt, this.authenticationOfflineService.user.maxMeetingStartDays).toISOString();

    // Update start/end time field with selected time from the time picker
    this.dateTimeFormatsService.isNewActivity = true;
    this.dateTimeFormatsService.updateSelectedTime$.pipe(takeUntil(this.ngDestroy$)).subscribe((timeData) => {
      if (timeData) {
        if (timeData.id == DateTimeFieldType.StartTimeField) {
          this.startTime = timeData.time;
          this.handleStartDateTimeValue();
        } else if (timeData.id == DateTimeFieldType.EndTimeField) {
          this.endTime = timeData.time;
          this.handleEndDateTimeValue();
        }
      }
    });
    this.initDateTimeFormFields();

    if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.MESSAGE_ACTIVITY)) {
      this.hasDirectMessagingEnabled = true
    }

    // Follow up action : the user will have the category 'None' as a default, regardless of FA.
    this.isFollowUpActionEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.FOLLOW_UP_ACTION_ACTIVITY);
    this.isNoneTaskEnabled = true;
    this.followUpActionCategory = 'none';
    this.isAccountPlanTaskEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.ACCOUNT_MANAGEMENT) && this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.ACCOUNT_FOLLOW_UP_TASK);
    this.isMarketingPlanTaskEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.MARKETING_BUSINESS_PLAN);
    this.isEventFollowUpActionEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.EVENT_FOLLOW_UP_ACTION);
    this.isScientificPlanTaskEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.SCIENTIFIC_TOOL_PLAN) && this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.SCIENTIFIC_FOLLOW_UP_TASK);
    this.isOpportunityTaskEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.OPPORTUNITY_MANAGEMENT_TASK);

    if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.ORDER_MANAGEMENT)) {
      this.isOrderCreationEnabled = true;
    }
    if (!this.isOrderCreationEnabled && this.from == 'OpportunityManagementTool') {
      const selectedOppurtunityType = this.opportunityService.opportunityTypes.find(ot => ot.indskr_opportunitytypeid == this.opportunity.opportunityTypeId);
      if (selectedOppurtunityType && selectedOppurtunityType.indskr_ordercreation && selectedOppurtunityType.indskr_ordercreationprocess == OrderCreationType.MANUAL) {
        this.isOrderCreationEnabled = true;
      }
    }
    if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CONSENT_TOOL)) {
      this.isConsentCreationEnabled = true;
    }
    if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CASE_INTAKE)) {
      this.hasCustomerInquiryEnabled = true;
    }
    if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.PHONECALL_ACTIVITY)) {
      this.hasPhonecallEnabled = true;
    }
    if (this.authenticationOfflineService.user.hasBulkProcedureLog && !this.authenticationOfflineService.user.hasProcedureLog) {
      this.procedureCategory = "procedure_tracker"
    }
    if (this.authenticationOfflineService.user.hasProcedureLog && !this.authenticationOfflineService.user.hasBulkProcedureLog && this.authService.user.buSettings['indskr_noprocedureday']) {
      this.procedureCategory = "procedureDay"
    }
    if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.XPERIENCES)
      && (this.layoverViewPushedFrom !== 'ScientificActivityPage')
      && (this.layoverViewPushedFrom !== 'AccountManagementTool')
      && (this.layoverViewPushedFrom !== 'CallPlansPage')
      && this.uiService.activitiesPagePlanTabSelectedPlan !== 'goalsPlansTab'
      && ((this.currentMasterPage === PageName.GoAppActivitiesPageComponent && this.footerService.isActivitiesButton) || this.currentMasterPage === PageName.ContactPageComponent)) {
      this.hasXperincesEnabled = true;
    }

    if (this.hasPhonecallEnabled && this.contactService.contactInformation && (this.navService.getCurrentPageName() == PageName.ContactPageComponent || this.currentMasterPage === PageName.CallPlanDetails || this.navService.getCurrentMasterPageName() == PageName.CallPlanComponent
      || (this.navService.getCurrentMasterPageName() == PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPageTab === 'plans' && this.uiService.activitiesPagePlanTabSelectedPlan === 'goalsPlansTab') || this.currentMasterPage === PageName.CustomerCallPlanDetails || this.navService.getCurrentMasterPageName() == PageName.CustomerCallPlanPage)) {
      if (isEmpty(this.contactService.contactInformation.mobilePhone) && isEmpty(this.contactService.contactInformation.telephone)
        && isEmpty(this.contactService.contactInformation.indskr_alternatephone1) && isEmpty(this.contactService.contactInformation.indskr_alternatephone2)
        && isEmpty(this.contactService.contactInformation.indskr_alternatephone3)) {
        this.noPhoneNumber = true;
      } else {
        this.noPhoneNumber = false;
      }
      if (this.authService.hasFeatureAction({ featureAction: FeatureActionsMap.ENABLE_PHONE_CALL_CONSENT_CHECK, skipLDCheck: true })
        && this.contactService.checkIfContactIsAMADoNotContact()) {
        this.hasPhonecallEnabled = false;
      }
    }

    // OMNI-61541: AMA No-Contact — in the Contact tool (single-contact context), a flagged
    // contact (donotemail) cannot be messaged. Keep the Message option visible but show it
    // disabled with an explanatory secondary text. Independent of any feature action; the
    // contact remains visible everywhere else.
    this.isMessageAMANoContact = false;
    if (this.hasDirectMessagingEnabled && this.contactService.contactInformation
      && (this.navService.getCurrentPageName() == PageName.ContactPageComponent || this.currentMasterPage === PageName.CallPlanDetails || this.navService.getCurrentMasterPageName() == PageName.CallPlanComponent
        || (this.navService.getCurrentMasterPageName() == PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPageTab === 'plans' && this.uiService.activitiesPagePlanTabSelectedPlan === 'goalsPlansTab') || this.currentMasterPage === PageName.CustomerCallPlanDetails || this.navService.getCurrentMasterPageName() == PageName.CustomerCallPlanPage)
      && this.contactService.isContactAMANoContact(this.contactService.contactInformation)) {
      this.isMessageAMANoContact = true;
    }
    // Have to implement the condition for the surgery order
    this.hasProcedureLogEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.PROCEDURE_LOG);
    this.hasProcedureLogConfigEnabled = this.authenticationOfflineService.user.hasProcedureLog;
    this.hasBulkProcedureLogConfigEnabled = this.authenticationOfflineService.user.hasBulkProcedureLog;
    this.hasStoreCheckEnabled = this.authService.hasFeatureAction(FeatureActionsMap.STORE_CHECK);
    this.hasKitBookingEnabled = this.authService.hasFeatureAction(FeatureActionsMap.KIT_BOOKING);
    if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.MEDICAL_INQUIRY_TOOL)) {
      this.hasMedicalInquiryEnabled = true;
    }
    this.hasOpportunityDisabledOffline = this.device.isOffline && this.authService.hasFeatureAction(FeatureActionsMap.OPPORTUNITY_REVENUE_USER_PROVIDED)
    // Call it last to manually enable or disable activity options depending upon the view it is being created
    this.resetNewActivityOptions();
    // OMNI-60698: auto-create the first-time-email draft exactly once, here in the
    // initial setup — NOT inside resetNewActivityOptions(), which is re-run on every
    // translate.onLangChange (fired on each delta sync since OMNI-60320).
    this.autoCreateFirstTimeEmailDraftIfApplicable();
    this.initNewActivityScreenFormFields();
    this.initNewActivityPagetitle();
    this.initDescriptions();
    this.activityOfflineService.invokeCallCenterActivity$.subscribe((value) => {
      if (value) {
        // @ts-ignore
        this.setActiveView('meeting');
        this.handleNewActivity();
      }
    }).unsubscribe();
    this.activityOfflineService.invokeCallCenterActivity$.next(false);
    this.events.subscribe('createphonecall', () => {
      this.uiService.activeViewNewMeeting = 'phonecall'
      this.handleNewActivity()
    })
    this.device.isOfflineObservable.pipe(takeUntil(this.ngDestroy$)).subscribe((data) => {
      this._cd.markForCheck();
    });
    this.ItranslatedCustomerTextSubscription = this.authenticationOfflineService.globalCustomerTxtUpdatedObservable.subscribe(val => {
      this.translatedglobalCustomerText();
    });
    this.device.isBackgroundUploadInProgressObservable.pipe(takeUntil(this.ngDestroy$)).subscribe(inProgress => {
      if (this.activityOfflineService.selectedActivity) {
        if (this.NewActivitySource == ActivitySource.MEETING_DETAIL || this.NewActivitySource === ActivitySource.MEETING_PRESENTATION) {
          this.backgroundUploadInProgress = inProgress && this.activityOfflineService.hasOfflineMeetingData(this.activityOfflineService.selectedActivity.ID);
        } else if (this.NewActivitySource == ActivitySource.PHONE_CALL_ACTIVITY_DETAIL) {
          this.backgroundUploadInProgress = inProgress && this.activityOfflineService.hasOfflinePhoneCallData(this.activityOfflineService.selectedActivity.ID);
        }
        this.initNewActivityPagetitle();
      }
    });
    this.eventService.subscribe('remote_meeting_participant_Joined_left', this.handleContactConnectionLost.bind(this));
    this.activityOfflineService.activityOpenedFromTodo = false;
  }

  public handleContactConnectionLost(data) {
    if (this.uiService.activeViewNewMeeting == 'consent') {
      this.setActiveView('consent')
    }
  }

  public translatedglobalCustomerText() {
    this.initGlobalCustomerText();
    this._cd.markForCheck();
  }

  private initGlobalCustomerText() {
    let translatedglobaltext;
    switch (this.utilityService.globalCustomerText) {
      case 'Customer':
        translatedglobaltext = this.translate.instant('CUSTOMER');
        break;
      case 'Stakeholder':
        translatedglobaltext = this.translate.instant('STAKEHOLDER');
        break;
      default:
        translatedglobaltext = this.utilityService.globalCustomerText;
          break;
    }
    this.translatedGlobalCustomerText = translatedglobaltext;
    this.translatedCustomerInquiryText = this.translate.instant('CUSTOMER_INQUIRY_WITH_TEXT', { globalCustomerText: translatedglobaltext });
    this.translatedCustomerInsightPlsText = this.translate.instant('XPERIENCES_CUSTOMER_INSIGHTS_PLUS', { globalCustomerText: translatedglobaltext });
  }

  public resetNewActivityOptions(): void {
    this.isQuoteCreationEnabled = false;
    this.isConsentCreationEnabled = false;
    this.directMessagingService.channelList.pipe(
      takeUntil(this.ngDestroy$),
      map(channels => channels.sort((a, b) => a.title.localeCompare(b.title)))
    ).subscribe(sortedChannels => {
      this.filteredChannelList = [...sortedChannels];
    });
    if (this.layoverViewPushedFrom) {
      if (this.layoverViewPushedFrom == 'AccountManagementTool' || this.layoverViewPushedFrom == 'ScientificActivityPage') {
        this.hasSamplingEnabled = false;
        this.hasEmailActivityEnabled = false;
        this.isAccountVisitEnabled = false;
        this.hasTimeoffEnabled = false;
        this.hasStoreCheckEnabled = false;
        this.hasPhonecallEnabled = (this.layoverViewPushedFrom == 'ScientificActivityPage') ? false : this.hasPhonecallEnabled;
        this.isOrderCreationEnabled = false;
        this.hasCustomerInquiryEnabled = false;
        this.hasLiveMeetEnabled = false;
        this.hasProcedureLogEnabled = false;
        this.hasProcedureLogConfigEnabled = false;
        this.hasBulkProcedureLogConfigEnabled = false;
        this.layoverViewPushedFrom == 'ScientificActivityPage' ? this.hasDirectMessagingEnabled = true : this.hasDirectMessagingEnabled = false;
        this.isOpportunityTaskEnabled = false;
        this.hasKitBookingEnabled = false;
        this.hasMedicalInquiryEnabled = false;
        if (this.layoverViewPassedData &&
          ((this.layoverViewPassedData.state == 0 && this.layoverViewPassedData.status == 'Open' && this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.FOLLOW_UP_ACTION_ACTIVITY)) ||
            (this.layoverViewPassedData.statusCode == 548910003 && this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.SCIENTIFIC_FOLLOW_UP_TASK)))) {
          this.isFollowUpActionEnabled = true;
          this.isNoneTaskEnabled = false;
        if (this.layoverViewPushedFrom == 'AccountManagementTool') this.isScientificPlanTaskEnabled = false;
          // Maybe only show the specific category type
          this.followUpActionCategory = 'accountplantask';
        if (this.layoverViewPushedFrom == 'ScientificActivityPage' && this.isScientificPlanTaskEnabled) {
          this.isAccountPlanTaskEnabled = false;
          this.isMarketingPlanTaskEnabled = false;
          this.followUpActionCategory = 'scientificplantask';
        }
    } else {
          this.isFollowUpActionEnabled = false;
        }
      } else if (this.layoverViewPushedFrom == 'AccountTool') {
        this.hasSamplingEnabled = false;
        this.hasAllocationOrdersUnrestrictedEnabled = false;
        this.hasEmailActivityEnabled = false;
        this.hasTimeoffEnabled = false;
        this.hasDirectMessagingEnabled = false;
        this.hasCustomerInquiryEnabled = false;
        this.hasMedicalInquiryEnabled = false;
        this.hasLiveMeetEnabled = false;
        this.isScientificPlanTaskEnabled = false;
        this.hasOpportunityEnabled = this.authService.hasFeatureAction(FeatureActionsMap.OPPORTUNITY_MANAGEMENT);
      }
      else if (this.layoverViewPushedFrom == 'OpportunityManagementTool'
        || this.layoverViewPushedFrom == 'AccountProfileOpportunities'
        || this.from == 'AccountPlanOpportunities'
        || this.from == 'MarketingPlanInfoopportunities') {
        if (!this.isOpportunityTaskEnabled) this.isFollowUpActionEnabled = false;
        this.isQuoteCreationEnabled = !this.device.isOffline && this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.OPPORTUNITY_MANAGEMENT_QUOTES);
        this.hasSamplingEnabled = false;
        this.hasAllocationOrdersUnrestrictedEnabled = false;
        this.hasEmailActivityEnabled = false;
        this.isAccountVisitEnabled = false;
        this.hasTimeoffEnabled = false;
        this.hasCustomerInquiryEnabled = false;
        this.hasLiveMeetEnabled = false;
        this.hasPhonecallEnabled = false;
        this.hasDirectMessagingEnabled = this.layoverViewPushedFrom == 'OpportunityManagementTool' && this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.MESSAGE_ACTIVITY) ? true : false;
        this.isAccountPlanTaskEnabled = false;
        this.isMarketingPlanTaskEnabled = false;
        this.isScientificPlanTaskEnabled = false;
        this.isNoneTaskEnabled = false;
        this.hasStoreCheckEnabled = false;
        this.hasKitBookingEnabled = false;
        this.hasMedicalInquiryEnabled = false;
        this.followUpActionCategory = 'opportunitytask';
        if (this.layoverViewPushedFrom != 'OpportunityManagementTool' && this.layoverViewPushedFrom !== 'MarketingPlanInfoopportunities') {
          this.isMeetingEnabled = false;
        }
        // User is taken to Meeting Details page when there is only meeting action enabled
        if (!this.isFollowUpActionEnabled && !this.isOrderCreationEnabled && !this.isQuoteCreationEnabled && !this.hasProcedureLogEnabled) {
          this.handleNewActivity();
        }
      }
      else if (this.layoverViewPushedFrom == 'PresentationToolsPage') {
        this.hasSamplingEnabled = false;
        this.hasAllocationOrdersUnrestrictedEnabled = false;
        this.hasEmailActivityEnabled = false;
        this.isAccountVisitEnabled = false;
        this.hasTimeoffEnabled = false;
        this.hasCustomerInquiryEnabled = false;
        this.hasMedicalInquiryEnabled = false;
        this.hasLiveMeetEnabled = false;
        this.hasDirectMessagingEnabled = false;
        this.isAccountPlanTaskEnabled = false;
        this.isMarketingPlanTaskEnabled = false;
        this.isScientificPlanTaskEnabled = false;
        this.isFollowUpActionEnabled = false;
        this.isOrderCreationEnabled = false;
        this.hasStoreCheckEnabled = false;
        this.hasKitBookingEnabled = false;
      }
      else if (this.layoverViewPushedFrom == 'ContactPageComponent') {
        this.hasLiveMeetEnabled = false;
        this.isOrderCreationEnabled = false;
        this.isAccountVisitEnabled = false;
        this.hasStoreCheckEnabled = false;
        this.isConsentCreationEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CONSENT_TOOL) && !this.uiService.isConsentFromToolDrawer;
        this.hasOpportunityEnabled = this.authService.hasFeatureAction(FeatureActionsMap.OPPORTUNITY_MANAGEMENT);
        if (this.hasProcedureLogEnabled && this.uiService.activeViewNewMeeting != 'email') {
          this.uiService.setActiveViewForNewMeeting('surgeryorder');
        }
        if (this.uiService.activeViewNewMeeting == 'email') {
          const activeViewList = ["hasDirectMessagingEnabled"];
          this.enableSpecificActivityToShow(activeViewList);
          // OMNI-60698: the first-time-email draft auto-create used to live here. It was
          // moved to autoCreateFirstTimeEmailDraftIfApplicable(), invoked once from
          // ngOnInit, because resetNewActivityOptions() is also re-run on every
          // translate.onLangChange — and since OMNI-60320 each delta sync emits
          // onLangChange to apply backend label overrides, keeping the create here
          // spawned a new blank email on Dynamics on every sync. This method must stay
          // side-effect-free (option/label reset only).
        }
      }
      else if (this.layoverViewPushedFrom == 'ProcedureLogFrom') {
        this.hasSamplingEnabled = false;
        this.hasAllocationOrdersUnrestrictedEnabled = false;
        this.hasEmailActivityEnabled = false;
        this.isAccountVisitEnabled = false;
        this.hasTimeoffEnabled = false;
        this.hasCustomerInquiryEnabled = false;
        this.hasMedicalInquiryEnabled = false;
        this.hasLiveMeetEnabled = false;
        this.hasDirectMessagingEnabled = false;
        this.isAccountPlanTaskEnabled = false;
        this.isMarketingPlanTaskEnabled = false;
        this.isScientificPlanTaskEnabled = false;
        this.isFollowUpActionEnabled = false;
        this.isOrderCreationEnabled = false;
        this.hasProcedureLogEnabled = false;
        this.hasProcedureLogConfigEnabled = false;
        this.hasBulkProcedureLogConfigEnabled = false;
        this.hasPhonecallEnabled = false;
        this.hasStoreCheckEnabled = false;
        this.hasKitBookingEnabled = false;
        if (this.isMeetingEnabled) {
          this.uiService.setActiveViewForNewMeeting('meeting');
        }
      }
    }

    if (this.uiService.isConsentFromToolDrawer) {
      this.hasProcedureLogEnabled = false;
      this.hasProcedureLogConfigEnabled = false;
      this.hasBulkProcedureLogConfigEnabled = false;
      this.hasKitBookingEnabled = false;
      this.hasMedicalInquiryEnabled = false;
    }
    if ((this.navService.getCurrentMasterPageName() == PageName.CallPlanComponent ||this.navService.getCurrentMasterPageName() == PageName.CustomerCallPlanPage &&
      (this.uiService.showNewActivity || this.navService.getCurrentPageName() == PageName.NewActivityComponent)
      && this.NewActivitySource !== ActivitySource.MEETING_DETAIL)
      // OMNI-59207: when Create is launched from a call-plan-update notification, every page lives in the
      // right-pane child nav, so the global getCurrentMasterPageName() stays at its root and the gate above
      // misses the call-plan context. layoverViewPushedFrom is set to CustomerCallPlanDetails only when
      // New Activity is opened from the call-plan Create button, so it identifies that flow precisely in
      // both the in-tool and notification paths.
      || (this.layoverViewPushedFrom === PageName.CustomerCallPlanDetails && this.NewActivitySource !== ActivitySource.MEETING_DETAIL)
      || (this.uiService.activeView === 'ActivitiesPageRightPaneNav'&& this.layoverViewPushedFrom !==  'AccountManagementTool' && this.uiService.activitiesPageTab === 'plans' && this.uiService.activitiesPagePlanTabSelectedPlan == 'goalsPlansTab' && this.NewActivitySource !== ActivitySource.MEETING_DETAIL)) {
      this.hasSamplingEnabled = false;
      this.hasAllocationOrdersUnrestrictedEnabled = false;
      this.isAccountVisitEnabled = false;
      this.hasTimeoffEnabled = false;
      this.hasCustomerInquiryEnabled = false;
      this.hasLiveMeetEnabled = false;
      this.isAccountPlanTaskEnabled = false;
      this.isMarketingPlanTaskEnabled = false;
      this.isEventFollowUpActionEnabled = false;
      this.isScientificPlanTaskEnabled = false;
      this.isFollowUpActionEnabled = false;
      this.isOrderCreationEnabled = false;
      this.hasProcedureLogEnabled = false;
      this.hasProcedureLogConfigEnabled = false;
      this.hasBulkProcedureLogConfigEnabled = false;
      this.hasStoreCheckEnabled = false;
      this.hasKitBookingEnabled = false;
      this.hasMedicalInquiryEnabled = false;
      if (this.isMeetingEnabled) {
        this.uiService.setActiveViewForNewMeeting('meeting');
      }
    }
    if (this.NewActivitySource === ActivitySource.MEETING_PRESENTATION) {
      this.isMeetingEnabled = false;
      this.isAccountVisitEnabled = false;
      this.hasTimeoffEnabled = false;
      this.hasLiveMeetEnabled = false;
      this.isAccountPlanTaskEnabled = false;
      this.isMarketingPlanTaskEnabled = false;
      this.isEventFollowUpActionEnabled = false;
      this.isScientificPlanTaskEnabled = false;
      this.isOpportunityTaskEnabled = false;
      this.isNoneTaskEnabled = false;
      this.isMeetingTaskEnabled = true;
      this.followUpActionCategory = 'meetingtask';
      this.isOrderCreationEnabled = false;
      this.hasPhonecallEnabled = false;
      this.hasStoreCheckEnabled = false;
      this.hasKitBookingEnabled = false;
      if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CONSENT_TOOL)) {
        this.isConsentCreationEnabled = true;
      }
      if (this.authService.hasFeatureAction(FeatureActionsMap.CUSTOMER_SURVEY) || this.authService.hasFeatureAction(FeatureActionsMap.ACCOUNT_SURVEY)) {
        this.customerSurveyService.selectedContactFromContactTool = this.contactService.contactInformation || null;
        this.isSurveyEnabled = true;
      }
      if (this.activityOfflineService.selectedActivity instanceof AppointmentActivity &&
        this.activityOfflineService.selectedActivity.isLiveMeet) {
        this.hasCustomerInquiryEnabled = false;
        this.hasMedicalInquiryEnabled = false;
        this.hasDirectMessagingEnabled = false;
      }
    }

    if (this.NewActivitySource === ActivitySource.EVENT_DETAIL) {
      this.newActivityOptionsInEventDetails();
    } else {
      this.isEventFollowUpActionEnabled = false;
    }

    if (this.NewActivitySource === ActivitySource.MEETING_DETAIL) {
      this.newActivityOptionsInMeetingDetails();
    }
    if (this.NewActivitySource === ActivitySource.PHONE_CALL_ACTIVITY_DETAIL) {
      this.isMeetingEnabled = false;
      this.isSurveyEnabled = false;
      this.isAccountVisitEnabled = false;
      this.hasTimeoffEnabled = false;
      this.hasLiveMeetEnabled = false;
      this.isAccountPlanTaskEnabled = false;
      this.isMarketingPlanTaskEnabled = false;
      this.isEventFollowUpActionEnabled = false;
      this.isScientificPlanTaskEnabled = false;
      this.isFollowUpActionEnabled = false;
      this.isOrderCreationEnabled = false;
      this.hasXperincesEnabled = false;
      this.hasSamplingEnabled = false;
      this.hasAllocationOrdersUnrestrictedEnabled = false;
      this.hasPhonecallEnabled = false;
      this.hasProcedureLogEnabled = false;
      this.hasProcedureLogConfigEnabled = false;
      this.hasBulkProcedureLogConfigEnabled = false;
      this.hasStoreCheckEnabled = false;
      this.hasKitBookingEnabled = false;
      this.hasMedicalInquiryEnabled = false;
      if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CASE_INTAKE)) {
        this.hasCustomerInquiryEnabled = true;
      }
      if (this.hasDirectMessagingEnabled) {
        this.uiService.setActiveViewForNewMeeting('email');
        this.trackingService.tracking('Select Message', TrackingEventNames.PHONECALL);
      }
      else if (this.hasCustomerInquiryEnabled) {
        this.uiService.setActiveViewForNewMeeting('customerinquiry');
        this.trackingService.tracking('Select inquiry', TrackingEventNames.PHONECALL);
      }
    }
    if (this.NewActivitySource === ActivitySource.SET_BOOKING_ACTIVITY_DETAIL) {
      this.isMeetingEnabled = true;
      this.uiService.setActiveViewForNewMeeting('meeting');
      if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CASE_INTAKE)) {
        this.hasCustomerInquiryEnabled = true;
      }
      this.isSurveyEnabled = false;
      this.isAccountVisitEnabled = false;
      this.hasTimeoffEnabled = false;
      this.hasLiveMeetEnabled = false;
      this.isAccountPlanTaskEnabled = false;
      this.isMarketingPlanTaskEnabled = false;
      this.isEventFollowUpActionEnabled = false;
      this.isScientificPlanTaskEnabled = false;
      this.isFollowUpActionEnabled = false;
      this.isOrderCreationEnabled = false;
      this.hasXperincesEnabled = false;
      this.hasSamplingEnabled = false;
      this.hasAllocationOrdersUnrestrictedEnabled = false;
      this.hasPhonecallEnabled = false;
      this.hasProcedureLogEnabled = false;
      this.hasProcedureLogConfigEnabled = false;
      this.hasBulkProcedureLogConfigEnabled = false;
      this.hasStoreCheckEnabled = false;
      this.hasKitBookingEnabled = false;
      this.hasMedicalInquiryEnabled = false;
      this.hasDirectMessagingEnabled = false;
    }

    if (this.NewActivitySource === ActivitySource.CUSTOMER_INQUIRY_TOOL) {
      // Disable all other features when coming from Customer Inquiry Tool
      this.isMeetingEnabled = false;
      this.isAccountVisitEnabled = false;
      this.hasTimeoffEnabled = false;
      this.hasLiveMeetEnabled = false;
      this.isAccountPlanTaskEnabled = false;
      this.isMarketingPlanTaskEnabled = false;
      this.isEventFollowUpActionEnabled = false;
      this.isScientificPlanTaskEnabled = false;
      this.isOpportunityTaskEnabled = false;
      this.isNoneTaskEnabled = false;
      this.isMeetingTaskEnabled = false;
      this.isFollowUpActionEnabled = false;
      this.isOrderCreationEnabled = false;
      this.isQuoteCreationEnabled = false;
      this.isConsentCreationEnabled = false;
      this.hasPhonecallEnabled = false;
      this.hasStoreCheckEnabled = false;
      this.hasKitBookingEnabled = false;
      this.hasMedicalInquiryEnabled = false;
      this.hasProcedureLogEnabled = false;
      this.hasProcedureLogConfigEnabled = false;
      this.hasBulkProcedureLogConfigEnabled = false;
      this.hasXperincesEnabled = false;
      this.hasSamplingEnabled = false;
      this.hasAllocationOrdersUnrestrictedEnabled = false;
      this.hasDirectMessagingEnabled = false;
      this.isSurveyEnabled = false;
      this.hasOpportunityEnabled = false;
      // Enable only customer inquiry
      if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CASE_INTAKE)) {
        this.hasCustomerInquiryEnabled = true;
        this.uiService.setActiveViewForNewMeeting('customerinquiry');
      }
    }

    if(this.featureActionService.isShortCallLauncherEnabledInMobileDevice && this.authService.hasFeatureAction(FeatureActionsMap.SHOR_CALL_LAUNCHER_DISABLE_APPOINTMENT_IN_NEW_ACTIVITY)) {
      this.setActiveViewForNewMeeting();
      this.isMeetingEnabled = this.isAccountVisitEnabled = false;
    }
    this.procedureLogConfigList = [];
    if (this.hasProcedureLogConfigEnabled) {
      this.procedureLogConfigList.push({ label: this.translate.instant('PROCEDURE_DAY'), value: 'procedureDay' });
      if (!this.authService.user.buSettings || !this.authService.user.buSettings['indskr_noprocedureday']) {
        this.procedureLogConfigList.push({ label: this.translate.instant('NO_PROCEDURE_DAY'), value: 'noProcedureDay' });
      }
    }
    if (this.hasBulkProcedureLogConfigEnabled) {
      this.procedureLogConfigList.push({ label: this.translate.instant('BULK_PROCEDURE_LOG'), value: 'procedure_tracker' });
    }
    this.meetingActivityTypes = this.activityOfflineService.configuredActivityTypes(MeetingActivityTypeCode.MEETING, FormatType.HCP_MEETING) || [];
    this.selectedMeetingActivityType = this.getDefaultMeetingActivityType(this.meetingActivityTypes);
    this.selectedMessagingChannelType = this.filteredChannelList?.length > 0 ? this.filteredChannelList[0] : null;
    this.procedureCategory = this.procedureLogConfigList?.length > 0 ? this.procedureLogConfigList[0].value : null;
    this.type = this.caseManagementService.caseTypeList?.length > 0 ? this.caseManagementService.caseTypeList[0] : null;
  }

  /**
   * OMNI-60698: Auto-creates the first-time-email Draft exactly once, during initial
   * screen setup (called from ngOnInit right after resetNewActivityOptions()).
   *
   * This logic previously lived inside resetNewActivityOptions(), but that method is
   * also re-run on every translate.onLangChange. Since OMNI-60320, each delta sync
   * emits onLangChange to apply backend label overrides in place — so the auto-create
   * was firing on every sync, POSTing a brand-new blank first-time email to Dynamics
   * each time (root cause of OMNI-60698). Keeping the side effect out of the
   * onLangChange path means resetNewActivityOptions() stays idempotent, as an
   * onLangChange handler must be.
   */
  private async autoCreateFirstTimeEmailDraftIfApplicable(): Promise<void> {
    if (this.layoverViewPushedFrom !== 'ContactPageComponent') return;
    if (this.uiService.activeViewNewMeeting !== 'email') return;
    if (!this.isSkipConsentForFirstTimeEmailFlow) return;
    const channels = await this.directMessagingService.channelList.pipe(map(channels => channels.map(channel => (channel))), first()).toPromise();
    const emailChannelList = channels.filter(c => c.activityType === ChannelActivityType.EMAIL) || [];
    if (isEmpty(emailChannelList)) return;
    if (emailChannelList.length == 1) {
      this.selectedMessagingChannelType = emailChannelList[0];
      this.handleNewActivity();
    } else {
      const sortedChannels = emailChannelList.sort((a, b) => a.title.localeCompare(b.title));
      this.filteredChannelList = [...sortedChannels];
    }
  }

  private setActiveViewForNewMeeting() {
    if (this.hasTimeoffEnabled) {
      this.uiService.setActiveViewForNewMeeting('timeoff');
    } else if (this.hasSamplingEnabled && !this.noEligibleAllocation) {
      this.uiService.setActiveViewForNewMeeting('allocation');
    } else if (this.hasDirectMessagingEnabled) {
      this.uiService.setActiveViewForNewMeeting('email');
    } else if (this.isFollowUpActionEnabled) {
      this.uiService.setActiveViewForNewMeeting('follow-up-action');
    } else if (this.isOrderCreationEnabled) {
      this.uiService.setActiveViewForNewMeeting('order');
    } else if (this.hasPhonecallEnabled && !this.noPhoneNumber) {
      this.uiService.setActiveViewForNewMeeting('phonecall');
    } else if (this.hasProcedureLogEnabled) {
      this.uiService.setActiveViewForNewMeeting('surgeryorder');
    } else if (this.hasOpportunityEnabled) {
      this.uiService.setActiveViewForNewMeeting('opportunity');
    } else if (this.isSurveyEnabled) {
      this.uiService.setActiveViewForNewMeeting('survey');
    } else if (this.hasStoreCheckEnabled && !this.device.isOffline) {
      this.uiService.setActiveViewForNewMeeting('storecheck');
    } else if (this.hasMedicalInquiryEnabled) {
      this.uiService.setActiveViewForNewMeeting('medicalinquiry');
    }
  }

  private newActivityOptionsInMeetingDetails() {
    this.isMeetingEnabled = false;
    this.isAccountVisitEnabled = false;
    this.hasTimeoffEnabled = false;
    this.hasLiveMeetEnabled = false;
    this.isAccountPlanTaskEnabled = false;
    this.isMarketingPlanTaskEnabled = false;
    this.isEventFollowUpActionEnabled = false;
    this.isScientificPlanTaskEnabled = false;
    this.isOpportunityTaskEnabled = false;
    this.isNoneTaskEnabled = false;
    this.isMeetingTaskEnabled = true;
    this.followUpActionCategory = 'meetingtask';
    this.isOrderCreationEnabled = false;
    this.hasXperincesEnabled = false;
    this.hasPhonecallEnabled = false;
    this.hasStoreCheckEnabled = false;
    this.hasKitBookingEnabled = false;
    this.isConsentCreationEnabled = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.CONSENT_TOOL);
    if (this.hasDirectMessagingEnabled) {
      this.uiService.setActiveViewForNewMeeting('email');
    }
    else if (this.hasCustomerInquiryEnabled) {
      this.uiService.setActiveViewForNewMeeting('customerinquiry');
    }
    else if (this.hasMedicalInquiryEnabled) {
      this.uiService.setActiveViewForNewMeeting('medicalinquiry');
    }
    else if (this.hasProcedureLogEnabled) {
      this.uiService.setActiveViewForNewMeeting('surgeryorder');
    }
    else if (this.isFollowUpActionEnabled){
      this.uiService.setActiveViewForNewMeeting('follow-up-action');
    }

    if (this.authService.hasFeatureAction(FeatureActionsMap.CUSTOMER_SURVEY) || this.authService.hasFeatureAction(FeatureActionsMap.ACCOUNT_SURVEY)) {
      this.isSurveyEnabled = true;
      this.customerSurveyService.selectedContactFromContactTool = this.contactService.contactInformation || null;
    }

    // User is taken to Activity selection page when there is only one activity
    if ((this.hasSamplingEnabled || this.hasProcedureLogEnabled) && !this.hasDirectMessagingEnabled && !this.hasCustomerInquiryEnabled && !this.isFollowUpActionEnabled) {
      this.handleNewActivity();
    }
    // If there is only one channel/case in the Message/Customer inquiry, it will be selected automatically
    if (this.hasDirectMessagingEnabled) {
      this.checkNumOfChannelList();
    }
    if (this.hasCustomerInquiryEnabled) {
      this.checkNumOfCaseList();
    }
  }
  private newActivityOptionsInEventDetails() {
    this.isMeetingEnabled = false;
    this.isAccountVisitEnabled = false;
    this.hasTimeoffEnabled = false;
    this.hasLiveMeetEnabled = false;
    this.isAccountPlanTaskEnabled = false;
    this.isMarketingPlanTaskEnabled = false;
    this.isScientificPlanTaskEnabled = false;
    this.isOpportunityTaskEnabled = false;
    this.isNoneTaskEnabled = false;
    this.isMeetingTaskEnabled = false;
    this.isOrderCreationEnabled = false;
    this.hasXperincesEnabled = false;
    this.hasPhonecallEnabled = false;
    this.isSurveyEnabled = false;
    this.hasProcedureLogEnabled = false;
    this.hasProcedureLogConfigEnabled = false;
    this.hasBulkProcedureLogConfigEnabled = false;
    this.hasCustomerInquiryEnabled = false;
    this.hasMedicalInquiryEnabled = false;
    this.hasDirectMessagingEnabled = false;
    this.hasStoreCheckEnabled = false;
    this.hasKitBookingEnabled = false;
    this.followUpActionCategory = 'eventtask';
    if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.ALLOCATION_TOOL)) {
      this.uiService.setActiveViewForNewMeeting('allocation');
      this.hasSamplingEnabled = true;
    } else if (this.isFollowUpActionEnabled && this.isEventFollowUpActionEnabled) {
      this.uiService.setActiveViewForNewMeeting('follow-up-action');
    }
  }

  checkNumOfChannelList() {
    if (!isEmpty(this.filteredChannelList)) {
      if (this.filteredChannelList.length === 1) {
        this.selectMessagingType(this.filteredChannelList[0]);
      }
    } else {
      const channelList = this.directMessagingService.channelList.pipe(map(channels => channels.map(channel => (channel))), first()).toPromise();
      if (size(channelList) == 1) {
        this.selectMessagingType(channelList[0]);
      }
    }
  }

  checkNumOfCaseList() {
    const caseList = this.caseManagementService.caseTypeList;
    if (caseList.length === 1) {
      this.selectCaseManagementType(caseList[0]);
    }
  }

  private onClose(isSuccess: boolean, isDestroyed: boolean = false) {
    this.callbackEvent?.(isSuccess, isDestroyed);
    this.callbackEvent = null;
  }


  ngOnDestroy() {
    this.onClose(false, true);
    this.dateTimeFormatsService.isNewActivity = false;
    this.events.unsubscribe('updatedCellClick', this.setCellData);
    this.updateCellClicked = false;
    this.events.unsubscribe('updatedCellClick', this._updateCellClick);
    if (this._updateDayClick) this.events.unsubscribe('updatedDayClick', this._updateDayClick);
    this.events.unsubscribe('updateCurrentDate', this._updateCurrentDate);
    this.events.unsubscribe('updateNewTimeOffDateTime');
    this.eventService.unsubscribe('remote_meeting_participant_Joined_left', this.handleContactConnectionLost);
    this.IcurrentMeetingActivitySubscription.unsubscribe();
    if (this.ItranslatedCustomerTextSubscription) this.ItranslatedCustomerTextSubscription.unsubscribe();
    this.ngDestroy$.next(true);
    this.ngDestroy$.complete();
    this.dateFormatSubscription.unsubscribe();
    this.timeFormatSubscription.unsubscribe();
  }

  ionViewWillEnter() {
    this._orientationHandler = (modeChange: VIEW_MODE_CHANGE, curPageName: PageName, curMasterPageName: PageName) => {
      if (curPageName == PageName.OrderAddQuantityComponent) return;
      if (!this.uiService.showNewActivity) this.uiService.showNewActivity = true;

      /**
       * Slowly move to CSS instead of ionic navigation
       */
      if (curMasterPageName === PageName.GoAppActivitiesPageComponent) {
        if (modeChange === VIEW_MODE_CHANGE['mobile-to-normal']) {
          this.uiService.showRightPane = false;
        }
      } else if (curMasterPageName === PageName.CallPlanComponent) {
        if (modeChange === VIEW_MODE_CHANGE['mobile-to-normal']) {
          this.navService.popWithPageTracking();
        }
      } else if (curMasterPageName === PageName.ContactPageComponent) {
        if (modeChange === VIEW_MODE_CHANGE['mobile-to-normal']) {
          this.navService.popWithPageTracking();
        }
      }
    };
    this.events.subscribe('device:view-mode-change', this._orientationHandler);
  }

  ionViewDidEnter() {
    this.initHeaderOnOptionSelection();
  }

  ionViewWillLeave() {
    if (this._orientationHandler) {
      this.events.unsubscribe('device:view-mode-change', this._orientationHandler);
    }
  }

  public initNewActivityScreenFormFields(): void {
    this.isMeetingPresentation = (this.activityOfflineService.activitySource === ActivitySource.MEETING_PRESENTATION) ? true : false;
    this.newActivityHeader = {
      id: 'new-activity-details-header',
      title: (<String>this.translate.instant('MEETING_ACTIVITIES')).toUpperCase(),
      controls: [],
    };
    if (this.activityOfflineService.activitySource === ActivitySource.MEETING_PRESENTATION) {
      this.newActivityHeader.controls.push({
        id: 'close',
        icon: 'chevron-back-outline',
        isDisabled: false,
        align: 'left'
      });
    }
  }
  private initNewActivityPagetitle(): void {
    if (this.activityOfflineService.activitySource === ActivitySource.MEETING_DETAIL ||
      this.activityOfflineService.activitySource === ActivitySource.MEETING_PRESENTATION
    ) {
      this.newActivityTitle = this.translate.instant('MEETING_ACTIVITIES');
    }
    if (this.activityOfflineService.activitySource === ActivitySource.EVENT_DETAIL) {
      this.newActivityTitle = this.translate.instant('EVENT_ACTIVITIES');
    }
    if (this.activityOfflineService.activitySource === ActivitySource.PHONE_CALL_ACTIVITY_DETAIL) {
      this.newActivityTitle = this.translate.instant('CALL_ACTIVITIES');
    }
    if (this.activityOfflineService.activitySource === ActivitySource.SET_BOOKING_ACTIVITY_DETAIL) {
      this.newActivityTitle = this.translate.instant('KIT_BOOKING_ACTIVITIES');
    }

    this.newActivityPageTitle = {
      id: "new-activity-page-title",
      title: this.translate.instant(this.newActivityTitle) + " " + this.forContactName,
      displayDefaultBackButton: true,
      controls: []
    }
  }

  public onPageTitleControlClick(id: string) {
    switch (id) {
      case 'close':
        this.cancelNewActivity();
        this.onClose(false);
        break;
      case 'new_activity_cancel_button':
        this.cancelNewActivity();
        break;
      case 'new_activity_confirm_button':
        if (this.isConfirmEnabled && this.checkCustomValidation()) {
          this.handleNewActivity();
        }
        break;
      default:
        break;
    }
  }

  private checkCustomValidation(): boolean {
    let flag = true;
    if (this.uiService.activeViewNewMeeting == 'surgeryorder' && this.procedureCategory == 'noProcedureDay') {
      if (this.NewActivitySource === ActivitySource.MEETING_PRESENTATION || this.activityOfflineService.activitySource === ActivitySource.MEETING_DETAIL && this.activityOfflineService.selectedActivity) {
        if (this.dateTimeFormatsService.isFutureDate((this.activityOfflineService.selectedActivity as AppointmentActivity).scheduledStart.getTime())
          && !this.dateTimeFormatsService.isTodayDate((this.activityOfflineService.selectedActivity as AppointmentActivity).scheduledStart.getTime()) && this.procedureCategory == 'noProcedureDay') {
          this.notificationService.notify(this.translate.instant('SHEDULE_PROCEDURE_LOG_FUTURE'), 'New Activity', 'top', ToastStyle.DANGER);
          flag = false;
          return flag;
        }
      }
    }
    return flag;
  }

  ngDoCheck() {
  }

  private initHeaderOnOptionSelection() {
    let prevConfirmEnabledFlag = this.isConfirmEnabled;
    this.isConfirmEnabled = true;
    switch (this.uiService.activeViewNewMeeting) {
      case 'email':
        if (!this.selectedMessagingChannelType) {
          this.isConfirmEnabled = false;
        }
        break;
      case 'meeting':
        if (this.uiService.activeViewNewMeetingType === 'live' && !this.selectedEvent) {
          this.isConfirmEnabled = false;
        }
        break;
      case 'customerinquiry':
        if (!this.type) {
          this.isConfirmEnabled = false;
        }
        break;
      case 'follow-up-action':
        this.isConfirmEnabled = this.followUpActionCategory ? true : false;
        break;
      case 'new-insight':
        this.isConfirmEnabled = this.NewActivitySource === ActivitySource.AGENDA && !this.selectedInsightType ? false : true;
        break;
      case 'surgeryorder':
        this.isConfirmEnabled = this.procedureCategory ? true : false;
        if (this.device.isOffline && this.procedureCategory == 'procedure_tracker') this.isConfirmEnabled = false;
        break;
      case 'consent':
        if (!this.selectedConsentCustomer) {
          this.isConfirmEnabled = false;
        }
        break;
    }
    if (this.isConfirmEnabled != prevConfirmEnabledFlag) {
      if (this.activityOfflineService.activitySource === ActivitySource.MEETING_PRESENTATION) {
        this.initNewActivityScreenFormFields();
      } else {
        this.initNewActivityPagetitle();
      }
      this._cd.markForCheck();
    }
  }

  private _handleCallPlanNavigation() {
    const curMasterPageName = this.navService.getCurrentMasterPageName();
    if (curMasterPageName != PageName.CallPlanComponent) {
      return;
    }
  
    this.uiService.showNewActivity = false;
    
    if (this.NewActivitySource === ActivitySource.MEETING_DETAIL) {
      this.callPlanService.callPlanPageView = 'CallPlanNewMeetingDetails';
      this.navService.popChildNavPageWithPageTracking();
      this.uiService.activeView = 'Appointment';
    } else if (this.NewActivitySource === ActivitySource.PHONE_CALL_ACTIVITY_DETAIL) {
      this.callPlanService.callPlanPageView = 'CallPlanPhoneCallDetails';
      this.navService.popChildNavPageWithPageTracking();
      this.uiService.activeView = 'phoneCallTimelineDetails';
    } else {
      this.callPlanService.callPlanPageView = 'CallPlanDetail';
      this.navService.popChildNavPageWithPageTracking();
      this.uiService.activeView = 'CallPlanDetails';
    }
  }
  
  private _handleActivitySourceNavigation() {
    const curMasterPageName = this.navService.getCurrentMasterPageName();
    
    if (this.NewActivitySource === ActivitySource.MEETING_DETAIL) {
      if (curMasterPageName === PageName.ContactPageComponent) {
        this.uiService.activeView = 'ContactPageRightPaneNav';
      } else {
        this.uiService.activeView = 'ActivitiesPageRightPaneNav';
      }
      this.footerService.initButtons(FooterViews.Activities);
      this.activityOfflineService.activitySource = null;
    } else if (this.NewActivitySource === ActivitySource.PHONE_CALL_ACTIVITY_DETAIL) {
      if (curMasterPageName === PageName.ContactPageComponent) {
        this.uiService.activeView = 'phoneCallTimelineDetails';
      } else {
        this.uiService.activeView = 'PhoneCall';
      }
      this.footerService.initButtons(FooterViews.PHONE_CALL);
      this.activityOfflineService.activitySource = null;
    } else if (this.navService.getActiveChildNavViewPageName() === PageName.NewActivityComponent) {
      this.navService.popChildNavPageWithPageTracking();
    }
  }
  
  private _handleSetBookingPolling() {
    if (this.layoverViewPushedFrom !== PageName.SetBookingActivityDetailsComponent || !this.setBooking) {
      return;
    }
  
    const setBooking = this.setBooking as SetBookingActivity;
    if (setBooking && setBooking.ID && 
        (setBooking.indskr_status === SetBookingStatus.PENDINGSYNC || 
         setBooking.indskr_status === SetBookingStatus.PENDINGCANCEL)) {
      this.setBookingDataService.startPollingForKitBookingStatus(setBooking);
    }
  }

  cancelNewActivity = () => {
    // Handle phone call tracking
    if (this.uiService.activeViewNewMeeting == 'phonecall' ||
        this.activityOfflineService.activitySource === ActivitySource.PHONE_CALL_ACTIVITY_DETAIL) {
      this.trackingService.tracking('Select Cancel', TrackingEventNames.PHONECALL);
    }
    
    // Handle layover push view
    if (this.isLayoverPushView && this.layoverViewPushedFrom) {
      this.activityOfflineService.activitySource = null;
      this.navService.popChildNavPageWithPageTracking();
      this._handleSetBookingPolling();
    }

    if (this.NewActivitySource === ActivitySource.CUSTOMER_INQUIRY_TOOL) {
      this.caseManagementService.showNewCase = false;
    }
    
    // Handle meeting presentation
    if (this.NewActivitySource === ActivitySource.MEETING_PRESENTATION) {
      if ((!this.selectedMeetingActivity) || (this.selectedMeetingActivity && this.selectedMeetingActivity.type === EmbeddedInteractionType.Content)) {
        this.footerService.initButtons(FooterViews.PreviewMeeting);
      }
      this.presentationService.showNewActivity = false;
      this.navService.popChildNavPageWithPageTracking();
    }
    
    // Common cleanup
    this.uiService.showNewActivity = false;
    this.onCancelNewActivity.emit();
    this.uiService.setCellData = null;
    
    const curPage = this.navService.getCurrentPageName();
    const curMasterPageName = this.navService.getCurrentMasterPageName();
    
    // Handle current page navigation
   this.handleCurrentPageNavigation();
  
    // Handle mobile view
    if (this.device.shouldBeMobileView && 
        (this.NewActivitySource !== ActivitySource.MEETING_DETAIL) && 
        this.NewActivitySource !== ActivitySource.PHONE_CALL_ACTIVITY_DETAIL && 
        this.NewActivitySource !== ActivitySource.MEETING_PRESENTATION &&
        this.uiService.activitiesPageTab !== 'plans') {
      this.uiService.showRightPane = false;
    }
  };

  private handleCurrentPageNavigation() {
    const curPage = this.navService.getCurrentPageName();
    const curMasterPageName = this.navService.getCurrentMasterPageName();

    if (curPage === PageName.NewActivityComponent) {
      this.navService.popWithPageTracking();
    } else if (curMasterPageName == PageName.CallPlanComponent) {
      this._handleCallPlanNavigation();
    } else if (curMasterPageName == PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPageTab == 'plans') {
      this.uiService.activeView = 'ActivitiesPageRightPaneNav';
      this.uiService.showRightPane = true;
      if (this.navService.getActiveChildNavViewPageName() == PageName.NewActivityComponent) {
        this.navService.popChildNavPageWithPageTracking();
      }
    } else {
      this._handleActivitySourceNavigation();
    }
  }

  /**
   *
   *
   * @private
   * @memberof NewActivityComponent
   */
  public async handleNewActivity() {
    if (this.activityCreationInProgress) return;
    this._startActivityCreation();
    try {
    switch (this.uiService.activeViewNewMeeting) {
      case 'MeetingPresentation':
        this.uiService.prevView = this.uiService.activeView;
        this.uiService.activeView = 'Presentation';
        this.presentationService.viewMode = PresentationView.ADDTOMEETING;
        this.pushWithPageTracking(PageName.PresentationPageComponent, PageName.PresentationPageComponent, { __fullscreen: true });
        this.uiService.showNewActivity = false;
        break;

      case 'meeting':
        if (this.agendaFooterService.actSegment === 'week') {
          this.trackingService.tracking('CalendarNewActivity', TrackingEventNames.ACTIVITY);
        }
        else {
          this.trackingService.tracking('AgendaMeetingCreated', TrackingEventNames.ACTIVITY)
        }
        // Refresh a stale (idle) start to prevent ERR_IO_ME12, never a tapped calendar slot (cellData)
        if (isPast(new Date(this.startTime)) && !this.cellData) {
          const duration = this.authService.user?.meeting_duration || this._getActivityDuration();
          this.startTime = format(new Date());
          this.endTime = format(addMinutes(new Date(), duration));
        }
        if (!this.activityOfflineService.validateMeetingDate(this.startTime)) {
          return;
        }
        let x = await this.createNewMeeting(this.uiService.activeViewNewMeetingType);
        // update the Plan tab
        if (this.agendaFooterService.actSegment === 'agenda' && this.agendaFooterService.planTabSegment === 'planTabTodo') {
          if (this.activityOfflineService.selectedActivity && this.activityOfflineService.selectedActivity.status !== 3 && this.activityOfflineService.selectedActivity.status !== 4) {
            this.events.publish('aciviiyCreatedRefreshTODO', this.activityOfflineService.selectedActivity);
          }
        }
        if (this.isLayoverPushView && this.layoverViewPushedFrom) {
          try {
            let skipPopAndPushChildPage = false;
            if (this.navService.getActiveChildNavViewPageName() == PageName.ActivitiesDetailsPaneComponent) {
              // Nested conditions are generally avoided, but this is required to prevent popping and pushing the child page
              // for the Customer Call Plan Details page. If other pages encounter the same issue(OMNI-57653), 
              // check only the active child navigation view page name and remove this condition or add other pages here.
              if (this.layoverViewPushedFrom == PageName.CustomerCallPlanDetails) {
                skipPopAndPushChildPage = true;
              }
            }
            this.uiService.showCancelDoneOnActivityDetails = true;

            if (!skipPopAndPushChildPage) {
              this.navService.popChildNavPageWithPageTracking();
              if (this.layoverViewPushedFrom == 'AccountManagementTool') {
                this.pushChildNavPageWithPageTracking(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.AccountManagementPageComponent, { from: 'AccountManagementTool', isNewlyCreatedActivity: true });
                return;
              } else if (this.layoverViewPushedFrom == 'AccountTool') {
                this.pushChildNavPageWithPageTracking(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.AccountPageComponent, { from: 'AccountTool', isNewlyCreatedActivity: true });
              } else if (this.layoverViewPushedFrom == 'OpportunityManagementTool') {
                this.pushChildNavPageWithPageTracking(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.AccountPageComponent, { from: 'OpportunityManagementTool', isNewlyCreatedActivity: true });
              } else if (this.layoverViewPushedFrom == 'ScientificActivityPage') {
                this.pushChildNavPageWithPageTracking(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.ScientificActivityPage, { from: 'ScientificActivityPage', isNewlyCreatedActivity: true });
              } else if (this.layoverViewPushedFrom == 'PresentationToolsPage') {
                this.pushChildNavPageWithPageTracking(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.PresentationPageComponent, { from: 'PresentationToolsPage', isNewlyCreatedActivity: true });
              } else if (this.layoverViewPushedFrom === 'ContactPageComponent') {
                this.pushChildNavPageWithPageTracking(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.ContactPageComponent, { from: this.layoverViewPushedFrom, isNewlyCreatedActivity: true });
              }
              else if (this.layoverViewPushedFrom == 'ProcedureLogFrom') {
                this.pushChildNavPageWithPageTracking(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.SurveyPageComponent, { from: 'ProcedureLogFrom', isNewlyCreatedActivity: true });
              }
              else if(this.layoverViewPushedFrom == 'MarketingPlanInfoopportunities'){
                this.pushChildNavPageWithPageTracking(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.AccountPageComponent, { from: 'marketingPlanTool', isNewlyCreatedActivity: true });
                return;
              } else if (this.layoverViewPushedFrom == PageName.SetBookingActivityDetailsComponent) {
                this.pushChildNavPageWithPageTracking(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.SetBookingActivityDetailsComponent, { from: this.layoverViewPushedFrom, isNewlyCreatedActivity: true });
                this.activityOfflineService.isNewActivityCreated = true;
                this.activityOfflineService.isLayOverPushedMeetingFromOtherActivities = true;
              } else if (this.layoverViewPushedFrom == PageName.CustomerCallPlanDetails) {
                this.pushChildNavPageWithPageTracking(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.CustomerCallPlanPage, { from: PageName.CustomerCallPlanDetails, isNewlyCreatedActivity: true });
              }
            }
          } catch (error) {
            console.error(error);
          }
        }
        else if (this.navService.getCurrentMasterPageName() == PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPageTab !== 'plans') {
          this.uiService.showCancelDoneOnActivityDetails = false;
          if(this.agendaFooterService.actSegment === 'week'){
            this.uiService.showRightPane = true;
            this.navService.setChildNavRoot(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.GoAppActivitiesPageComponent, { isNewlyCreatedActivity: true });
          }
        }
        this.activityOfflineService.isNewMeetingFlow = true;
        this.activityOfflineService.selectedActivityAtHome = this.activityOfflineService.selectedActivity;
        this.activityOfflineService.trackSelectedActivityId = this.activityOfflineService.selectedActivity?.ID || '';
        break;
      case 'accountVisit': {
        if (!this.activityOfflineService.validateMeetingDate(this.startTime)) {
          return;
        }

        // Prevent offline for account visit
        if (this.activityOfflineService.accountVisitOfflineCheck(
          {
            isAccountVisitEnabled: true,
            isAccountVisitRecord: true,
            isAccountVisitNestedMeeting: false,
          },
          true,
        )) {
          return;
        }

        await this.createNewAccountVisit();
        break;
      }
      case 'email':
        this.trackingService.tracking('EmailActivityFromNewActivity', TrackingEventNames.EMAIL, true);
        if (this.isLayoverPushView) {
          this.navService.popChildNavPageWithPageTracking();
        }
        if (this.activityOfflineService.activitySource === ActivitySource.MEETING_DETAIL ||
          this.activityOfflineService.activitySource === ActivitySource.MEETING_PRESENTATION) {
          await this.createEmailInMeeting();
        } else if (this.activityOfflineService.activitySource === ActivitySource.PHONE_CALL_ACTIVITY_DETAIL) {
          await this.createEmailInPhoneCallActivity();
        } else {
          await this.createDraftEmail();
        }
        this.activityOfflineService.selectedActivityAtHome = this.activityOfflineService.selectedActivity;
        break;

      case 'timeoff':
        if (!this.activityOfflineService.validateTimeOffDate(this.startTime)) {
          return;
        }
        await this.createNewTimeOff();
        if (this.agendaFooterService.actSegment === 'week') {
          this.trackingService.tracking('TimeOffCalendarNew', TrackingEventNames.TIMEOFF, true);
        }
        else {
          this.trackingService.tracking('AgendaTimeOffCreated', TrackingEventNames.ACTIVITY);
        }
        break;

      case 'allocation':
        if (this.isLayoverPushView && this.from != 'ContactPageComponent') {
          this.navService.popChildNavPageWithPageTracking();
        }
        if (this.activityOfflineService.activitySource === ActivitySource.MEETING_DETAIL ||
          this.activityOfflineService.activitySource === ActivitySource.MEETING_PRESENTATION) {
          this.trackingService.tracking('AllocationOrderCreatedMeetingDetails', TrackingEventNames.ALLOCATIONS)
          await this.createOrEditSampleOrderFromMeeting();
        } else {
          if (this.NewActivitySource === ActivitySource.EVENT_DETAIL) {
            await this.createOrEditSampleOrderFromEvent();
          } else {
            this.trackingService.tracking('AgendaAllocationCreated', TrackingEventNames.ACTIVITY)
            await this.createNewSampleRequest();
          }
        }
        this.activityOfflineService.selectedActivityAtHome = this.activityOfflineService.selectedActivity;
        break;

      case 'follow-up-action':
        if (
          this.followUpActionCategory == 'none'
          || this.followUpActionCategory == 'accountplantask'
          || this.followUpActionCategory == 'meetingtask'
          || this.followUpActionCategory == 'marketingplantask'
          || this.followUpActionCategory === 'eventtask'
        ) {
          let inMeetingActivity: Activity;
          await this.handleNewFollowUpActionTaskCreation().then(success => {
            if(this.followUpActionCategory == 'meetingtask' || this.followUpActionCategory === 'eventtask'){
              // Publish Activity event to add to calendar
              this.activityOfflineService.publishActivityEvent({ action: "Create", activity: this.activityOfflineService.selectedActivity });
              inMeetingActivity = this.followUpActivityDataService.inMeetingFollowupActionActivity
            }
          }).catch(error => {
            console.error(error);
          });
          if (this.NewActivitySource === ActivitySource.MEETING_PRESENTATION) {
            this.meetingStructureService.createInMeetingEmbededActivity(inMeetingActivity);
            this.handleNewActivityCreatedUpdatePlanTab(inMeetingActivity);
            this.meetingStructureService.openInMeetingActivitiesModal(inMeetingActivity, true);
          } else if (this.activityOfflineService.activitySource === ActivitySource.MEETING_DETAIL) {
            this.meetingStructureService.createInMeetingEmbededActivity(inMeetingActivity);
            this.handleNewActivityCreatedUpdatePlanTab(inMeetingActivity);
            this.meetingStructureService.openInMeetingActivitiesModal(inMeetingActivity, true);
            if (this.isLayoverPushView) {
              this.navService.popChildNavPageWithPageTracking();
            }
          } else if (
            this.NewActivitySource === ActivitySource.EVENT_DETAIL
            || this.activityOfflineService.activitySource === ActivitySource.EVENT_DETAIL
          ) {
            this.meetingStructureService.createInMeetingEmbededActivity(inMeetingActivity);
            this.handleNewActivityCreatedUpdatePlanTab(inMeetingActivity);
            this.meetingStructureService.openInMeetingActivitiesModal(inMeetingActivity, true);
            if (this.isLayoverPushView) {
              this.navService.popChildNavPageWithPageTracking();
            }
          }
          this.activityOfflineService.selectedActivityAtHome = this.activityOfflineService.selectedActivity;
          const targetActivity = inMeetingActivity || this.activityOfflineService.selectedActivity;
          this.activityOfflineService.publishActivityEvent({ action: "Create", activity: targetActivity });
          return;
        } else if (this.followUpActionCategory == 'scientificplantask') {
          await this.handleNewSAPFollowUpAction().catch(error => {
            console.error(error);
          });
        } else if (this.followUpActionCategory == 'opportunitytask') {
          await this.handleNewFollowUpActionTaskCreation().catch(error => {
            console.error(error);
          });
        } else {
          this.notificationService.notify(this.translate.instant('NEW_ACTIVITY_TOAST_SELECT_FOLLOW_UP'), 'New Activity');
        }
        if (this.agendaFooterService.actSegment === 'agenda' && this.agendaFooterService.planTabSegment === 'planTabTodo') {
          if (this.activityOfflineService.selectedActivity) {
            this.events.publish('aciviiyCreatedRefreshTODO', this.activityOfflineService.selectedActivity);
          }
        }
        this.activityOfflineService.selectedActivityAtHome = this.activityOfflineService.selectedActivity;
        this.activityOfflineService.publishActivityEvent({ action: "Create", activity: this.activityOfflineService.selectedActivity });
        return;
      case 'order':
        await this.handleNewOrderCreation().then(success => {
          this.activityOfflineService.publishActivityEvent({ action: "Create", activity: this.activityOfflineService.selectedActivity });
        }).catch(error => {
          console.error(error);
          //Handle error in new follow up creation for UI
        });
        this.activityOfflineService.selectedActivityAtHome = this.activityOfflineService.selectedActivity;
        return;
      case 'surgeryorder':
        {
          let procedureError = false;
          let inMeetingActivity: Activity;
          if (this.procedureCategory == 'procedure_tracker') {
            if (this.device.isOffline) {
              return;
            }
            await this.handleNewProcedureTrackerCreation().then(success => {
              this.activityOfflineService.publishActivityEvent({ action: "Create", activity: this.activityOfflineService.selectedActivity });
              inMeetingActivity = this.procedureTrackerActivityDataService.inMeetingProcedureTrackerActivity;
            }).catch(error => {
              procedureError = true;
            });
            if (procedureError) return;
          } else {
            await this.handleNewSurgeryOrderCreation().then(success => {
              this.activityOfflineService.publishActivityEvent({ action: "Create", activity: this.activityOfflineService.selectedActivity });
              inMeetingActivity = this.surgeryOrderActivityDataService.inMeetingSurgeryOrderActivity
            }).catch(error => {
              console.error(error);
            });
          }


          if (this.NewActivitySource === ActivitySource.MEETING_PRESENTATION) {
            this.meetingStructureService.createInMeetingEmbededActivity(inMeetingActivity);
            this.handleNewActivityCreatedUpdatePlanTab(inMeetingActivity);
            this.meetingStructureService.openInMeetingActivitiesModal(inMeetingActivity, true);
          } else if (this.activityOfflineService.activitySource === ActivitySource.MEETING_DETAIL) {
            this.meetingStructureService.createInMeetingEmbededActivity(inMeetingActivity);
            this.handleNewActivityCreatedUpdatePlanTab(inMeetingActivity);
            this.meetingStructureService.openInMeetingActivitiesModal(inMeetingActivity, true);
            if (this.isLayoverPushView) {
              this.navService.popChildNavPageWithPageTracking();
            }
          }
          return;
        }
      case 'quote':
        {
          await this.handleNewQuoteCreation().then(success => {
            this.activityOfflineService.publishActivityEvent({ action: "Create", activity: this.activityOfflineService.selectedActivity });
          });
          return;
        }
      case 'consent':
        {
          try {
            await this.handleNewConsentCreation()
          }
          finally {
          }
          return;
        }
      case 'new-insight':
        this.uiService.showNewActivity = false;
        if (this.NewActivitySource == ActivitySource.AGENDA) {
          this.navService.setChildNavRoot(PageName.NothingSelectedView, PageName.NothingSelectedView, PageName.GoAppActivitiesPageComponent);
          this.uiService.activeView = 'ActivitiesPageRightPaneNav';
          this.activityOfflineService.selectedActivity = null;
          this.activityOfflineService.selectedActivityAtHome = null;
          this.uiService.showRightPane = true;
          if (this.selectedInsightType === INSIGHT_TYPE.CUSTOMER_INSIGHT) {
            this.xperiencesService.newInsight = new TrendingCustomer();
            this.pushChildNavPageWithPageTracking(PageName.CustomerInsightComponent, PageName.CustomerInsightComponent, PageName.GoAppActivitiesPageComponent, { from: PageName.GoAppActivitiesPageComponent });
          } else {
            this.xperiencesService.generalInsight = null;
            this.pushChildNavPageWithPageTracking(PageName.GeneralInsightsPlusComponent, PageName.GeneralInsightsPlusComponent, PageName.GoAppActivitiesPageComponent, { from: PageName.GoAppActivitiesPageComponent });
          }
        } else if (this.layoverViewPushedFrom === 'ContactPageComponent') {
          this.navService.popChildNavPageWithPageTracking();
          let newInsight: TrendingCustomer = new TrendingCustomer();
          this.xperiencesService.newInsight = newInsight;
          this.uiService.activeView = 'ContactPageRightPaneNav';
          newInsight.contactid = this.contactService.contactInformation.ID;
          newInsight.fullname = this.contactService.contactInformation.fullname;
          this.pushChildNavPageWithPageTracking(PageName.CustomerInsightComponent, PageName.CustomerInsightComponent, PageName.ContactPageComponent, { from: PageName.ContactPageComponent });
        }
        return;
      case 'medicalinquiry':
        {
          const miCreateForm = this.dynamicFormService.getFormDefinitionForEntity('indskr_medicalinquiry', FormType.CREATEFORM);
          if (!miCreateForm) {
            this.notificationService.notify(this.translate.instant('MI_NO_CREATE_FORM_CONFIGURED'), 'New Activity', 'top', ToastStyle.DANGER);
            return;
          }

          await this.handleNewMedicalInquiry();
        }
        return;
      case 'customerinquiry':
        let iCase: CaseActivity;
        if (this.activityOfflineService.activitySource === ActivitySource.MEETING_DETAIL ||
          this.activityOfflineService.activitySource === ActivitySource.MEETING_PRESENTATION) {
          await this.createCustomerInquiryForMeeting(AccesingMode.INMEETING);
          if (this.isLayoverPushView) {
            this.navService.popChildNavPageWithPageTracking();
          }
          if (this.caseManagementService.currentCase) this.uiService.showNewActivity = false;
        } else if (this.activityOfflineService.activitySource == ActivitySource.PHONE_CALL_ACTIVITY_DETAIL) {
          await this.createCustomerInquiryForMeeting(AccesingMode.IN_PHONE_CALL);
          if (this.isLayoverPushView) {
            this.navService.popChildNavPageWithPageTracking();
          }
          if (this.caseManagementService.currentCase) this.uiService.showNewActivity = false;
        } else if(this.activityOfflineService.activitySource == ActivitySource.SET_BOOKING_ACTIVITY_DETAIL){
          await this.createCustomerInquiryForMeeting(AccesingMode.IN_SET_BOOKING);
          if(this.isLayoverPushView) {
            this.activityOfflineService.prevSelectedActivity = this.activityOfflineService.selectedActivity;
            this.navService.popChildNavPageWithPageTracking();
          }
        } else {
          this.trackingService.tracking('InquiryActivityConfirm', TrackingEventNames.CUSTOMER_INQUIRY);
          if (this.navService.getCurrentMasterPageName() != PageName.ContactPageComponent) {
            let preSelectedData: Object = {};
            preSelectedData['startTime'] = this.startTime ? new Date(this.startTime).getTime() : new Date().getTime();
            try {
              iCase = await this.caseManagementService.initNewCaseActivity(this.type, true, preSelectedData);
            } catch (error) {
              console.error(error);
            }

            if (iCase) {
              this.caseManagementService.assignSelectedCase(iCase);
              this.uiService.showNewActivity = false;
              this.uiService.showRightPane = true;
              this.activityOfflineService.selectedActivityAtHome = this.activityOfflineService.selectedActivity = iCase;
              this.uiService.prevView = this.uiService.activeView;
              this.caseManagementService.showNewCase = false;
            }
            else {
              return;
            }
          }

          if
            (this.navService.getCurrentMasterPageName() === PageName.GoAppActivitiesPageComponent) {
            this.caseManagementService.accessedFrom = AccesingMode.AGENDA;
            this.uiService.activeView = 'ActivitiesPageRightPaneNav';
            this.navService.setChildNavRoot(PageName.NothingSelectedView, PageName.NothingSelectedView, PageName.GoAppActivitiesPageComponent);
            this.pushChildNavPageWithPageTracking(PageName.CaseManagementDetailComponent, PageName.CaseManagementDetailComponent, PageName.GoAppActivitiesPageComponent, { from: PageName.GoAppHomeComponent });

          }
          else if (this.navService.getCurrentMasterPageName() === PageName.ContactPageComponent ||
            (this.navService.getCurrentMasterPageName() === PageName.GoAppActivitiesPageComponent && !this.footerService.isActivitiesButton)) {
            let preSelectedData: Object = {};
            if (this.contactService.contactInformation) {
              preSelectedData['contacts'] = new Array(1).fill(this.contactService.contactInformation);
            }
            let iCase: CaseActivity = await this.caseManagementService.initNewCaseActivity(this.type, true, preSelectedData);
            this.caseManagementService.assignSelectedCase(iCase);
            this.uiService.showNewActivity = false;
            this.activityOfflineService.selectedActivity = iCase;
            await this.navService.popChildNavPageWithPageTracking();
            this.caseManagementService.accessedFrom = AccesingMode.CONTACT;
            this.pushChildNavPageWithPageTracking(PageName.CaseManagementDetailComponent, PageName.CaseManagementDetailComponent, PageName.ContactPageComponent, { from: PageName.ContactDetailsComponent });
          }
          else {
            this.uiService.activeView = 'customer_inquiry';
          }
          try {
            this.eventService.publish('weekview:RefreshUI');
          } catch (error) {
            console.error('error publishing new event');
          }
        }
        break;
      case 'phonecall':
        if (this.agendaFooterService.actSegment === 'week') {
          this.trackingService.tracking('PhoneCallCalendarNew', TrackingEventNames.PHONECALL, true);
        }
        else {
          this.trackingService.tracking('Select Confirm', TrackingEventNames.PHONECALL);
        }
        await this.createNewPhoneCall();
        if (this.activityOfflineService.selectedActivity && this.activityOfflineService.selectedActivity.type == ActivityType.PhoneCall)
          this.footerService.initButtons(FooterViews.PHONE_CALL);

        if (this.isLayoverPushView) {
          try {
            if (this.layoverViewPushedFrom == 'AccountManagementTool') {
              if (this.uiService.activitiesPagePlanTabSelectedPlan === 'accountPlansTab') {
                this.uiService.activeView = 'ActivitiesPageRightPaneNav';
              }
              this.navService.popChildNavPageWithPageTracking();
              this.uiService.showCancelDoneOnActivityDetails = true;
              this.pushChildNavPageWithPageTracking(PageName.PhoneCallDetailsComponent,
                PageName.PhoneCallDetailsComponent, PageName.AccountManagementPageComponent, { from: 'AccountManagementTool', account: this.layoverViewPassedData.accounts, isNewlyCreatedActivity: true });
              return;
            } else if (this.layoverViewPushedFrom == 'AccountTool') {
              this.navService.popChildNavPageWithPageTracking();
              this.uiService.showCancelDoneOnActivityDetails = true;
              this.pushChildNavPageWithPageTracking(PageName.PhoneCallDetailsComponent, PageName.PhoneCallDetailsComponent, PageName.AccountPageComponent, { from: 'AccountTool', account: this.layoverViewPassedData, isNewlyCreatedActivity: true });
            } else if (this.layoverViewPushedFrom == 'ContactPageComponent') {
              this.navService.popChildNavPageWithPageTracking();
              this.uiService.showCancelDoneOnActivityDetails = true;
              this.pushChildNavPageWithPageTracking(PageName.PhoneCallDetailsComponent, PageName.PhoneCallDetailsComponent, PageName.ContactPageComponent, { from: 'ContactPageComponent', isNewlyCreatedActivity: true });
            }
          } catch (error) {
            console.error(error);
          }
        }
        this.activityOfflineService.selectedActivityAtHome = this.activityOfflineService.selectedActivity;
        break;
      case 'opportunity':
        this._handleNewOpportunity();
        return;
      case 'survey':
        if (this.activityOfflineService.activitySource === ActivitySource.MEETING_DETAIL ||
          this.activityOfflineService.activitySource === ActivitySource.MEETING_PRESENTATION) {
          this._openSurvey();
        } else {

        }
        return;
      case 'storecheck':
        await this.handleNewStoreCheck();
        break;
      case 'kit_booking':
        await this.handleNewKitBooking();
        break;
      case 'quotes':
        await this.handleNewQuotes();
        break;

      default:
        console.error(
          'Unhandled switch case for activeViewNewMeeting:',
          this.uiService.activeViewNewMeeting
        );
    }

    if (this.NewActivitySource === ActivitySource.MEETING_DETAIL) {
      const currentPage: PageName = this.navService.getCurrentPageName();
      if (currentPage == PageName.CallPlanComponent) {
        this.callPlanService.callPlanPageView = 'CallPlanNewMeetingDetails';
        this.footerService.initButtons(FooterViews.Activities);
      }
    }

    if (this.uiService.activeViewNewMeeting == 'allocation') {
      return
    }
    if (this.uiService.activeViewNewMeeting != 'email') {
      this.emailService.selectedActivity = null;
      this.emailService.setCurrentEmail(null);
    }

    this.uiService.setCellData = null;
    const curPage = this.navService.getCurrentPageName();
    if (curPage === PageName.NewActivityComponent) {
      //meeting request
      if (!this.confirmTimeoff) {
        this.activityOfflineService.isNewActivityCreated = true;
        this.uiService.activeView = 'Appointment';
        // For now, we assume that default behaviour after creating a new activity from a
        // pushed new-activity page is to go to the activities detail page on activities master page
        if (this.currentMasterPage !== PageName.GoAppActivitiesPageComponent) {
          // We want to show 'agenda' tab by default when we come from other pages
          this.uiService.activitiesPageTab = 'agenda';
        }
        this.navService.popToRootWithPageTracking();
      }
    }
    else if (curPage === PageName.ContactPageComponent && this.uiService.activeViewNewMeeting != 'customerinquiry') {
      /* != 'customerinquiry as we have already handled the logic in the above switch statement */
      if (this.uiService.activeViewNewMeeting == 'email' && this.NewActivitySource !== ActivitySource.MEETING_DETAIL) {
        this.uiService.activeView = 'Email';
      }
      else if (this.uiService.activeViewNewMeeting == 'phonecall'
        && this.NewActivitySource === ActivitySource.CONTACT_INFO) {
        this.uiService.activeView = 'phoneCallTimelineDetails'
      }
    }
    else if (curPage === PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPageTab != 'plans') {
      if (this.activityOfflineService.selectedActivity instanceof EmailActivity) {
        this.uiService.activeView = 'Email';
        return;
      }
    }

    // Some activity publishes activity creation event within their logic.
    // Might need to filter those features as we find..
    if (this.uiService.activeViewNewMeeting !== 'timeoff') {
      this.activityOfflineService.publishActivityEvent({ action: "Create", activity: this.activityOfflineService.selectedActivity });
    }

    this.handleNewActivityCreatedUpdatePlanTab(this.activityOfflineService.selectedActivity);
    } finally {
      this._finishActivityCreation();
    }
  }

  private async handleNewStoreCheck() {
    if (this.device.isOffline) {
      this.notificationService.notify(this.translate.instant('STORE_CHECK_OFFLINE'), 'Store Check Activity', 'top', ToastStyle.DANGER);
      return;
    }
    if (this.isLayoverPushView) {
      await this.navService.popChildNavPageWithPageTracking();
    }
    await this.createStoreCheck();
  }

  private async createStoreCheck() {
    const payload = {
      scheduledend: new Date(this.endTime).getTime(),
      scheduledstart: new Date(this.startTime).getTime(),
      offlineActivityId: 'offline_store_check_' + new Date().getTime(),
      subject: this.translate.instant("STORE_CHECK"),
    }
    if (this.authService.hasFeatureAction(FeatureActionsMap.PROMO_CHECK)) {
      payload['subject'] = this.translate.instant('STORE_PROMO_CHECK');
    }
    if (this.layoverViewPushedFrom == 'AccountTool') {
      payload['accounts'] = [{
        indskr_accountid: this.layoverViewPassedData.id,
        accountName: this.layoverViewPassedData.accountName,
        accountId: this.layoverViewPassedData.id
      }];
      payload['subject'] = payload['subject'] + ' - ' + this.layoverViewPassedData.accountName;
    }
    if (this.device.isOffline) {
      this.notificationService.notify(this.translate.instant('STORE_CHECK_OFFLINE'), 'Store Check Activity', 'top', ToastStyle.DANGER);
      return;
    }
    const defaultCategories = this.storeCheckService.productCategories?.filter(pc => pc.indskr_default);
    if (!isEmpty(defaultCategories)) {
      const defaultCategory = defaultCategories[0];
      payload['categoryId'] = defaultCategory.indskr_productfamilycategoryid;
      payload['categoryName'] = defaultCategory.indskr_name;
      if (this.authService.hasFeatureAction(FeatureActionsMap.PROMO_CHECK)) {
        payload['subject'] += ` - ${defaultCategory.indskr_name}`;
      }
    }
    const activity = await this.storeCheckService.createStoreCheck(payload);
    if (activity) {
      this.activityOfflineService.finalizeAgendaRefresh();
      this.activityOfflineService.selectedActivityAtHome = this.activityOfflineService.selectedActivity = activity;
      this.activityOfflineService.publishActivityEvent({ action: "Create", activity: this.activityOfflineService.selectedActivity });
      if (this.navService.getActiveChildNavName() === ChildNavNames.AccountPageNavigation) {
        this.pushChildNavPageWithPageTracking(PageName.StoreCheckDetailsComponent, PageName.StoreCheckDetailsComponent, PageName.AccountPageComponent);
      } else {
        this.navService.setChildNavRoot(PageName.StoreCheckDetailsComponent, PageName.StoreCheckDetailsComponent, PageName.GoAppActivitiesPageComponent);
      }
    } else {
      this.notificationService.notify(this.translate.instant('NEW_ACTIVITY_TOAST_ERROR_CREATING_NEW_STORE_CHECK'), 'New Activity', 'top', ToastStyle.DANGER);
    }
  }

  private handleNewActivityCreatedUpdatePlanTab(activity: any) {
      // We only have to update if the activity is older then today midnight.
    if(activity){
      if (this.dateTimeFormatsService.isPastDate(activity.scheduledStart) && this.authenticationOfflineService.user.offlineDataDuration && this.authenticationOfflineService.user.offlineDataDuration > 0) {
        let dateAdjustedWithOfflineDataDuration = new Date(new Date((new Date().setDate(new Date().getDate() - this.authenticationOfflineService.user.offlineDataDuration))).setHours(0, 0, 0, 0));
        let todayStart = new Date(new Date().setHours(0, 0, 0, 0));
        if (this.dateTimeFormatsService.isDateWithinRange(activity.scheduledStart, dateAdjustedWithOfflineDataDuration, todayStart)) {
          this.events.publish('newActivityIsCreatedUpdatePlanTab', activity);
        }
      }
    }
  }

  async createOrEditSampleOrderFromMeeting() {
    let activity: SampleActivity = await this.sharedDataService.createInMeetingAllocationOrder();
    if (activity) {
      this.samplingOfflineService.samplingDetailsViewMode = SamplingDetailsViewMode.CREATE_FROM_MEETING;
      this.samplingOfflineService.inMeetingAllocationActivity = activity;
      this.activityService.activityDetailsLoaded = true;
      if (!this.uiService.toolsActivityActive) {
        this.events.publish('refreshAgenda');
      }
      else this.uiService.agendaRefreshRequired = true;
      this.uiService.showNewActivity = false;
      this.activityOfflineService.samplingToInMeetingActivityMapping.set(this.activityOfflineService.selectedActivity.ID, activity.ID)
      this.meetingStructureService.createInMeetingEmbededActivity(activity);
      this.meetingStructureService.openInMeetingActivitiesModal(activity, true);
    }
  }

  async createOrEditSampleOrderFromEvent() {
    let activity: SampleActivity = await this.sharedDataService.createEventAllocationOrder();
    if (activity) {
      this.samplingOfflineService.samplingDetailsViewMode = SamplingDetailsViewMode.CREATE_FROM_EVENTS;
      this.samplingOfflineService.inMeetingAllocationActivity = activity;
      this.activityService.activityDetailsLoaded = true;
      if (!this.uiService.toolsActivityActive) {
        this.events.publish('refreshAgenda');
      }
      else this.uiService.agendaRefreshRequired = true;
      this.uiService.showNewActivity = false;
      this.activityOfflineService.samplingToInMeetingActivityMapping.set(this.activityOfflineService.selectedActivity.ID, activity.ID)
      this.meetingStructureService.createInMeetingEmbededActivity(activity);
      this.meetingStructureService.openInMeetingActivitiesModal(activity, true);
    }
  }


  /**
   * OMNI-61541: notify (once) when one or more contacts in the current meeting/phone-call
   * carry the AMA No-Contact flag (donotemail). Those contacts are not added to the
   * in-meeting message (see SharedDataService.createInMeetingEmail); this explains why.
   */
  private notifySkippedAMANoContactMeetingContacts(): void {
    const meetingContacts: any[] = (this.activityOfflineService.selectedActivity as any)?.contacts || [];
    if (meetingContacts.some(c => c && c.donotemail === true)) {
      this.notificationService.notify(this.translate.instant('AMA_NO_CONTACT_CANNOT_BE_MESSAGED'), 'New Activity', 'top', ToastStyle.INFO);
    }
  }

  private async createEmailInMeeting() {
    try {
      this.trackingService.tracking('EmailActivityFromMeeting', TrackingEventNames.EMAIL, true);

      let activity: EmailActivity = await this.sharedDataService.createInMeetingEmail(this.selectedMessagingChannelType);
      this.notifySkippedAMANoContactMeetingContacts();
      if (activity) {
        this.meetingStructureService.createInMeetingEmbededActivity(activity);
        let data = {
          id: activity.ID, subject: activity.subject, info: activity.info, type: activity.type,
          scheduledStart: activity.scheduledStart, scheduledEnd: activity.scheduledEnd,
          messageType: EmailTemplateType.Resource,
        };
        this.activityOfflineService.publishActivityEvent({ action: 'Create', activity });
        if (!this.uiService.toolsActivityActive) {
          this.events.publish('refreshAgenda');
        } else this.uiService.agendaRefreshRequired = true;
        this.createEmailModal(this.emailService.selectedActivity);
      }
    } catch (ex) {
      console.error('Error creating email in meeting : ' + ex);
    }
  }

  private async createEmailInPhoneCallActivity() {
    try {
      this.trackingService.tracking('SelectConfirm', TrackingEventNames.PHONECALL, true);

      let activity: EmailActivity = await this.sharedDataService.
        createInMeetingEmail(this.selectedMessagingChannelType);
      this.notifySkippedAMANoContactMeetingContacts();
      if (activity) {
        this.phoneCallMeetingStructureService.createInPhoneCallMeetingEmbededActivity(activity);
        let data = {
          id: activity.ID, subject: activity.subject, info: activity.info, type: activity.type,
          scheduledStart: activity.scheduledStart, scheduledEnd: activity.scheduledEnd,
          messageType: EmailTemplateType.Resource,
        };
        this.activityOfflineService.publishActivityEvent({ action: 'Create', activity });
        this.activityOfflineService.finalizeAgendaRefresh();
        this.createEmailModal(this.emailService.selectedActivity);
      }
    } catch (ex) {
      console.error('Error creating email in meeting : ' + ex);
    }
  }


  private createEmailModal(activity: EmailActivity) {
    this.uiService.showNewActivity = false;
    this.emailService.setCurrentEmail(activity);
    this.emailService.viewType = EmailViewType.CREATE_FROM_MEETING;
    if (this.NewActivitySource == ActivitySource.PHONE_CALL_ACTIVITY_DETAIL) {
      this.emailService.viewType = EmailViewType.CREATE_FROM_PHONE_CALL
      this.phoneCallMeetingStructureService.openInPhoneCallMeetingActivitiesModal(activity, true)
      return
    }
    this.meetingStructureService.openInMeetingActivitiesModal(activity, true);
  }

  public toggle(selected, event) {
    if (event.checked) {
      this.selectedType = selected.id;
      this.type = selected;
    }
    else {
      if (selected.id == this.selectedType) event.checked = true;
    }
  }

  private getPlanType() {
    switch (this.followUpActionCategory) {
      case 'accountplantask': return FOLLOW_UP_TYPE.ACCOUNT_PLAN;
      case 'none': return FOLLOW_UP_TYPE.NONE;
      case 'meetingtask': return FOLLOW_UP_TYPE.MEETINGTASK;
      case 'opportunitytask': return FOLLOW_UP_TYPE.OPPORTUNITY_TASK;
      case 'marketingplantask': return FOLLOW_UP_TYPE.MARKETING_BUSINESS_PLAN;
      case 'eventtask': return FOLLOW_UP_TYPE.EVENT_TASK;
      default: return null;
    }
  }

  private filterDeletedOrCanceledParticipants(participants: EventParticipant[]): EventParticipant[] {
    let filtered = [];
    if (Array.isArray(participants)) {
      filtered = participants.filter(p => !(
        p.isDeleted || p.indskr_reasons === EventRegistrationStatus.Cancelled
      ));
    }

    return filtered;
  }

  private async handleNewFollowUpActionTaskCreation(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let errorOccured: boolean = false;
      let currentTime = new Date().getTime();
      let start = this.dateTimeFormatsService.toISOString(new Date().setHours(0, 0, 0, 0));

      if (this.agendaFooterService.actSegment === 'week' && this.uiService.selectedCalendarDateInWeekView && this.navService.getCurrentMasterPageName() === PageName.GoAppActivitiesPageComponent) {
        start = this.dateTimeFormatsService.toISOString(this.uiService.selectedCalendarDateInWeekView.setHours(0, 0, 0, 0));
      }
      let payload = {
        activityId: 'offline_followup_' + currentTime,
        activitytypecode: 'followuptask',
        subject: 'Follow-up Action',
        offlineId: 'offline_followup_' + currentTime,
        scheduledstart: new Date(start).getTime(),
        indskr_plantype: this.getPlanType()//this.followUpActionCategory == 'accountplantask' ? FOLLOW_UP_TYPE.ACCOUNT_PLAN : this.followUpActionCategory == 'none' ? FOLLOW_UP_TYPE.NONE : this.followUpActionCategory == 'meetingtask' ? FOLLOW_UP_TYPE.MEETINGTASK : FOLLOW_UP_TYPE.OPPORTUNITY_TASK,
      };
      if (this.isLayoverPushView) {
        if (this.layoverViewPushedFrom == 'AccountManagementTool') {
          this.trackingService.tracking('AccountPlanFollowupAction', TrackingEventNames.ACCOUNTPLANNING)
          if (this.layoverViewPassedData.accounts) {
            if (this.layoverViewPassedData && this.layoverViewPassedData.accounts.length == 1) {
              payload['indskr_account'] = this.layoverViewPassedData.accounts[0].id;
              payload['accountName'] = this.layoverViewPassedData.accounts[0].name;
              payload['indskr_accountplan'] = this.layoverViewPassedData.ID;
              payload['accountplanName'] = this.layoverViewPassedData.accountPlanName;
            }
          }
        }
        if (this.layoverViewPushedFrom == 'AccountTool') {
          this.trackingService.tracking('AccountsFollowupAction', TrackingEventNames.ACCOUNTPLANNING)
          if (this.layoverViewPassedData) {
            payload['indskr_account'] = this.layoverViewPassedData.id;
            payload['accountName'] = this.layoverViewPassedData.accountName;
          }
        }
        if (this.layoverViewPushedFrom == 'OpportunityManagementTool'
          || this.layoverViewPushedFrom == 'AccountProfileOpportunities'
          || this.from == 'AccountPlanOpportunities'
          || this.from == 'MarketingPlanInfoopportunities') {
          if (this.layoverViewPassedData) {
            payload['indskr_account'] = this.layoverViewPassedData.accountID;
            payload['accountName'] = this.layoverViewPassedData.accountName;
            payload['indskr_accountplan'] = this.layoverViewPassedData.accountPlanID;
            payload['accountplanName'] = this.layoverViewPassedData.accountPlanName;
            payload['opportunityid'] = this.layoverViewPassedData.ID;
            payload['opportunityName'] = this.layoverViewPassedData.opportunityName;
          }
        }
        if(this.layoverViewPushedFrom == 'ActivitiesDetailsPane'){
          let parentMeetingActivity = (this.activityOfflineService.selectedActivity as AppointmentActivity);
          if(parentMeetingActivity.contacts.length==1){
            payload['indskr_contact'] = parentMeetingActivity.contacts[0].ID;
            payload['contactName'] = parentMeetingActivity.contacts[0].fullName;
            this.contactService.addToRecentContacts(parentMeetingActivity.contacts[0]);
          }
          if(parentMeetingActivity.accounts.length==1){
            payload['indskr_account'] = parentMeetingActivity.accounts[0].id;
            payload['accountName'] = parentMeetingActivity.accounts[0].accountName;
          }
          if(parentMeetingActivity.products.length>0){
            payload['products'] = [];
            parentMeetingActivity.products.filter(o=>o.isSelected).forEach(p=>{
              payload['products'].push(
                {
                  productId : p.ID,
                  productName: p.name,
                }
              )
            })
          }
        }
        if (this.layoverViewPushedFrom === 'EventDetailsPane') {
          const currentEvent = (this.eventsToolService.selectedEventOnEventsTool as EventActivity);
          if (!currentEvent) {
            throw new Error(`Current event is not found!`);
          }
          payload['indskr_event'] = currentEvent.ID || currentEvent.offlineId;
          payload['indskr_eventname'] = currentEvent.name;

          const filteredParticipants = this.filterDeletedOrCanceledParticipants(currentEvent.participants);
          if (filteredParticipants.length === 1) {
            payload['indskr_contact'] = filteredParticipants[0].id;
            payload['contactName'] = filteredParticipants[0].name;
            const contact = this.contactService.getContactByID(filteredParticipants[0].id);
            if (contact) {
              this.contactService.addToRecentContacts(contact);
            }
          }
          if (currentEvent.accounts.length === 1) {
            payload['indskr_account'] = currentEvent.accounts[0].id;
            payload['accountName'] = currentEvent.accounts[0].name;
          }
          if (currentEvent.products.length > 0) {
            payload['products'] = [];
            currentEvent.products.forEach(p =>
              payload['products'].push(
                {
                  productId : p.id,
                  productName: p.name,
                }
              )
            );
          }
        }
      }
      if ((this.currentMasterPage == PageName.ContactPageComponent ||
        (this.currentMasterPage == PageName.GoAppActivitiesPageComponent && !this.footerService.isActivitiesButton))
        && this.contactService.contactInformation) {
        this.trackingService.tracking('ContatcsFollowupAction', TrackingEventNames.ACCOUNTPLANNING)
        payload['indskr_contact'] = this.contactService.contactInformation.ID;
        payload['contactName'] = this.contactService.contactInformation.fullName;
        this.contactService.addToRecentContacts(this.contactService.contactInformation);
      }
      else {
        this.trackingService.tracking('AgendaFollowupAction', TrackingEventNames.ACCOUNTPLANNING);
      }
      let newFollowUp = new FollowUpActivity(payload);
      newFollowUp.state = 0;
      newFollowUp.statusString = 'Open';
      newFollowUp.ownerId = this.authenticationOfflineService.user.systemUserID;
      newFollowUp.ownerNameString = this.authenticationOfflineService.user.displayName;
      newFollowUp.pendingPushToDynamics = true;
      if(this.followUpActionCategory == 'meetingtask' && this.activityOfflineService.selectedActivity && this.activityOfflineService.selectedActivity instanceof AppointmentActivity){
        if (!this.activityOfflineService.selectedActivity.ID.includes('offline')) {
          newFollowUp.appointmentId = this.activityOfflineService.selectedActivity.ID;
        }
        newFollowUp.offlineMeetingId = (this.activityOfflineService.selectedActivity as AppointmentActivity).offlineMeetingId;
        newFollowUp.appointmentSubject = this.activityOfflineService.selectedActivity.subject;
        if((this.activityOfflineService.selectedActivity as AppointmentActivity).products){
          newFollowUp.products = [];
          (this.activityOfflineService.selectedActivity as AppointmentActivity).products.forEach(selPro => {
            if(selPro.isSelected || selPro.isAutoSelected){
              let foundProduct = this.brandService.getBrandByID(selPro.ID);
              if(foundProduct){
                newFollowUp.products.push({ productID: foundProduct.ID, productName: foundProduct.name });
              }
            }
          });
        }
      }
      await this.followUpActivityDataService.createFollowUpActivity({ onDynamics: !this.device.isOffline, onLocalCopy: true, onLocalDatabase: true }, [newFollowUp], currentTime, false).then(succ => {
        //Successfully created new follow up activity
        if (
          this.activityOfflineService.activitySource !== ActivitySource.MEETING_DETAIL
          && this.NewActivitySource !== ActivitySource.MEETING_PRESENTATION
          && this.activityOfflineService.activitySource !== ActivitySource.EVENT_DETAIL
        ) {
          this.activityOfflineService.selectedActivity = newFollowUp;
        } else {
          this.followUpActivityDataService.inMeetingFollowupActionActivity = newFollowUp;
        }
      }).catch(err => {
        // Handle any error occured during follow up activity creation
        reject('error occured while creating new follow up');
        errorOccured = true;
      });
      if (this.activityOfflineService.activitySource === ActivitySource.MEETING_DETAIL || this.NewActivitySource === ActivitySource.MEETING_PRESENTATION) {
        if (this.uiService.activitiesPageTab == 'day' || this.activityOfflineService.newHomeView === 'calendarView') {
          let data = {
            id: newFollowUp.ID,
            subject: newFollowUp.subject,
            location: newFollowUp.location,
            scheduledStart: newFollowUp.scheduledStart,
            scheduledEnd: newFollowUp.scheduledEnd,
            type: newFollowUp.type,
          };
          this.uiService.setUIServiceData({
            view: 'new-activity', data,
          });
        }
        this.activityOfflineService.finalizeAgendaRefresh();
        resolve('');
        return;
      }
      if (!errorOccured) {
        let from: string = 'AgendaView';
        let pageName: PageName = PageName.GoAppActivitiesPageComponent;
        if (this.isLayoverPushView) {
          this.navService.popChildNavPageWithPageTracking();
          if (this.layoverViewPushedFrom == 'AccountManagementTool') {
            from = 'AccountManagementTool';
            pageName = PageName.AccountManagementPageComponent;
            this.pushChildNavPageWithPageTracking(PageName.FollowUpActionDetailComponent, PageName.FollowUpActionDetailComponent, PageName.AccountManagementPageComponent, { from: from, activity: newFollowUp });
          }
          else if (this.currentMasterPage == PageName.AccountPageComponent && this.layoverViewPushedFrom == 'AccountTool') {
            from = 'AccountTool';
            pageName = PageName.AccountPageComponent;
            this.uiService.showNewActivity = false;
            this.pushChildNavPageWithPageTracking(PageName.FollowUpActionDetailComponent, PageName.FollowUpActionDetailComponent, PageName.AccountPageComponent, { from: from, activity: newFollowUp });
          }
          else if (this.layoverViewPushedFrom == 'OpportunityManagementTool'
            || this.layoverViewPushedFrom == 'AccountProfileOpportunities'
            || this.from == 'AccountPlanOpportunities'
            || this.from == 'MarketingPlanInfoopportunities') {
            from = this.layoverViewPushedFrom;
            pageName = this.layoverViewPushedFrom == 'OpportunityManagementTool' ? PageName.OpportunityManagementPage
              : this.layoverViewPushedFrom == 'AccountProfileOpportunities' ? PageName.AccountPageComponent : this.layoverViewPushedFrom == 'MarketingPlanInfoopportunities' ? PageName.MarketingPlanManagementPageComponent :  PageName.AccountManagementPageComponent;
            this.pushChildNavPageWithPageTracking(PageName.FollowUpActionDetailComponent, PageName.FollowUpActionDetailComponent, pageName, { from: from, activity: newFollowUp });
          } else if (this.layoverViewPushedFrom === 'ContactPageComponent') {
            from = 'ContactTool';
            pageName = PageName.ContactPageComponent;
            this.pushChildNavPageWithPageTracking(PageName.FollowUpActionDetailComponent, PageName.FollowUpActionDetailComponent, PageName.ContactPageComponent, { from: from, activity: newFollowUp });
          }
        } else { // Assume follow up actiion is being created from agenda
          if (this.footerService.isActivitiesButton) {
            this.navService.setChildNavRoot(PageName.FollowUpActionDetailComponent, PageName.FollowUpActionDetailComponent, PageName.GoAppActivitiesPageComponent, { from: from, activity: newFollowUp });
          } else {
            this.pushChildNavPageWithPageTracking(PageName.FollowUpActionDetailComponent, PageName.FollowUpActionDetailComponent, PageName.GoAppActivitiesPageComponent, { from: from, activity: newFollowUp });
          }
          this.uiService.activeView = 'ActivitiesPageRightPaneNav';
          this.uiService.showNewActivity = false;
          this.uiService.showRightPane = true;
          if (this.uiService.activitiesPageTab == 'day' || this.activityOfflineService.newHomeView === 'calendarView') {
            let data = {
              id: newFollowUp.ID,
              subject: newFollowUp.subject,
              location: newFollowUp.location,
              scheduledStart: newFollowUp.scheduledStart,
              scheduledEnd: newFollowUp.scheduledEnd,
              type: newFollowUp.type,
            };
            this.uiService.setUIServiceData({
              view: 'new-activity', data,
            });
          }
        }
        this.activityOfflineService.finalizeAgendaRefresh();
        resolve('');
      }
    });
  }


  private async handleNewQuoteCreation() {
    try {

      let newQuote = await this.injector.get(QuoteDataService)
        .generateQuoteFromOpportunity(this.layoverViewPassedData.ID);


      if (this.isLayoverPushView) {
        if (this.currentMasterPage === PageName.OpportunityManagementPage && this.layoverViewPushedFrom == 'OpportunityManagementTool') {
          const from = 'OpportunityManagementTool';
          const pageName: PageName = PageName.GoAppActivitiesPageComponent;
          this.uiService.showNewActivity = false;
          this.navService.popChildNavPageWithPageTracking();
          this.pushChildNavPageWithPageTracking(PageName.OpportunityQuoteDetailsComponent, PageName.OpportunityQuoteDetailsComponent, pageName, { from: from, quote: newQuote });
        }else if (this.currentMasterPage === PageName.MarketingPlanManagementPageComponent && this.layoverViewPushedFrom == 'MarketingPlanInfoopportunities') {
          const from = 'MarketingPlanOpportunities';
          const pageName: PageName = PageName.MarketingPlanManagementPageComponent;
          this.uiService.showNewActivity = false;
          this.navService.popChildNavPageWithPageTracking();
          this.pushChildNavPageWithPageTracking(PageName.OpportunityQuoteDetailsComponent, PageName.OpportunityQuoteDetailsComponent, pageName, { from: from, quote: newQuote });
        }
      }
    }
    catch (ex) {
      throw 'Error occured while creating a new quote';
    }
  }
  private async handleNewConsentCreation() {
    try {
      this.navService.popChildNavPageWithPageTracking();
      const isFromMeetingDetail = this.NewActivitySource === ActivitySource.MEETING_DETAIL;
      const masterPage = isFromMeetingDetail ? PageName.ActivitiesDetailsPaneComponent : PageName.PresentationMeetingComponent;
      const params = isFromMeetingDetail ? { asPage: true, contactToRestoreOnClose: this.contactBeforeMeetingConsent } : { asPage: true };
      this.pushChildNavPageWithPageTracking(PageName.ContactConsentCaptureComponent, PageName.ContactConsentCaptureComponent, masterPage, params);
    }
    catch (ex) {
      throw 'Error occured while creating a new quote';
    }
  }

  private async handleNewOrderCreation(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let errorOccured: boolean = false;
      let currentTime = new Date().getTime();
      let start, end;
      start = this.dateTimeFormatsService.toISOString(Utility.getRoundedDownTime(new Date()));
      end = this.dateTimeFormatsService.toISOString(this.dateTimeFormatsService.addMinutesToDate(start, 30));
      let payload = {
        salesorderid: 'offline_order_' + currentTime,
        indskr_externalid: 'offline_order_' + currentTime,
        indskr_ordertype: 548910000,
        ordernumber: 'New Order',
        subject: 'New Order',
        name: 'New Order',
        pendingPushToDynamics: true,
        statuscode: 1,
        statecode: 0,
        activitytypecode: 'indskr_order',
        createdon: new Date(currentTime).getTime(),
        scheduledstart: new Date(start).getTime(),
        scheduledend: new Date(end).getTime(),
      }

      if (this.layoverViewPushedFrom == 'AccountTool') {
        if (this.layoverViewPassedData) {
          payload['customerid'] = this.layoverViewPassedData.id;
          payload['customerName'] = this.layoverViewPassedData.accountName;
        }
      }

      if (this.layoverViewPushedFrom == 'OpportunityManagementTool'
        || this.layoverViewPushedFrom == 'AccountProfileOpportunities'
        || this.from == 'AccountPlanOpportunities'
        || this.from == 'MarketingPlanInfoopportunities') {
        if (this.layoverViewPassedData) {
          payload['indskr_country'] = this.layoverViewPassedData.countryId || '';
          payload['countryName'] = this.layoverViewPassedData.countryName || '';
          payload['customerid'] = this.layoverViewPassedData.accountID || '';
          payload['customerName'] = this.layoverViewPassedData.accountName || '';
          payload['opportunityid'] = this.layoverViewPassedData.ID;
          payload['opportunityName'] = this.layoverViewPassedData.opportunityName;
          payload['accountplanid'] = this.layoverViewPassedData.accountPlanID;
          payload['accountplanName'] = this.layoverViewPassedData.accountPlanName;
        }
      }

      let newOrder = new OrderActivity(payload);
      if (this.layoverViewPushedFrom == 'OpportunityManagementTool') {
        const selectedOpportunityType = this.opportunityService.opportunityTypes.find(ot => ot.indskr_opportunitytypeid == this.opportunity.opportunityTypeId);
        const opp: Opportunity = this.opportunity;
        if (this.opportunity && !isEmpty(opp.products) && selectedOpportunityType && selectedOpportunityType.indskr_ordercreationprocess === OrderCreationType.MANUAL) {
          const products = opp.products.filter(pr => !pr.isDeleted);
          if (!isEmpty(products)) {
            products.forEach(pr => {
              newOrder.products.push({
                productId: pr.productID,
                productName: pr.productName,
                quantity: 1,
                uomid: pr.uomid,
                isDeleted: false,
                unitPrice: 0,
                formattedUnitPrice: "0$",
                total: 1,
                formattedTotal: "1",
              });
            });
          }
        }
      }
      newOrder.statusString = 'Open';
      newOrder.ownerId = this.authenticationOfflineService.user.systemUserID;
      newOrder.ownerNameString = this.authenticationOfflineService.user.displayName;

      await this.orderActivityDataService.createOrderActivity({ onDynamics: !this.device.isOffline, onLocalCopy: true, onLocalDatabase: true }, [newOrder], currentTime, false).then(succ => {
        //Successfully created new order activity
        this.trackingService.tracking('OrderCreate',TrackingEventNames.ORDER);
        this.activityOfflineService.selectedActivity = newOrder;
      }).catch(err => {
        // Handle any error occured during order activity creation
        reject('error occured while creating new order');
        errorOccured = true;
      });
      if (!errorOccured) {
        let from: string = 'AgendaView';
        let pageName: PageName = PageName.GoAppActivitiesPageComponent;
        if (this.isLayoverPushView) {
          // Handle cases if any
          if (this.currentMasterPage == PageName.AccountPageComponent && this.layoverViewPushedFrom == 'AccountTool') {
            from = 'AccountTool';
            pageName = PageName.AccountPageComponent;
            this.uiService.showNewActivity = false;
            this.trackingService.tracking('AccountNewOrder', TrackingEventNames.ORDERMANAGEMENT);
            this.navService.popChildNavPageWithPageTracking();
            this.pushChildNavPageWithPageTracking(PageName.OrderDetailsComponent, PageName.OrderDetailsComponent, pageName, { from: from, activity: newOrder });
          }
          if (this.currentMasterPage == PageName.OpportunityManagementPage && this.layoverViewPushedFrom == 'OpportunityManagementTool') {
            from = 'OpportunityManagementTool';
            pageName = PageName.OpportunityManagementPage;
            this.uiService.showNewActivity = false;
            this.uiService.isFromOpportunites = true;
            this.navService.popChildNavPageWithPageTracking();
            this.pushChildNavPageWithPageTracking(PageName.OrderDetailsComponent, PageName.OrderDetailsComponent, pageName, { from: from, activity: newOrder });
          }
          if (this.currentMasterPage == PageName.AccountPageComponent && this.layoverViewPushedFrom == 'AccountProfileOpportunities') {
            from = 'AccountProfileOpportunities';
            pageName = PageName.AccountPageComponent;
            this.uiService.showNewActivity = false;
            this.navService.popChildNavPageWithPageTracking();
            this.pushChildNavPageWithPageTracking(PageName.OrderDetailsComponent, PageName.OrderDetailsComponent, pageName, { from: from, activity: newOrder });
          }
          if (this.currentMasterPage == PageName.AccountManagementPageComponent && this.layoverViewPushedFrom == 'AccountPlanOpportunities') {
            from = 'AccountPlanOpportunities';
            pageName = PageName.AccountManagementPageComponent;
            this.uiService.showNewActivity = false;
            this.navService.popChildNavPageWithPageTracking();
            this.pushChildNavPageWithPageTracking(PageName.OrderDetailsComponent, PageName.OrderDetailsComponent, pageName, { from: from, activity: newOrder });
          }
          if (this.currentMasterPage == PageName.GoAppActivitiesPageComponent && this.layoverViewPushedFrom == 'AccountPlanOpportunities' && this.uiService.activitiesPagePlanTabSelectedPlan === 'accountPlansTab') {
            from = 'AccountPlanOpportunities';
            pageName = PageName.AccountManagementPageComponent;
            this.uiService.showNewActivity = false;
            this.uiService.activeView = 'ActivitiesPageRightPaneNav';
            this.navService.popChildNavPageWithPageTracking();
            this.pushChildNavPageWithPageTracking(PageName.OrderDetailsComponent, PageName.OrderDetailsComponent, pageName, { from: from, activity: newOrder });
          }
          if (this.currentMasterPage == PageName.MarketingPlanManagementPageComponent && this.layoverViewPushedFrom == 'MarketingPlanInfoopportunities') {
            from = 'MarketingPlanOpportunities';
            pageName = PageName.MarketingPlanManagementPageComponent;
            this.uiService.showNewActivity = false;
            this.navService.popChildNavPageWithPageTracking();
            this.pushChildNavPageWithPageTracking(PageName.OrderDetailsComponent, PageName.OrderDetailsComponent, pageName, { from: from, activity: newOrder });
          }
        } else {
          this.trackingService.tracking('AgendaNewOrder', TrackingEventNames.ORDERMANAGEMENT);
          this.navService.setChildNavRoot(PageName.OrderDetailsComponent, PageName.OrderDetailsComponent, PageName.GoAppActivitiesPageComponent, { from: from, activity: newOrder });
          this.uiService.activeView = 'ActivitiesPageRightPaneNav';
          this.uiService.showNewActivity = false;
          this.uiService.showRightPane = true;
          if (this.uiService.activitiesPageTab == 'day' || this.activityOfflineService.newHomeView === 'calendarView') {
            let data = {
              id: newOrder.ID,
              subject: newOrder.subject,
              location: (newOrder.accountId) ? newOrder.accountNameString : 'No Account',
              scheduledStart: newOrder.scheduledStart,
              scheduledEnd: newOrder.scheduledEnd,
              type: newOrder.type,
            };
            this.uiService.setUIServiceData({
              view: 'new-activity', data,
            });
          }
        }
        this.activityOfflineService.finalizeAgendaRefresh();
        if (this.agendaFooterService.actSegment === 'week') this.events.publish('weekview:RefreshUI');
        resolve('')
      } else {
        ;
        reject('Error occured while creating a new order');
      }
    });
  }

  private async handleNewSurgeryOrderCreation(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let errorOccured: boolean = false;
      let currentTime = new Date().getTime();
      let autoSetOwnerAsCoowner = this.authenticationOfflineService.user.buSettings && this.authenticationOfflineService.user.buSettings['indskr_setownerascoowner'];

      const dates = this._validateAndCalculateOrderDates(reject);
      if (!dates) return;

      const { start, end, startOfWeek, endOfWeek, isWeeklyFlag } = dates;

      if (isWeeklyFlag) {
        const firstDay = this.dateTimeFormatsService.formatDate(this.dateTimeFormatsService.getStartOfWeek(new Date(start)), 'MMM DD, YYYY');
        const lastDay = this.dateTimeFormatsService.formatDate(this.dateTimeFormatsService.getEndOfWeek(new Date(start)), 'MMM DD, YYYY');
        this.notificationService.notify(this.translate.instant('PROCEDURE_LOG_FOR_WEEK', { startDate: firstDay, endDate: lastDay }), 'New Activity', 'top', ToastStyle.INFO);
      }

      let payload: any = {
        salesorderid: 'offline_surgeryorder_' + currentTime,
        indskr_externalid: 'offline_surgeryorder_' + currentTime,
        indskr_ordertype: 548910001,
        ordernumber: 'Surgery Order',
        name: 'Procedure Log',
        indskr_noprocedureday: (this.procedureCategory === 'noProcedureDay') ? true : false,
        indskr_ctmergednew: false,
        pendingPushToDynamics: true,
        statuscode: 1,
        statecode: 0,
        activitytypecode: 'SurgeryOrder',
        createdon: new Date(currentTime).getTime(),
        modifiedByName: this.authService.user.displayName,
        modifiedon: new Date().getTime() + '',
        scheduledstart: (isWeeklyFlag) ? startOfWeek : new Date(start).getTime(),
        scheduledend: (isWeeklyFlag) ? endOfWeek : new Date(end).getTime(),
      }

      if(autoSetOwnerAsCoowner){
        let coOwners = [{
          userId: this.authenticationOfflineService.user.xSystemUserID,
          userFullName: this.authenticationOfflineService.user.displayName,
          indskr_procedurelogcoownerid: Guid.create().toString()
        }]

        payload = { ...payload, coOwners }
      }

      if (this.currentMasterPage == PageName.ContactPageComponent && this.procedureCategory === 'procedureDay' && this.contactService.contactInformation
        && !(this.NewActivitySource === ActivitySource.MEETING_PRESENTATION || this.activityOfflineService.activitySource == ActivitySource.MEETING_DETAIL)) {
        let contact = [
          {
            "id": this.contactService.contactInformation.ID,
            "firstName": this.contactService.contactInformation.firstName,
            "title": this.contactService.contactInformation.title,
            "middleName": this.contactService.contactInformation.middleName,
            "lastName": this.contactService.contactInformation.lastName,
            "statusCode": this.contactService.contactInformation.statusCode
          }]
        payload['contactorders'] = contact;
        payload['name'] = 'Procedure Log - ' + this.contactService.contactInformation.fullName;

       // adding primary affiliated account information
        const primaryaccount = await this.accountService.findPrimaryAccountOfContact(this.contactService.contactInformation.ID);
        if(primaryaccount){
          payload['customerid'] = primaryaccount.accountid;
          payload['customerName'] = primaryaccount["indskr_accountcontactaffiliation.indskr_accountid_Formatted"];
        }
      }
      this._bindContextToOrderPayload(payload, isWeeklyFlag);

      let newSurgeryOrder = new SurgeryOrderActivity(payload);
      if (isWeeklyFlag) {
        newSurgeryOrder.scheduledEnd = endOfWeek;
      }
      newSurgeryOrder.statusString = 'Draft';
      newSurgeryOrder.ownerId = this.authenticationOfflineService.user.systemUserID;
      newSurgeryOrder.ownerNameString = this.authenticationOfflineService.user.displayName;
      if (this.NewActivitySource === ActivitySource.MEETING_PRESENTATION || this.activityOfflineService.activitySource == ActivitySource.MEETING_DETAIL) {
        if (!this.activityOfflineService.selectedActivity.ID.includes('offline')) {
          newSurgeryOrder.appointmentId = this.activityOfflineService.selectedActivity.ID;
        }
        newSurgeryOrder.offlineMeetingId = (this.activityOfflineService.selectedActivity as AppointmentActivity).offlineMeetingId;
      }

      // Prefill Meeting Account and Contact if any
      if ((this.NewActivitySource === ActivitySource.MEETING_PRESENTATION || this.activityOfflineService.activitySource === ActivitySource.MEETING_DETAIL) && this.procedureCategory === 'procedureDay') {
        if (this.activityOfflineService.selectedActivity && this.activityOfflineService.selectedActivity.type == ActivityType.Appointment && (this.activityOfflineService.selectedActivity as AppointmentActivity).accounts && (this.activityOfflineService.selectedActivity as AppointmentActivity).accounts.length == 1) {
          newSurgeryOrder.accountId = (this.activityOfflineService.selectedActivity as AppointmentActivity).accounts[0].id;
          newSurgeryOrder.accountNameString = (this.activityOfflineService.selectedActivity as AppointmentActivity).accounts[0].accountName;
        }
        if (this.activityOfflineService.selectedActivity && this.activityOfflineService.selectedActivity.type == ActivityType.Appointment && (this.activityOfflineService.selectedActivity as AppointmentActivity).contacts && (this.activityOfflineService.selectedActivity as AppointmentActivity).contacts.length >= 1) {
          (this.activityOfflineService.selectedActivity as AppointmentActivity).contacts.forEach(meetingContact => {
            this.contactService.addToRecentContacts(meetingContact);
            newSurgeryOrder.customers.push(new OrderContact({
              id: meetingContact.ID,
              title: meetingContact.title,
              firstName: meetingContact.firstName,
              middleName: meetingContact.middleName,
              lastName: meetingContact.lastName,
              fullName: meetingContact.fullName,
              stateCode: meetingContact.isActive ? 1 : 0,
              statusCode: meetingContact.statusCode
            }));
          });
          newSurgeryOrder.customersNameString = this.surgeryOrderActivityDataService.getCustomerString;
          newSurgeryOrder.subject = 'Procedure Log - ' + newSurgeryOrder.customersNameString;
        }
      }
      const procedureLogAction = {
        onDynamics: (this.device.isOffline) ? false : ((this.NewActivitySource === ActivitySource.MEETING_PRESENTATION || this.activityOfflineService.activitySource == ActivitySource.MEETING_DETAIL) ? !!newSurgeryOrder.appointmentId : true),
        onLocalCopy: true,
        onLocalDatabase: true
      }
      await this.surgeryOrderActivityDataService.createOrderActivity(procedureLogAction, [newSurgeryOrder], currentTime, false).then(succ => {
        //Successfully created new surgery order activity
        if (this.activityOfflineService.activitySource !== ActivitySource.MEETING_DETAIL && this.NewActivitySource !== ActivitySource.MEETING_PRESENTATION) {
          this.activityOfflineService.selectedActivity = newSurgeryOrder;
        } else {
          this.surgeryOrderActivityDataService.inMeetingSurgeryOrderActivity = newSurgeryOrder;
        }
        this.trackingService.tracking('ProcedureLogCreate',TrackingEventNames.PROCEDURE_LOG);
      }).catch(err => {
        // Handle any error occured during order activity creation
        reject('error occured while creating new order');
        errorOccured = true;
      });
      if (this.activityOfflineService.activitySource === ActivitySource.MEETING_DETAIL || this.NewActivitySource === ActivitySource.MEETING_PRESENTATION) {
        if (this.uiService.activitiesPageTab == 'day' || this.activityOfflineService.newHomeView === 'calendarView') {
          let data = {
            id: newSurgeryOrder.ID,
            subject: newSurgeryOrder.subject,
            location: (newSurgeryOrder.accountId) ? newSurgeryOrder.accountNameString : 'No Account',
            scheduledStart: newSurgeryOrder.scheduledStart,
            scheduledEnd: newSurgeryOrder.scheduledEnd,
            type: newSurgeryOrder.type,
          };
          this.uiService.setUIServiceData({
            view: 'new-activity', data,
          });
        }
        this.activityOfflineService.finalizeAgendaRefresh();
        resolve('');
        return;
      }
      if (!errorOccured) {
        let from: any = PageName.GoAppHomeComponent;
        let pageName: PageName = PageName.GoAppActivitiesPageComponent;
        if (this.isLayoverPushView) {
          if (this.currentMasterPage == PageName.AccountPageComponent) {
            from = 'ProcedureLogFromAccountTool';
            pageName = PageName.AccountPageComponent;
            this.uiService.activeView = 'AccountPageRightPaneNav';
            this.uiService.showNewActivity = false;
            await this.navService.popChildNavPageWithPageTracking();
            this.pushChildNavPageWithPageTracking(PageName.SurgeryOrderDetailsComponent, PageName.SurgeryOrderDetailsComponent, PageName.AccountPageComponent, { from: from, activity: newSurgeryOrder });
          }
          else if (this.currentMasterPage == PageName.ContactPageComponent) {
            from = 'ProcedureLogFromContactTool';
            pageName = PageName.ContactPageComponent;
            this.uiService.activeView = 'ContactPageRightPaneNav';
            this.uiService.showNewActivity = false;
            await this.navService.popChildNavPageWithPageTracking();
            this.pushChildNavPageWithPageTracking(PageName.SurgeryOrderDetailsComponent, PageName.SurgeryOrderDetailsComponent, PageName.ContactPageComponent, { from: from, activity: newSurgeryOrder });
          }
          else if (this.currentMasterPage == PageName.OpportunityManagementPage && this.layoverViewPushedFrom == 'OpportunityManagementTool') {
            from = 'OpportunityManagementTool';
            pageName = PageName.OpportunityManagementPage;
            this.uiService.showNewActivity = false;
            this.uiService.isFromOpportunites = true;
            await this.navService.popChildNavPageWithPageTracking();
            this.pushChildNavPageWithPageTracking(PageName.SurgeryOrderDetailsComponent, PageName.SurgeryOrderDetailsComponent, PageName.OpportunityManagementPage, { from: from, activity: newSurgeryOrder });
          }
          else if (this.currentMasterPage == PageName.MarketingPlanManagementPageComponent && this.layoverViewPushedFrom == 'MarketingPlanInfoopportunities') {
            from = 'MarketingPlanOpportunities';
            pageName = PageName.MarketingPlanManagementPageComponent;
            this.uiService.showNewActivity = false;
            await this.navService.popChildNavPageWithPageTracking();
            this.pushChildNavPageWithPageTracking(PageName.SurgeryOrderDetailsComponent, PageName.SurgeryOrderDetailsComponent, PageName.MarketingPlanManagementPageComponent, { from: from, activity: newSurgeryOrder });
          }
        } else {
          this.trackingService.tracking('AgendaNewSurgeryOrder', TrackingEventNames.SURGERY_ORDER);
          this.navService.setChildNavRoot(PageName.SurgeryOrderDetailsComponent, PageName.SurgeryOrderDetailsComponent, PageName.GoAppActivitiesPageComponent, { from: from, activity: newSurgeryOrder });
          this.uiService.activeView = 'ActivitiesPageRightPaneNav';
          this.uiService.showNewActivity = false;
          this.uiService.showRightPane = true;
          this.activityOfflineService.selectedActivityAtHome = this.activityOfflineService.selectedActivity;
          if (this.uiService.activitiesPageTab == 'day' || this.activityOfflineService.newHomeView === 'calendarView') {
            let data = {
              id: newSurgeryOrder.ID,
              subject: newSurgeryOrder.subject,
              location: (newSurgeryOrder.accountId) ? newSurgeryOrder.accountNameString : 'No Account',
              scheduledStart: newSurgeryOrder.scheduledStart,
              scheduledEnd: newSurgeryOrder.scheduledEnd,
              type: newSurgeryOrder.type,
            };
            this.uiService.setUIServiceData({
              view: 'new-activity', data,
            });
          }
        }
        this.activityOfflineService.finalizeAgendaRefresh();
        resolve('');
      } else {
        reject('Error occured while creating a new order');
      }
    });
  }

  private async handleNewProcedureTrackerCreation(): Promise<any> {
    return new Promise(async (resolve, reject) => {
      let errorOccured: boolean = false;
      let currentTime = new Date().getTime();

      const dates = this._validateAndCalculateOrderDates(reject);
      if (!dates) return;

      const { start, end, startOfWeek, endOfWeek, isWeeklyFlag } = dates;

      // Procedure-tracker-specific future checks (daily and weekly)
      if (this.agendaFooterService.actSegment === 'week') {
        if (this.dateTimeFormatsService.isFutureDate(this.startTime) && !this.dateTimeFormatsService.isTodayDate(this.startTime) && !isWeeklyFlag) {
          this.notificationService.notify(this.translate.instant('DAILY_PROCEDURE_TRACKER_FUTURE'), 'New Activity', 'top', ToastStyle.DANGER);
          reject('bulk procedure log should not be created in future dates');
          return;
        }
      }
      if (isWeeklyFlag) {
        const currentWeek: Date = this.dateTimeFormatsService.getStartOfWeek(new Date());
        if (this.dateTimeFormatsService.isAfterDate(startOfWeek, currentWeek)) {
          this.notificationService.notify(this.translate.instant('WEEKLY_PROCEDURE_TRACKER_FUTURE'), 'New Activity', 'top', ToastStyle.DANGER);
          reject('bulk procedure log should not be created in future week');
          return;
        }
        const firstDay = this.dateTimeFormatsService.formatDate(this.dateTimeFormatsService.getStartOfWeek(new Date(start)), 'MMM DD, YYYY');
        const lastDay = this.dateTimeFormatsService.formatDate(this.dateTimeFormatsService.getEndOfWeek(new Date(start)), 'MMM DD, YYYY');
        this.notificationService.notify(this.translate.instant('PROCEDURE_LOG_FOR_WEEK', { startDate: firstDay, endDate: lastDay }), 'New Activity', 'top', ToastStyle.INFO);
      }

      let orderName: string = 'Bulk Procedure Log';
      let detailsComponent: PageName = PageName.ProcedureTrackerDetailsComponent;
      let detailsPageName: PageName = PageName.ProcedureTrackerDetailsComponent;
      let payload: any = {
        salesorderid: 'offline_proceduretracker_' + currentTime,
        indskr_externalid: 'offline_proceduretracker_' + currentTime,
        indskr_ordertype: 548910002,
        ordernumber: 'Surgery Order',
        name: orderName,
        pendingPushToDynamics: true,
        statuscode: 1,
        statecode: 0,
        activitytypecode: 'ProcedureTracker',
        createdon: currentTime,
        modifiedon: currentTime + '',
        scheduledstart: (isWeeklyFlag) ? startOfWeek : new Date(start).getTime(),
        scheduledend: (isWeeklyFlag) ? endOfWeek : new Date(end).getTime(),
        divisionName: this.authService.user.businessUnitName,
        divisionId: this.authService.user.xBusinessUnitId,
      }

      // Set auto-subject name before binding context so the helper can still override customerid/customerName
      if (this.currentMasterPage === PageName.AccountPageComponent && this.layoverViewPassedData
        && !(this.NewActivitySource === ActivitySource.MEETING_PRESENTATION || this.activityOfflineService.activitySource == ActivitySource.MEETING_DETAIL)) {
        if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.AUTO_SUBJECT_PROCEDURE_TRACKER)) {
          payload['name'] = this.dateTimeFormatsService.formatDate(startOfWeek, 'YYYY-MM-DD') + ' ' + this.layoverViewPassedData.accountName;
        }
      }

      this._bindContextToOrderPayload(payload, isWeeklyFlag);

      let newProcedureTracker = new ProcedureTrackerActivity(payload);
      if (isWeeklyFlag) {
        newProcedureTracker.scheduledEnd = endOfWeek;
      }
      newProcedureTracker.statusString = 'Draft';
      newProcedureTracker.modifiedby = newProcedureTracker.ownerId = this.authenticationOfflineService.user.systemUserID;
      newProcedureTracker.modifiedByName = newProcedureTracker.ownerNameString = this.authenticationOfflineService.user.displayName;
      newProcedureTracker.ownerNameString = this.authenticationOfflineService.user.displayName;
      if (this.NewActivitySource === ActivitySource.MEETING_PRESENTATION || this.activityOfflineService.activitySource == ActivitySource.MEETING_DETAIL) {
        if (!this.activityOfflineService.selectedActivity.ID.includes('offline')) {
          newProcedureTracker.appointmentId = this.activityOfflineService.selectedActivity.ID;
        }
        newProcedureTracker.offlineMeetingId = (this.activityOfflineService.selectedActivity as AppointmentActivity).offlineMeetingId;
      }

      // Prefill Meeting Account and Contact if any
      if ((this.NewActivitySource === ActivitySource.MEETING_PRESENTATION || this.activityOfflineService.activitySource === ActivitySource.MEETING_DETAIL)) {
        if (this.activityOfflineService.selectedActivity && this.activityOfflineService.selectedActivity.type == ActivityType.Appointment && (this.activityOfflineService.selectedActivity as AppointmentActivity).accounts && (this.activityOfflineService.selectedActivity as AppointmentActivity).accounts.length == 1) {
          newProcedureTracker.accountId = (this.activityOfflineService.selectedActivity as AppointmentActivity).accounts[0].id;
          newProcedureTracker.accountNameString = (this.activityOfflineService.selectedActivity as AppointmentActivity).accounts[0].accountName;
        }
      }
      const procedureLogAction = {
        onDynamics: (this.device.isOffline) ? false : ((this.NewActivitySource === ActivitySource.MEETING_PRESENTATION || this.activityOfflineService.activitySource == ActivitySource.MEETING_DETAIL) ? !!newProcedureTracker.appointmentId : true),
        onLocalCopy: true,
        onLocalDatabase: true
      }

      // validation here;
      if (newProcedureTracker.accountId) {
        const procedureTrackerExists = await this.procedureTrackerActivityDataService.isDuplicateProceureTrackerExists(newProcedureTracker.accountId, {
          scheduledStart: payload.scheduledstart,
          scheduledEnd: payload.scheduledend
        }).catch(err => {
          this.notificationService.notify(this.translate.instant('ADDING_ACCOUNTS_TO_PROCEDURE_TRACKER_FAILED'), 'Order Details', 'top', ToastStyle.DANGER);
        });

        if (procedureTrackerExists === undefined) {  // if there is dynamics error
          return reject();
        }

        if (procedureTrackerExists) {
          this.notificationService.notify(this.translate.instant('DUPLICATE_PROCEDURE_TRACKER', {
            accountName: newProcedureTracker.accountNameString,
            startDate: this.dateTimeFormatsService.formatDate(payload.scheduledstart, 'DD MMM YYYY'),
            endDate: this.dateTimeFormatsService.formatDate(payload.scheduledend, 'DD MMM YYYY')
          }),
            'Order Details', 'top', ToastStyle.INFO, 10000);
          return reject();
        }
      }
      // validation here


      await this.procedureTrackerActivityDataService.createOrderActivity(procedureLogAction, [newProcedureTracker], currentTime, false).then(succ => {
        //Successfully created new surgery order activity
        if (this.activityOfflineService.activitySource !== ActivitySource.MEETING_DETAIL && this.NewActivitySource !== ActivitySource.MEETING_PRESENTATION) {
          this.activityOfflineService.selectedActivity = newProcedureTracker;
        } else {
          this.procedureTrackerActivityDataService.inMeetingProcedureTrackerActivity = newProcedureTracker;
        }
      }).catch(err => {
        // Handle any error occured during order activity creation
        reject('error occured while creating new order');
        errorOccured = true;
      });
      if (this.activityOfflineService.activitySource === ActivitySource.MEETING_DETAIL || this.NewActivitySource === ActivitySource.MEETING_PRESENTATION) {
        if (this.uiService.activitiesPageTab == 'day' || this.activityOfflineService.newHomeView === 'calendarView') {
          let data = {
            id: newProcedureTracker.ID,
            subject: newProcedureTracker.subject,
            location: (newProcedureTracker.accountId) ? newProcedureTracker.accountNameString : 'No Account',
            scheduledStart: newProcedureTracker.scheduledStart,
            scheduledEnd: newProcedureTracker.scheduledEnd,
            type: newProcedureTracker.type,
          };
          this.uiService.setUIServiceData({
            view: 'new-activity', data,
          });
        }
        this.activityOfflineService.finalizeAgendaRefresh();
        resolve('');
        return;
      }
      if (!errorOccured) {
        let from: string = 'AgendaView';
        let pageName: PageName = PageName.GoAppActivitiesPageComponent;
        if (this.isLayoverPushView) {
          if (this.currentMasterPage == PageName.AccountPageComponent) {
            from = 'ProcedureLogFromAccountTool';
            pageName = PageName.AccountPageComponent;
            this.uiService.activeView = 'AccountPageRightPaneNav';
          }
          else if (this.currentMasterPage == PageName.ContactPageComponent) {
            from = 'ProcedureLogFromContactTool';
            pageName = PageName.ContactPageComponent;
            this.uiService.activeView = 'ContactPageRightPaneNav';
          } else if(this.currentMasterPage == PageName.OpportunityManagementPage) {
            from = 'OpportunityManagementTool';
          }else if(this.currentMasterPage == PageName.MarketingPlanManagementPageComponent) {
            from = 'MarketingPlanOpportunities';
          }
          this.uiService.showNewActivity = false;
          await this.navService.popChildNavPageWithPageTracking();
          this.pushChildNavPageWithPageTracking(detailsComponent, detailsPageName, pageName, { from: from, activity: newProcedureTracker });
        } else {
          this.trackingService.tracking('AgendanewProcedureTracker', TrackingEventNames.PROCEDURE_TRACKER);
          this.navService.setChildNavRoot(detailsComponent, detailsPageName, pageName, { from: from, activity: newProcedureTracker });
          this.uiService.activeView = 'ActivitiesPageRightPaneNav';
          this.uiService.showNewActivity = false;
          this.uiService.showRightPane = true;
          this.activityOfflineService.selectedActivityAtHome = this.activityOfflineService.selectedActivity;
          if (this.uiService.activitiesPageTab == 'day' || this.activityOfflineService.newHomeView === 'calendarView') {
            let data = {
              id: newProcedureTracker.ID,
              subject: newProcedureTracker.subject,
              location: (newProcedureTracker.accountId) ? newProcedureTracker.accountNameString : 'No Account',
              scheduledStart: newProcedureTracker.scheduledStart,
              scheduledEnd: newProcedureTracker.scheduledEnd,
              type: newProcedureTracker.type,
            };
            this.uiService.setUIServiceData({
              view: 'new-activity', data,
            });
          }
        }
        this.activityOfflineService.finalizeAgendaRefresh();
        resolve('');
      } else {
        reject('Error occured while creating a new order');
      }
    });
  }

  /**
   * Shared validation and date calculation for surgery order / procedure tracker creation.
   * Returns null if validation fails (rejection already called).
   * Does not fire the weekly notification — callers must do that after their own validations.
   */
  private _validateAndCalculateOrderDates(
    reject: (reason?: any) => void
  ): { start: string; end: string; startOfWeek?: Date; endOfWeek?: Date; isWeeklyFlag: boolean } | null {
    const isWeeklyFlag = ('Weekly' === this.authenticationOfflineService.user.procedureLogDuration);

    if (!isWeeklyFlag && !this.activityOfflineService.validateProcedureDate(this.startTime, 'DATETIME_P_CANT_SHEDULE_PROCEDURE_LOG_DAYS_AGO')) {
      reject('you cannot schedule a procedure log for more than the past activity grace period.');
      return null;
    }

    let start: string;
    if (this.agendaFooterService.actSegment === 'week') {
      if (this.dateTimeFormatsService.isFutureDate(this.startTime) && !this.dateTimeFormatsService.isTodayDate(this.startTime) && this.procedureCategory == 'noProcedureDay') {
        this.notificationService.notify(this.translate.instant('SHEDULE_PROCEDURE_LOG_FUTURE'), 'New Activity', 'top', ToastStyle.DANGER);
        reject('no procedure day should be created in today and in past');
        return null;
      }
      start = this.dateTimeFormatsService.toISOString(Utility.getRoundedDownTime(new Date(this.startTime)));
    } else {
      start = this.dateTimeFormatsService.toISOString(Utility.getRoundedDownTime(new Date()));
    }
    const end = this.dateTimeFormatsService.toISOString(this.dateTimeFormatsService.addMinutesToDate(start, 30));

    let startOfWeek: Date | undefined;
    let endOfWeek: Date | undefined;
    if (isWeeklyFlag) {
      startOfWeek = this.dateTimeFormatsService.getStartOfWeek(new Date(start));
      endOfWeek = this.dateTimeFormatsService.getEndOfWeek(new Date(start));
    }

    return { start, end, startOfWeek, endOfWeek, isWeeklyFlag };
  }

  /**
   * Binds account, opportunity, and meeting context to an order payload.
   * Shared between surgery order and procedure tracker creation.
   */
  private _bindContextToOrderPayload(
    payload: any,
    isWeeklyFlag: boolean
  ): void {
    // Account context from account page
    if (this.currentMasterPage === PageName.AccountPageComponent && this.layoverViewPassedData
      && !(this.NewActivitySource === ActivitySource.MEETING_PRESENTATION || this.activityOfflineService.activitySource == ActivitySource.MEETING_DETAIL)) {
      payload['customerid'] = this.layoverViewPassedData.id;
      payload['customerName'] = this.layoverViewPassedData.accountName;
    }

    // Opportunity context
    if (this.layoverViewPushedFrom == 'OpportunityManagementTool'
      || this.layoverViewPushedFrom == 'AccountProfileOpportunities'
      || this.from == 'AccountPlanOpportunities'
      || this.from == 'MarketingPlanInfoopportunities') {
      if (this.layoverViewPassedData) {
        payload['opportunityid'] = this.layoverViewPassedData.ID;
        payload['opportunityName'] = this.layoverViewPassedData.opportunityName;
        payload['customerid'] = this.layoverViewPassedData.accountID || '';
        payload['customerName'] = this.layoverViewPassedData.accountName || '';

        let oppObj: Opportunities = {
          indskr_opportunity: this.layoverViewPassedData.ID,
          indskr_procedurelogopportunityid: this.layoverViewPassedData.salesorderid,
          deleted: false
        };
        payload['opportunities'] = [oppObj];
      }
    }

    // Meeting context — override scheduled times
    if (!isWeeklyFlag && (this.NewActivitySource === ActivitySource.MEETING_PRESENTATION || this.activityOfflineService.activitySource === ActivitySource.MEETING_DETAIL && this.activityOfflineService.selectedActivity)) {
      payload['scheduledstart'] = (this.activityOfflineService.selectedActivity as AppointmentActivity).scheduledStart.getTime();
      payload['scheduledend'] = (this.activityOfflineService.selectedActivity as AppointmentActivity).scheduledEnd.getTime();
    }
  }

  public async createDraftEmail() {
    this.trackingService.tracking('AgendaEmailCreated', TrackingEventNames.ACTIVITY);
    let scheduleTime = new Date().getTime().toString();
    let request: any
    let activity: any;
    if ((this.agendaFooterService.actSegment === "week" || this.activityOfflineService.newHomeView === 'calendarView') && this.startTime && this.cellData) {
      const selectedDate: Date = new Date(this.startTime);
      if (this.dateTimeFormatsService.isPastDate(selectedDate)) {
        let channelType: string = (this.selectedMessagingChannelType.channelType) ? this.selectedMessagingChannelType.channelType : this.translate.instant("MESSAGE");
        this.notificationService.notify(this.translate.instant("MESSAGE_ACTIVITY_UNABLE_SCHEDULE_EMAIL", { type: channelType }), 'New Activity', 'top', ToastStyle.DANGER);
        return;
      }
      scheduleTime = selectedDate.getTime().toString();
    }
    let emailParties: EmailActivityParty[] = [];
    if (this.currentMasterPage == PageName.CallPlanComponent
      || (this.currentMasterPage == PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPageTab === 'plans' && this.uiService.activitiesPagePlanTabSelectedPlan === 'goalsPlansTab')) {
      this.callPlanService.callPlanPageView = 'CallPlanNewEmailDetails';
      let selectedContactId = '';
      if(!isEmpty(this.callPlanOfflineService.selectedRepCallPlan)) {
        selectedContactId = this.callPlanOfflineService.selectedRepCallPlan['contactId'];
      }else if(this.uiService.activitiesPagePlanTabSelectedPlan === 'goalsPlansTab' && !isEmpty(this.contactService.contactInformation)) {
        selectedContactId = this.contactService.contactInformation['ID'];
      }
      const contacts = selectedContactId ? this.contactService.getContactByID(selectedContactId) : false;
      if (contacts) {
        if (!this.isActiveContact(contacts)) return;
        let credentailsNotFoud = await this.validateChannelCredentails(contacts)
        if (credentailsNotFoud) {
          this.cancelNewActivity();
          // stop execution when there is no credentails for selected channel.
          this.navService.popChildNavPageWithPageTracking();
          return;
        }
        await this.emailService.fetchDoNotEmailForSelectedContacts([contacts]);
        emailParties = await this.getEmailParties(contacts)
      }
    }
    const isSkipConsentForFirstTimeEmailFlow: boolean = this.isSkipConsentForFirstTimeEmailFlow || false;

    if (this.currentMasterPage == PageName.ContactPageComponent || this.currentMasterPage == PageName.ScientificActivityPage || this.currentMasterPage == PageName.CustomerCallPlanPage
      || (this.currentMasterPage == PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPageTab === 'plans' && this.uiService.activitiesPagePlanTabSelectedPlan === 'scientificPlans')) {
      this.callPlanService.callPlanPageView = '';
      const contacts = this.contactService.contactInformation ? this.contactService.getContactByID(this.contactService.contactInformation['ID']) : false;
      if (contacts) {
        if (!this.isActiveContact(contacts)) return;
        if (!isSkipConsentForFirstTimeEmailFlow) {
          let credentailsNotFoud = await this.validateChannelCredentails(contacts);
          if (credentailsNotFoud) {
            this.navService.popChildNavPageWithPageTracking();
            return;
          }
          await this.emailService.fetchDoNotEmailForSelectedContacts([contacts]);
          emailParties = await this.getEmailParties(contacts)
        } else {
          emailParties = await this.getEmailPartiesForFirstTimeEmail(contacts)
        }
      }
    }
    let payload = {
      scheduledstart: scheduleTime,
      scheduledend: scheduleTime,
      subject: this.selectedMessagingChannelType.channelType,
      statuscode: 1,
      channelType: this.selectedMessagingChannelType.channelType,
      channelId: this.selectedMessagingChannelType.id,
      channelActivityType: this.selectedMessagingChannelType.activityType
    };
    if (isSkipConsentForFirstTimeEmailFlow) {
      payload['indskr_type'] = EmailTemplateType.FirstTimeEmail;
    }
    activity = await this.emailService.createNewEmailActivity(payload, false);
    if (activity) {
      if (this.currentMasterPage !== PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPagePlanTabSelectedPlan !== 'goalsPlansTab') this.uiService.activeView = 'Email';
      let data = {
        id: activity.ID, subject: activity.subject, info: activity.info, type: activity.type,
        scheduledStart: activity.scheduledStart, scheduledEnd: activity.scheduledEnd,
      };
      this.activityOfflineService.addActivity(activity);
      if (this.uiService.activitiesPageTab === 'day') {
        this.uiService.setUIServiceData({
          view: 'new-activity', data
        });
      }
      this.emailService.selectedActivity = activity;

      if (this.layoverViewPushedFrom === PageName.CustomerCallPlanDetails && this.authService.hasFeatureAction(FeatureActionsMap.EMAIL_ACCOUNT_INFORMATION_CAPTURE)) {
        if (this.layoverViewPassedData) {
          const accountId = this.layoverViewPassedData.id || '';
          const foundAccount = this.accountService.getAccountById(accountId);
          if (foundAccount) {
            this.emailService.selectedActivity['accounts'] = [];
            this.emailService.selectedActivity.accounts.push(foundAccount);
            let selectedAccount = [];
            if (this.emailService.selectedActivity.accounts) {
              this.emailService.selectedActivity.accounts.map(account => {
                selectedAccount.push({
                  indskr_accountid: account.id,
                });
              });
            }
            const payloadSelectedAccount = {
              accounts : selectedAccount
            }
            if (!this.device.isOffline) {
              try {
                await this.emailDataService.sendEmailExternalActivity(payloadSelectedAccount, this.emailService.selectedActivity.activityid);
              } catch(error) {
                console.error(error);
              }
            }
          }
        }
      }

      this.emailService.setCurrentEmail(this.emailService.selectedActivity);
      this.emailService.viewType = EmailViewType.FROM_AGENDA;
      this.uiService.showNewActivity = false;
      this.activityService.activityDetailsLoaded = true;
      this.activityOfflineService.finalizeAgendaRefresh();
      this.activityOfflineService.publishActivityEvent({ action: "Create", activity: this.emailService.selectedActivity });
      this.emailService.setCurrentEmail(activity);

      if(this.layoverViewPushedFrom === 'OpportunityManagementTool') {
        await this.opportunityDataService.addMessageToOpportunity(this.layoverViewPassedData as Opportunity, activity.ID).then((response) => {
          // update email with opportunity reference
          activity.opportunityReference = [{
            opportunityId: this.layoverViewPassedData.ID,
            opportunityName: this.layoverViewPassedData.name,
            activityId: activity.ID
          }];
          this.diskService.updateOrInsertActivityToActivityDetailRawDocument(activity, true);
        }).catch((error) => {
          console.error(error);
        });
      }
      if (!isEmpty(emailParties)) {
        await this.emailService.updateEmailActivityParties(emailParties);
      }
    }
    if (this.NewActivitySource === 'MeetingPresentation') {
      this.emailService.viewType = EmailViewType.EMAIL_FROM_MEETING_PRESENTATION;
      this.navService.setChildNavRoot(PageName.EmailDetailsPageComponent, PageName.EmailDetailsPageComponent, PageName.PresentationMeetingComponent);
    } else {
      this.activityOfflineService.selectedActivity = activity;
    }
    if (this.layoverViewPushedFrom == 'ScientificActivityPage') {
      this.emailService.viewType = EmailViewType.FROM_SCIENTIFIC_PLAN;
      if (this.uiService.activitiesPagePlanTabSelectedPlan === 'scientificPlans') {
        this.uiService.activeView = 'ActivitiesPageRightPaneNav';
        this.uiService.showNewActivity = false;
        this.uiService.showRightPane = true;
        this.navService.popChildNavPageWithPageTracking();
      }
      this.pushChildNavPageWithPageTracking(PageName.EmailDetailsPageComponent, PageName.EmailDetailsPageComponent, PageName.ScientificActivityDetail, { modalView: {} });
    } else if (this.currentMasterPage == PageName.CallPlanComponent) {
      this.callPlanService.callPlanPageView = 'CallPlanNewEmailDetails';
      this.navService.popChildNavPageWithPageTracking();
      this.pushChildNavPageWithPageTracking(PageName.EmailDetailsPageComponent, PageName.EmailDetailsPageComponent, PageName.CallPlanComponent, { from: PageName.CallPlanDetails });
    }
    else if (this.currentMasterPage == PageName.CustomerCallPlanPage) {
      this.callPlanService.callPlanPageView = 'CallPlanNewEmailDetails';
      this.navService.popChildNavPageWithPageTracking();
      this.pushChildNavPageWithPageTracking(PageName.EmailDetailsPageComponent, PageName.EmailDetailsPageComponent, PageName.CustomerCallPlanPage, { from: PageName.CustomerCallPlanDetails });
    }
    else if (this.currentMasterPage == PageName.GoAppActivitiesPageComponent) {
      this.uiService.activeView = 'ActivitiesPageRightPaneNav';
      this.uiService.showNewActivity = false;
      this.uiService.showRightPane = true;
      if (this.uiService.activitiesPagePlanTabSelectedPlan === 'goalsPlansTab') {
        this.navService.popChildNavPageWithPageTracking();
        this.pushChildNavPageWithPageTracking(PageName.EmailDetailsPageComponent, PageName.EmailDetailsPageComponent, PageName.GoAppActivitiesPageComponent, { from: PageName.CallPlanDetails });
      }
      else {
        this.navService.setChildNavRoot(PageName.EmailDetailsPageComponent, PageName.EmailDetailsPageComponent, PageName.GoAppActivitiesPageComponent, { from: PageName.GoAppActivitiesPageComponent });
      }
    } else if (this.layoverViewPushedFrom === 'ContactPageComponent') {
      this.pushChildNavPageWithPageTracking(PageName.EmailDetailsPageComponent, PageName.EmailDetailsPageComponent, PageName.ContactPageComponent, { from: PageName.ContactPageComponent, isSkipConsentForFirstTimeEmailFlow: isSkipConsentForFirstTimeEmailFlow });
    } else if(this.layoverViewPushedFrom === 'OpportunityManagementTool') {
      this.pushChildNavPageWithPageTracking(PageName.EmailDetailsPageComponent, PageName.EmailDetailsPageComponent, PageName.OpportunityManagementPage, { from: PageName.OpportunityManagementPage });
    }
  }

  private isActiveContact(contact): boolean {
    if (!contact.isActive) {
      this.notificationService.notify(this.translate.instant('CONTACT_NO_LONGER_ACCESS'), 'Contact list', 'top', ToastStyle.DANGER);
      return false;
    }
    return true;
  }

  async validateChannelCredentails(contactDetails) {
    switch (this.selectedMessagingChannelType.activityType) {
      case ChannelActivityType.EMAIL:
        if (isEmpty(contactDetails.emailAddressList)) {
          this.notificationService.notify(this.translate.instant('NO_EMAIL_ADDRESS_ASSOCIATED'), 'New Activity', 'top', ToastStyle.INFO)
          return true;
        }
        break;

      case ChannelActivityType.FACEBOOK:
        if (isEmpty(contactDetails.indskr_facebookpsid)) {
          this.notificationService.notify(this.translate.instant('NO_FACE_ID_ASSOCIATED'), 'New Activity', 'top', ToastStyle.INFO)
          return true;
        }
        break;

      case ChannelActivityType.SMS:
        if ((isEmpty(contactDetails.indskr_whatsappid)) && (isEmpty(contactDetails.mobilePhone))) {
          this.notificationService.notify(this.translate.instant('NO_MOBILE_NUMBER_ASSOCIATED'), 'New Activity', 'top', ToastStyle.INFO)
          return true;
        }
        break;

      case ChannelActivityType.WHATSAPP:
        if ((isEmpty(contactDetails.indskr_whatsappid)) && (isEmpty(contactDetails.mobilePhone))) {
          this.notificationService.notify(this.translate.instant('NO_MOBILE_NUMBER_ASSOCIATED'), 'New Activity', 'top', ToastStyle.INFO)
          return true;
        }
        break

    }
  }

  async getEmailParties(contactDetails) {
    let emailAddress: EmailAddress[] = [];
    let emailAddresses: string[] = [];
    let emailParties: EmailActivityParty[] = [];
    // OMNI-61541: AMA No-Contact — do not add a flagged (donotemail) contact to the message.
    if (contactDetails && contactDetails.donotemail === true) {
      this.notificationService.notify(this.translate.instant('AMA_NO_CONTACT_CANNOT_BE_MESSAGED'), 'New Activity', 'top', ToastStyle.INFO);
      return emailParties;
    }
    for (let email of contactDetails.emailAddressList) {
      if (email.isPrimary) {
        email.isSelected = true;
        if(!emailAddresses.includes(email.emailAddressId)) {
          emailAddresses.push(email.emailAddressId);
          emailAddress.push(new EmailAddress(email.emailAddressId, email.emailAddress));
        }

      } else {
        email.isSelected = false;
      }
    }
    let emailParty: EmailActivityParty = new EmailActivityParty();
    emailParty.allowToRemove = true;
    emailParty.contact_firstname = contactDetails.firstName;
    emailParty.contact_lastname = contactDetails.lastName;
    emailParty.contact_mobilephone = contactDetails.mobilePhone;
    emailParty.contact_indskr_facebookpsid = contactDetails.indskr_facebookpsid;
    emailParty.indskr_contactid = contactDetails.ID;
    emailParty.emailAddresses = emailAddress;
     // OMNI-61541: propagate donotemail unconditionally (AMA No-Contact send-block is
     // independent of MESSAGE_CONSENT_REQUIRED).
     if (contactDetails.hasOwnProperty('donotemail') && contactDetails.donotemail !== undefined) {
      emailParty.donotemail = contactDetails.donotemail;
    }
    emailParties.push(emailParty);
    return emailParties;
  }

  async getEmailPartiesForFirstTimeEmail(contactDetails) {
    let emailAddress: EmailAddress[] = [];
    let emailParties: EmailActivityParty[] = [];
    let emailParty: EmailActivityParty = new EmailActivityParty();
    emailParty.allowToRemove = true;
    emailParty.contact_firstname = contactDetails.firstName;
    emailParty.contact_lastname = contactDetails.lastName;
    emailParty.contact_mobilephone = contactDetails.mobilePhone;
    emailParty.contact_indskr_facebookpsid = contactDetails.indskr_facebookpsid;
    emailParty.indskr_contactid = contactDetails.ID;
    emailParty.emailAddresses = emailAddress;
    emailParties.push(emailParty);
    return emailParties;
  }

  public setActiveView(viewType, subViewType?) {
    this.displayConflictAlert = false;

    if (this.activityCreationInProgress) return;

    if ((viewType == 'new-insight' || viewType == 'general-insight' || this.procedureCategory === 'procedure_tracker') && this.device.isOffline) return;
   
    this.selectedEvent = null;
    if (viewType == 'consent' && this.layoverViewPushedFrom != 'ContactPageComponent'
      && !(this.activityOfflineService.selectedActivity as AppointmentActivity)?.contacts?.length) {
      this.notificationService.notify(this.translate.instant('CONSENT_NEEDS_MEETING_CUSTOMER', { globalCustomerText: this.translatedGlobalCustomerText }), 'New Activity', 'top', ToastStyle.INFO);
      return;
    }
    if (viewType == 'meeting' || viewType == 'timeoff') {
      if (viewType === 'meeting' && this.isMeetingFormatRequired && !this.selectedMeetingActivityType) {
        this.notificationService.notify(this.translate.instant('SELECT_MEETING_FORMAT'), 'New Activity', 'top', ToastStyle.INFO);
        return;
      }
      // Set activeViewNewMeeting first to ensure it's set before duration calculations
      this.uiService.setActiveViewForNewMeeting(viewType, subViewType);
      
      let eventname = ''
      if (this.agendaFooterService.actSegment !== 'week') {
        setTimeout(() => {
          this.setCellData();
          this.initDateTimeFormFields();
        }, 0);
        if (this.navService.getCurrentPageName() == PageName.NewActivityComponent) {
          //mobile view confirmed
          if (this.currentMasterPage === PageName.GoAppActivitiesPageComponent) {
            //mobile view and agenda
            eventname = viewType == 'meeting' ? 'Schedule Activity from Activity screen' : 'Schedule Time Off from Activity screen';
          }
        }
        else if (this.navService.getCurrentPageName() == PageName.GoAppActivitiesPageComponent) {
          //agenda view on browser
          eventname = viewType == 'meeting' ? 'Schedule Activity from Activity screen' : 'Schedule Time Off from Activity screen';
        }
      }
      else {
        //calendar view on browser
        setTimeout(() => {
          this._initTimeForCalendarPage(true);
          this.setCellData();
          this.initDateTimeFormFields();
        }, 0);
        eventname = viewType == 'meeting' ? 'Schedule Activity from Calendar' : 'Schedule Time Off from Calendar';
      }
      this.trackingService.tracking(eventname, TrackingEventNames.ACTIVITY);
    }
    else if (viewType == 'phonecall') {
      this.trackingService.tracking(' Select Phone call', TrackingEventNames.PHONECALL, true);
      setTimeout(() => {
        this.setCellData();
        this._initTimeForCalendarPage(true);
        this.initDateTimeFormFields();
      }, 0);
    }
    else if (viewType == 'customerinquiry'){
      this.checkNumOfCaseList();
      if(this.activityOfflineService.activitySource === ActivitySource.PHONE_CALL_ACTIVITY_DETAIL)
        this.trackingService.tracking('Select inquiry', TrackingEventNames.PHONECALL);
      if(this.activityOfflineService.activitySource === ActivitySource.SET_BOOKING_ACTIVITY_DETAIL){
        this.checkNumOfCaseList();
        this.trackingService.tracking('Select inquiry', TrackingEventNames.KITBOOKING);
      }
    }
    else if (viewType == 'email' && this.activityOfflineService.activitySource === ActivitySource.PHONE_CALL_ACTIVITY_DETAIL) {
      this.trackingService.tracking('Select Message', TrackingEventNames.PHONECALL);
    }
    else if (viewType == 'consent') {
      if (this.layoverViewPushedFrom == 'ContactPageComponent') {
        this.selectConsentCustomer(this.contactService.contactInformation, true);
      } else {
        this.contactBeforeMeetingConsent = this.contactService.contactInformation;
        this.selectConsentCustomer((this.activityOfflineService.selectedActivity as AppointmentActivity).contacts[0], true);
      }
    } else if (viewType === 'accountVisit') {
      let eventDetail = 'Schedule Account Visit from Activity screen';
      if (this.agendaFooterService.actSegment !== 'week') {
        setTimeout(() => {
          this.setCellData();
          this.initDateTimeFormFields();
        }, 0);
      } else {
        eventDetail = 'Schedule Account Visit from Calendar';
        setTimeout(() => {
          this._initTimeForCalendarPage(true);
          this.initDateTimeFormFields();
        }, 0);
      }
      this.trackingService.tracking(eventDetail, TrackingEventNames.ACCOUNT_VISIT, true);
    } else if (viewType === 'storecheck') {
      setTimeout(() => {
        this.setCellData();
        this._initTimeForCalendarPage(true);
        this.initDateTimeFormFields();
      }, 0);
    } else if (viewType == 'kit_booking'){
      if(this.device.isOffline) return;
    }
    if (this.uiService.activeViewNewMeeting === 'timeoff' && viewType === 'timeoff') {
      // handle click again scenario
      this._newTimeOffCmp?.initDateTimeFormFields();
    }
    // Only set activeViewNewMeeting if not already set above (for meeting/timeoff)
    if (viewType !== 'meeting' && viewType !== 'timeoff') {
      this.uiService.setActiveViewForNewMeeting(viewType, subViewType);
    }
    if (
      viewType === 'meeting'
      || viewType === 'phonecall'
      || viewType === 'accountVisit'
    ) {
      this.activityOfflineService.signalConflictCheck$.next({ componentUuid: this.uuid, signal: true, start: new Date(this.startDateTime), end: new Date(this.endDateTime) });
    }

    this._cd.markForCheck();
    this.initHeaderOnOptionSelection();
    if(this.isConfirmEnabled && this.checkCustomValidation()){
      this.handleNewActivity().then(() => {
        this.onClose(true);
      });
    }
  }

  public isCreatingActivity(viewType: string, subViewType?: string): boolean {
    return this.activeActivityCreationView === viewType
      && (!subViewType || this.uiService.activeViewNewMeetingType === subViewType);
  }

  public hasVoiceNoteTakerEnabled = false;

  /**
   * Dictate-a-meeting entry: captures a voice note and, as the primary action,
   * creates a meeting from it (subject + notes pre-populated from the dictation,
   * stamped with the selected meeting format). Save for Later keeps the note in
   * My Notes instead. The button is disabled while a mandatory format is
   * unselected, matching the row's create gate.
   */
  public async openVoiceNoteCapture(): Promise<void> {
    if (this.isMeetingFormatRequired && !this.selectedMeetingActivityType) {
      return;
    }
    const format = this.selectedMeetingActivityType;
    const dictation = await this.injector.get(DictationFlowService).dictateNewMeeting(
      format?.indskr_activitytypeid,
      format ? this.localizationService.getTranslatedString(format.indskr_name, this.activityTypeTranslationEntity) : undefined,
    );
    if (!dictation) {
      return;
    }
    if (this.navService.getCurrentPageName() === PageName.NewActivityComponent) {
      this.navService.popWithPageTracking();
    }
    const { VoiceNoteMeetingService } = await import('@omni/services/voice-note/voice-note-meeting.service');
    const meeting = await this.injector.get(VoiceNoteMeetingService).createMeetingFromDictation(
      dictation.confirmed,
      format ? { activityTypeId: format.indskr_activitytypeid, activityTypeName: format.indskr_name } : undefined,
      { transcript: dictation.transcript, sourceNote: dictation.sourceNote },
    );

    if (!meeting) {
      this.notificationService.notify(
        this.translate.instant('SOMETHING_REALLY_BAD_HAPPENED'),
        'New Activity',
        'top',
        ToastStyle.DANGER,
      );
    }
  }

  private _startActivityCreation(): void {
    this.activeActivityCreationView = this.uiService.activeViewNewMeeting;
    this._cd.markForCheck();
  }

  private _finishActivityCreation(): void {
    this.activeActivityCreationView = '';
    this.meetingCreationInProgress = false;
    this._cd.markForCheck();
  }

  async createNewPhoneCall() {
    const payload: InitiatePhoneCallPayload = this._preparePhoneCallPayload();
    const newPhoneCall = await this.phoneCallDataService.createPhoneCallActivity(payload);
    if (newPhoneCall) {
      let data;
      if (!newPhoneCall.createdOffline) {
        // Online created meeting
        data = { id: newPhoneCall.ID };

        if (this.navService.getPreviousActiveChildNavViewPageName() === PageName.AccountPlanDetailsComponent) {
          let payload = [{
            activityPhoneCallId: Guid.create().toString(),
            activityId: newPhoneCall.ID
          }]
          this.accountManagementDataService.savePhoneCallsForAccountPlan(this.layoverViewPassedData.ID, payload).catch(error => console.error(error));
        }
      } else {
        // Offline created meeting
        data = {
          id: newPhoneCall.ID,
          subject: newPhoneCall.subject,
          location: newPhoneCall.location,
          scheduledStart: newPhoneCall.scheduledStart,
          scheduledEnd: newPhoneCall.scheduledEnd,
        };
      }
      this.uiService.setUIServiceData({
        view: 'new-activity', data,
      }); // this is an observable stream




      //Add the same phone number if creating follow up
      let phoneNumber = undefined
      if (this.followUpMeetingContacts.length > 0 && this.activityOfflineService.selectedActivity) {
        phoneNumber = (this.activityOfflineService.selectedActivity as PhoneActivity).selectedMobileNumber
      }


      if(this.navService.getPreviousActiveChildNavViewPageName() ===   PageName.AccountPlanDetailsComponent){
        newPhoneCall.accountPlanId = this.layoverViewPassedData.ID;
      }

      this.activityOfflineService.selectedActivity = newPhoneCall;



      let fieldsUpdated:boolean = false;

      // Set Default Values For IO Config Fields
      this.activityOfflineService.addIoConfigDefaultValuesToActivity(newPhoneCall);
      if(newPhoneCall instanceof PhoneActivity && newPhoneCall.appConfigFields && newPhoneCall.appConfigFields.length > 0){
        if (!this.device.isOffline && !this.activityOfflineService.hasOfflinePhoneCallData(newPhoneCall.ID)) {
          await this.phoneCallDataService.updateappConfigFields((newPhoneCall as PhoneActivity), newPhoneCall.appConfigFields, true);
        } else {
          await this.activityOfflineService.upsertPhoneCallOfflineData(this.activityOfflineService.selectedActivity as PhoneActivity);
        }
      }
      if (this.navService.getCurrentPageName() == PageName.GoAppActivitiesPageComponent) {
        this.uiService.showRightPane = true;
        this.uiService.activeView = 'PhoneCall';
        this.navService.setChildNavRoot(PageName.PhoneCallDetailsComponent, PageName.PhoneCallDetailsComponent, PageName.GoAppActivitiesPageComponent, { isNewlyCreatedActivity: true });
      }
      else if (this.currentMasterPage === PageName.ContactPageComponent) {
        if (this.contactService.contactInformation) { //add contact to new activity if created from contact profile
          let contact = this.contactService.getContactByID(this.contactService.contactInformation['ID']);
          if (contact) {
            this.contactService.moveContactToSelected(contact)
            newPhoneCall.selectedMobileNumber = contact.mobilePhone
            await this.phoneCallDataService.addContactsToPhoneCallActivity(newPhoneCall);
            let mobileNumberList = [];
            if (contact.mobilePhone || contact.telephone || contact.indskr_alternatephone1 || contact.indskr_alternatephone2 || contact.indskr_alternatephone3) {
              mobileNumberList.push({ 'phoneNumber': contact.mobilePhone ? contact.mobilePhone : '', 'identity': 'mobilePhone' })
              mobileNumberList.push({ 'phoneNumber': contact.indskr_alternatephone1 ? contact.indskr_alternatephone1 : '', 'identity': 'alternatephone1' })
              mobileNumberList.push({ 'phoneNumber': contact.indskr_alternatephone2 ? contact.indskr_alternatephone2 : '', 'identity': 'alternatephone2' })
              mobileNumberList.push({ 'phoneNumber': contact.indskr_alternatephone3 ? contact.indskr_alternatephone3 : '', 'identity': 'alternatephone3' })
              mobileNumberList.push({ 'phoneNumber': contact.telephone ? contact.telephone : '', 'identity': 'telephone' })
            }
            if (mobileNumberList.length) {
              const isNotEmpty = (element) => !isEmpty(element.phoneNumber);
              let index = mobileNumberList.findIndex(isNotEmpty);
              mobileNumberList[index].isChecked = true;
              (this.activityOfflineService.selectedActivity as PhoneActivity).selectedMobileNumber = mobileNumberList[index].phoneNumber
            }
            this.uiService.prevView = 'contactDetails';
            this.uiService.activeView = 'phoneCallTimelineDetails';
            this.uiService.showCancelDoneOnActivityDetails = true;
            this.footerService.initButtons(FooterViews.PHONE_CALL);
          }
        }
      } else if (this.currentMasterPage === PageName.AccountManagementPageComponent && this.layoverViewPassedData.accounts?.length == 1) {
        const accounts = [{ accountId: this.layoverViewPassedData.accounts[0].id, accountName: this.layoverViewPassedData.accounts[0].name }];
        newPhoneCall['accounts'].push(...accounts)
        this.activityOfflineService.selectedActivity['accounts'] = [];
        this.activityOfflineService.selectedActivity['accounts'].push(...accounts);
        fieldsUpdated = true;
      } else if (this.currentMasterPage === PageName.AccountPageComponent) {
        newPhoneCall['accounts'].push(this.layoverViewPassedData)
        this.activityOfflineService.selectedActivity['accounts'] = [];
        this.activityOfflineService.selectedActivity['accounts'].push(this.layoverViewPassedData);
        fieldsUpdated = true;
      } else if ((this.currentMasterPage === PageName.CallPlanComponent || this.currentMasterPage === PageName.CustomerCallPlanPage
        || (this.currentMasterPage == PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPageTab === 'plans' && this.uiService.activitiesPagePlanTabSelectedPlan == 'goalsPlansTab'))) {
        let contact = this.contactService.contactInformation ? this.contactService.getContactByID(this.contactService.contactInformation['ID']) : false;
        if (contact) {
          this.contactService.moveContactToSelected(contact);
          newPhoneCall.selectedMobileNumber = contact.mobilePhone;
          newPhoneCall.subject = `${contact.firstName} ${contact.lastName} - ${this.translate.instant('NEW_ACTIVITY_PHONECALL')}`
          await this.phoneCallDataService.addContactsToPhoneCallActivity(newPhoneCall);
          let mobileNumberList = [];
          if (contact.mobilePhone || contact.telephone || contact.indskr_alternatephone1 || contact.indskr_alternatephone2 || contact.indskr_alternatephone3) {
            mobileNumberList.push({ 'phoneNumber': contact.mobilePhone ? contact.mobilePhone : '', 'identity': 'mobilePhone' })
            mobileNumberList.push({ 'phoneNumber': contact.indskr_alternatephone1 ? contact.indskr_alternatephone1 : '', 'identity': 'alternatephone1' })
            mobileNumberList.push({ 'phoneNumber': contact.indskr_alternatephone2 ? contact.indskr_alternatephone2 : '', 'identity': 'alternatephone2' })
            mobileNumberList.push({ 'phoneNumber': contact.indskr_alternatephone3 ? contact.indskr_alternatephone3 : '', 'identity': 'alternatephone3' })
            mobileNumberList.push({ 'phoneNumber': contact.telephone ? contact.telephone : '', 'identity': 'telephone' })
          }
          if (mobileNumberList.length) {
            const isNotEmpty = (element) => !isEmpty(element.phoneNumber);
            let index = mobileNumberList.findIndex(isNotEmpty);
            mobileNumberList[index].isChecked = true;
            (this.activityOfflineService.selectedActivity as PhoneActivity).selectedMobileNumber = mobileNumberList[index].phoneNumber
          }
        }

        if (this.layoverViewPushedFrom === PageName.CustomerCallPlanDetails && this.layoverViewPassedData) {
          const accountId = this.layoverViewPassedData.id || '';
            const foundAccount = this.accountService.getAccountById(accountId);
            if (foundAccount) {
              newPhoneCall['accounts'].push(this.layoverViewPassedData)
              this.activityOfflineService.selectedActivity['accounts'] = [];
              this.activityOfflineService.selectedActivity['accounts'].push(this.layoverViewPassedData);
              fieldsUpdated = true;
            }
        }

        if (this.currentMasterPage == PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPageTab === 'plans' && this.uiService.activitiesPagePlanTabSelectedPlan == 'goalsPlansTab') {
          this.uiService.showRightPane = true;
        } else {
          this.uiService.prevView = 'callPlanDetails';
          this.uiService.activeView = 'phoneCallTimelineDetails';
          this.uiService.showRightPane = false;
        }
        this.navService.popChildNavPageWithPageTracking();
        if (this.currentMasterPage === PageName.CallPlanComponent) {
          this.pushChildNavPageWithPageTracking(PageName.PhoneCallDetailsComponent, PageName.PhoneCallDetailsComponent, PageName.CallPlanComponent, { from: PageName.CallPlanDetails, isNewlyCreatedActivity: true });
        } else {
          this.pushChildNavPageWithPageTracking(PageName.PhoneCallDetailsComponent, PageName.PhoneCallDetailsComponent, PageName.CustomerCallPlanPage, { from: PageName.CustomerCallPlanDetails, isNewlyCreatedActivity: true });
        }
        this.uiService.showCancelDoneOnActivityDetails = true;
        this.footerService.initButtons(FooterViews.PHONE_CALL);
      }

      //Add contacts from selected Activity to new created follow up activity
      if (this.followUpMeetingContacts.length > 0) {
        this.activityOfflineService.selectedActivity['contacts'] = [];
        this.followUpMeetingContacts.map(contact => {
          this.contactService.moveContactToSelected(contact);
        });
        newPhoneCall.selectedMobileNumber = phoneNumber
        await this.phoneCallDataService.addContactsToPhoneCallActivity(newPhoneCall);

        if (this.uiService.activitiesPageTab == 'agenda') {
          this.activityOfflineService.selectedActivityOnAgenda = this.activityOfflineService.selectedActivity;
        }

        this.contactService.followUpMeetingContacts = [];
      }

      if(fieldsUpdated){
        let phoneCallPayLoad = this.phoneCallDataService.setPhoneCallPayload(this.activityOfflineService.selectedActivity as PhoneActivity)
        if (!this.device.isOffline && !this.activityOfflineService.hasOfflinePhoneCallData(this.activityOfflineService.selectedActivity.ID)) {
          await this.phoneCallDataService.updatePhoneCall(this.activityOfflineService.selectedActivity as PhoneActivity, phoneCallPayLoad); //CWD-2414 Update the activity subject if auto subject feature action is enabled
        }
        else {
          await this.activityOfflineService.upsertPhoneCallOfflineData(this.activityOfflineService.selectedActivity as PhoneActivity);
        }
      }


      this.isLoaderOn = false;
      this.uiService.showNewActivity = false;
      this.activityService.activityDetailsLoaded = true;
      if (!this.uiService.toolsActivityActive) {
        this.events.publish("refreshAgenda");
        if (this.agendaFooterService.actSegment === 'week') {
          this.events.publish("weekview:RefreshUI"); // Refreshing the weekview for phone call activity.
        }
      }
      else {
        this.uiService.agendaRefreshRequired = true;
        this.activityOfflineService.signalActivityConflictCheck$.next(this.activityOfflineService.selectedActivity);
      }
      this.phoneCallMeetingStructureService.createEmbeddedInteractions(newPhoneCall);
      this.phoneCallDataService.saveMeeting(newPhoneCall);
    }
  }

  private clearContactJoinStatusOfCurrentSelectedMeeting() {
    if (this.activityOfflineService.selectedActivity instanceof AppointmentActivity && this.activityOfflineService.selectedActivity.contacts && this.activityOfflineService.selectedActivity.contacts.length > 0) {
      this.activityOfflineService.selectedActivity.contacts.map(contact => {
        if (this.contactService.getContactByID(contact.ID)) {
          this.contactService.getContactByID(contact.ID).connectionState = ContactMeetingState.NOTJOINED;
        }
      });
    }
  }

  /**
   * Creates a new meeting payload by concatenating data from the form and calling our meeting service initiate meeting fn
   *
   * @private
   * @memberof NewActivityComponent
   */
  async createNewMeeting(subtype?: string) {
    // Prevent multiple simultaneous meeting creations
    if (this.meetingCreationInProgress) return;

    this.meetingCreationInProgress = true;
    const payload = this._prepareMeetingPayloadWithSubtype(subtype);
    if (this.layoverViewPushedFrom === 'ContactPageComponent' && this.contactService.contactInformation) {
      const upfrontContact = this.contactService.getContactByID(this.contactService.contactInformation['ID']);
      if (upfrontContact) {
        payload.contacts = [upfrontContact];
      }
    }

    this._cd.markForCheck();
    
    try {
      const newMeeting = await this.meetingService.createNewMeeting(payload);
      
      if (!newMeeting) {
        this._handleMeetingCreationFailure();
        this.meetingCreationInProgress = false;
        return;
      }

      this.diskService.updateOrInsertActivityToActivityDetailRawDocument(newMeeting);
      
      // Handle live meeting event participants
      await this._handleLiveMeetingParticipants(subtype, newMeeting);
      
      // Set default values and update config fields
      await this._handleMeetingConfiguration(newMeeting);
  
      this.activityOfflineService.selectedActivity = newMeeting;
      if (!newMeeting['isCreatePendingSync']) {
        await this.activityOfflineService.upsertMeetingsOfflineData(newMeeting);
      }
      this.activityOfflineService.publishActivityEvent({ action: "Create", activity: this.activityOfflineService.selectedActivity });

      if (newMeeting && !this.meetingService.isErrorStartDateCreateMeeting) {
        const data = this._prepareMeetingData(newMeeting, payload);
        this.uiService.setUIServiceData({ view: 'new-activity', data });

        const isPlanViewFlow = this._isPlanViewFlow();
        
        if (this.isLayoverPushView && !isPlanViewFlow) {
          await this._handleLayoverViewFlow(newMeeting);
        } else if (isPlanViewFlow) {
          await this._handlePlanViewFlow(newMeeting);
        } else {
          await this._handleDefaultFlow(newMeeting);
        }

        // Handle post-creation tasks
        await this._handlePostCreationTasks(newMeeting);
      } else {
        this._handleMeetingCreationFailure();
        this.meetingCreationInProgress = false;
        return;
      }
    } catch (err) {
      console.error('Error occurred while creating new meeting activity' + err);
      this.uiService.showCancelDoneOnActivityDetails = true;
      this.meetingStructureService.createEmbeddedInteractions(null);
      this.meetingCreationInProgress = false;
      return;
    } finally {
      this.isLoaderOn = this.uiService.showNewActivity = false;
    }
  }

  /**
   * Prepares meeting data for UI service
   * @private
   */
  private _prepareMeetingData(newMeeting: any, payload: any) {
    if (!newMeeting.createdOffline) {
      return { id: newMeeting.ID, ...payload };
    } else {
      return {
        id: newMeeting.ID,
        subject: newMeeting.subject,
        location: newMeeting.location,
        scheduledStart: newMeeting.scheduledStart,
        scheduledEnd: newMeeting.scheduledEnd,
      };
    }
  }

  /**
   * Checks if current flow is plan view flow
   * @private
   */
  private _isPlanViewFlow(): boolean {
    return this.currentMasterPage === PageName.CallPlanDetails || 
           this.currentMasterPage === PageName.CallPlanComponent ||
           (this.currentMasterPage === PageName.GoAppActivitiesPageComponent && 
            this.uiService.activitiesPageTab === 'plans' && 
            this.uiService.activitiesPagePlanTabSelectedPlan === 'goalsPlansTab') ||
           this.currentMasterPage === PageName.CustomerCallPlanDetails || 
           this.navService.getCurrentMasterPageName() === PageName.CustomerCallPlanPage;
  }

  /**
   * Handles layover view flow
   * @private
   */
  private async _handleLayoverViewFlow(newMeeting: any) {
    switch (this.layoverViewPushedFrom) {
      case 'AccountManagementTool':
        await this._handleAccountManagementToolFlow(newMeeting);
        break;
      case 'AccountTool':
        await this._handleAccountToolFlow(newMeeting);
        break;
      case 'OpportunityManagementTool':
      case 'MarketingPlanInfoopportunities':
        await this._handleOpportunityFlow(newMeeting);
        break;
      case 'ProcedureLogFrom':
        await this._handleProcedureLogFlow(newMeeting);
        break;
      case 'ScientificActivityPage':
        await this._handleScientificActivityFlow(newMeeting);
        break;
      case 'PresentationToolsPage':
        await this._handlePresentationToolsFlow(newMeeting);
        break;
      case 'ContactPageComponent':
        await this.addContactToMeeting(newMeeting);
        break;
      case PageName.SetBookingActivityDetailsComponent:
        await this._handleSetBookingFlow(newMeeting);
        break;
    }
  }

  /**
   * Handles plan view flow
   * @private
   */
  private async _handlePlanViewFlow(newMeeting: any) {
    const contactId = this.callPlanOfflineService.selectedCallPlan?.contactId || '';
    const accountId = this.callPlanOfflineService.selectedCallPlan?.accountId || '';

    if (accountId) {
      await this._handleAccountPlanFlow(newMeeting, accountId);
    } else if (contactId) {
      await this._handleContactPlanFlow(newMeeting, contactId);
    }
  }

  /**
   * Handles default flow
   * @private
   */
  private async _handleDefaultFlow(newMeeting: any) {
    if (this.currentMasterPage === PageName.GoAppActivitiesPageComponent && !this.footerService.isActivitiesButton) {
      await this._handleActivitiesPageFlow(newMeeting);
    } else if (this.currentMasterPage === PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPageTab !== 'plans') {
      await this._handleActivitiesPageNonPlanFlow(newMeeting);
    }
  }

  /**
   * Handles post-creation tasks
   * @private
   */
  private async _handlePostCreationTasks(newMeeting: any) {
    // Handle account plan details
    if (this.navService.getPreviousActiveChildNavViewPageName() === PageName.AccountPlanDetailsComponent) {
      await this._handleAccountPlanDetailsTask(newMeeting);
    }

    // Raw relationship ids are useful later for edit/remove actions; do not block create/navigation on them.
    this._fetchActivityDetailsInBackground(newMeeting);
  

    const createFields = newMeeting['createRequestFields'] || {
      subject: newMeeting.subject,
      location: this.activityOfflineService.selectedActivity.location,
      scheduledStart: this.activityOfflineService.selectedActivity.scheduledStart,
      scheduledEnd: this.activityOfflineService.selectedActivity.scheduledEnd,
    };
    newMeeting.subject = await this.meetingService.setMeetingSubject(this.activityOfflineService.selectedActivity);
    const shouldSkipPatch = shouldSkipPostCreateMeetingPatch({
      isOffline: this.device.isOffline,
      hasOfflineData: this.activityOfflineService.hasOfflineMeetingData(newMeeting.ID),
      isAppointmentSecInfoConfigured: this.secondaryInfoService.isAppointmentSecInfoConfigured,
      createFields,
      finalFields: {
        subject: newMeeting.subject,
        location: this.activityOfflineService.selectedActivity.location,
        scheduledStart: this.activityOfflineService.selectedActivity.scheduledStart,
        scheduledEnd: this.activityOfflineService.selectedActivity.scheduledEnd,
      },
    });
    // Update meeting if online
    let updateMeetingPromise: Promise<void | boolean> = Promise.resolve();
    if (!shouldSkipPatch && !this.device.isOffline && !this.activityOfflineService.hasOfflineMeetingData(newMeeting.ID) && this.secondaryInfoService.isAppointmentSecInfoConfigured) {
      const payload = new UpdateMeetingPayload(
        newMeeting.subject,
        this.activityOfflineService.selectedActivity.location,
        this.activityOfflineService.selectedActivity.scheduledStart,
        this.activityOfflineService.selectedActivity.scheduledEnd
      );
      updateMeetingPromise = this.meetingService.updateMeeting(this.activityOfflineService.selectedActivity as AppointmentActivity, payload);
    }

    await updateMeetingPromise;

    if (!this.activityOfflineService.selectedActivity['isCreatePendingSync'] || !shouldSkipPatch) {
      await this.activityOfflineService.upsertMeetingsOfflineData(this.activityOfflineService.selectedActivity as AppointmentActivity);
    }

    // Refresh UI
    if (!this.uiService.toolsActivityActive) {
      this.events.publish("refreshAgenda");
    } else {
      this.uiService.agendaRefreshRequired = true;
      this.activityOfflineService.signalActivityConflictCheck$.next(this.activityOfflineService.selectedActivity);
    }
    
    if (this.agendaFooterService.actSegment === 'week') {
      this.events.publish('weekview:RefreshUI');
    }
    
    this.meetingStructureService.createEmbeddedInteractions(newMeeting);
    this.activityService.activityDetailsLoaded = true;
  }

  /**
   * Handles account management tool flow
   * @private
   */
  private async _handleAccountManagementToolFlow(newMeeting: any) {
    newMeeting.accountPlanId = this.layoverViewPassedData.ID;
    this.activityOfflineService.selectedActivity = newMeeting;
    
    if (this.layoverViewPassedData?.accounts?.length === 1) {
      this.activityOfflineService.selectedActivity['accounts'] = [];
      const account = this.accountService.getAccountById(this.layoverViewPassedData.accounts[0].id);
      this.accountService.moveAccountToSelected(account);
      
      (this.activityOfflineService.selectedActivity as AppointmentActivity).associatedAccountPlans.push({
        accountPlanId: this.layoverViewPassedData.ID,
        accountPlanName: this.layoverViewPassedData.accountPlanName
      });
      
      if (this.activityOfflineService.selectedActivity instanceof AppointmentActivity) {
        await this.activityOfflineService.upsertMeetingsOfflineData(this.activityOfflineService.selectedActivity);
        
        if (!this.device.isOffline && !this.activityOfflineService.hasOfflineMeetingData(this.activityOfflineService.selectedActivity.ID)) {
          await this.meetingService.addAccountsToMeeting(this.activityOfflineService.selectedActivity);
        }
        
        if (!newMeeting.ID.includes('offline')) {
          const accPlanPayload = (this.activityOfflineService.selectedActivity as AppointmentActivity).associatedAccountPlans.map(a => a.accountPlanId);
          this.meetingService.addAccountPlansToMeeting(this.activityOfflineService.selectedActivity as AppointmentActivity, accPlanPayload);
        }
      }
    }
  }

  /**
   * Handles account tool flow
   * @private
   */
  private async _handleAccountToolFlow(newMeeting: any) {
    this.activityOfflineService.selectedActivity = newMeeting;
    this.activityOfflineService.selectedActivity['accounts'] = [];
    const account = this.accountService.getAccountById(this.layoverViewPassedData.id);
    this.accountService.moveAccountToSelected(account);
    
    if (this.activityOfflineService.selectedActivity instanceof AppointmentActivity) {
      if (this.authService.user.buConfigs?.['indskr_populateaccountaddress']) {
        const selectedAddress = await this.accountService.getPrimaryAddressOfAccount(this.activityOfflineService.selectedActivity['accounts'][0].id);
        await this.accountService.addLocationToMeeting(this.activityOfflineService.selectedActivity, selectedAddress);
      }
      
      if (!this.device.isOffline && !this.activityOfflineService.hasOfflineMeetingData(this.activityOfflineService.selectedActivity.ID)) {
        await this.meetingService.addAccountsToMeeting(this.activityOfflineService.selectedActivity);
      }
      
      const affiliatedContacts = await this.contactService.getAffiliatedContactsFromAccountsForMeeting([account]);
      if (affiliatedContacts.length === 1) {
        await this._updateContactsOfSelectedMeeting(affiliatedContacts);
      }
    }
  }

  /**
   * Handles opportunity flow
   * @private
   */
  private async _handleOpportunityFlow(newMeeting: any) {
    this.activityOfflineService.selectedActivity = newMeeting;
    this.activityOfflineService.selectedActivity['accounts'] = [];
    
    (this.activityOfflineService.selectedActivity as AppointmentActivity).regardingObjectId = this.layoverViewPassedData.ID;
    (this.activityOfflineService.selectedActivity as AppointmentActivity).regardingObjectIdValue = this.layoverViewPassedData.opportunityName;
    
    if (this.layoverViewPassedData.accountID) {
      const account = this.accountService.getAccountById(this.layoverViewPassedData.accountID);
      this.accountService.moveAccountToSelected(account);
    }
    
    (this.activityOfflineService.selectedActivity as AppointmentActivity).associatedOpportunities.push({
      opportunityId: this.layoverViewPassedData.ID,
      opportunityName: this.layoverViewPassedData.opportunityName
    });

    const opportunity = this.layoverViewPassedData as Opportunity;
    if (opportunity) {
      await this._handleOpportunityDetails(newMeeting, opportunity);
    }
    
    if (this.activityOfflineService.selectedActivity instanceof AppointmentActivity) {
      await this.activityOfflineService.upsertMeetingsOfflineData(this.activityOfflineService.selectedActivity);
      
      if (!this.device.isOffline && !this.activityOfflineService.hasOfflineMeetingData(this.activityOfflineService.selectedActivity.ID) && this.layoverViewPassedData.accountID) {
        await this.meetingService.addAccountsToMeeting(this.activityOfflineService.selectedActivity);
      }
      
      if (!newMeeting.ID.includes('offline')) {
        (this.layoverViewPassedData as Opportunity).appointmentId = newMeeting.ID;
        const oppPayload = (this.activityOfflineService.selectedActivity as AppointmentActivity).associatedOpportunities.map(a => a.opportunityId);
        this.meetingService.addOpportunitiesToMeeting(this.activityOfflineService.selectedActivity as AppointmentActivity, oppPayload);
      }
    }
  }

  /**
   * Handles opportunity details
   * @private
   */
  private async _handleOpportunityDetails(newMeeting: any, opportunity: Opportunity) {
    const contactsToUpdate: Contact[] = [];
    
    // Add primary contact
    if (this.authService.hasFeatureAction(FeatureActionsMap.OPPORTUNITY_PRIMARY_TARGET) && 
        opportunity.primaryTargetValue === OpportunityPrimaryTraget.CONTACT && 
        opportunity.contactID) {
      const contact = this.contactService.getContactByID(opportunity.contactID);
      if (contact) {
        contactsToUpdate.push(contact);
      }
    }
    
    // Add stakeholders
    if (opportunity.stakeholders) {
      opportunity.stakeholders.forEach(stakeholder => {
        const contact = this.contactService.getContactByID(stakeholder.ID);
        if (contact && !contactsToUpdate.some(a => a.ID === contact.ID)) {
          contactsToUpdate.push(contact);
        }
      });
    }
    
    if (contactsToUpdate.length > 0) {
      contactsToUpdate.forEach(contact => {
        this.contactService.addToRecentContacts(contact);
      });
      await this._updateContactsOfSelectedMeeting(contactsToUpdate);
    }
    
    // Add products
    if (!(this.activityOfflineService.selectedActivity as AppointmentActivity).products) {
      const brands = JSON.parse(JSON.stringify(this.brandService.brands.filter(b => 
        !b.productApplicability.length || b.productApplicability.includes('100000000'))));
      (this.activityOfflineService.selectedActivity as AppointmentActivity).products = brands;
    }

    // Add procedures
    if (this.authService.hasFeatureAction(FeatureActionsMap.MEETING_PROCEDURE) && opportunity.surgeryId) {
      const foundProcedure = this.surgeryOrderActivityDataService.procedureTrackerProductHierarchies?.find(s => s.surgeryId === opportunity.surgeryId);
      if (foundProcedure) {
        const activityProcedure = new Brand({
          productid: foundProcedure.surgeryId,
          name: foundProcedure.surgeryName,
          productStructure: 3
        });
        (this.activityOfflineService.selectedActivity as AppointmentActivity).activityProcedures.push(activityProcedure);
        
        if (!this.device.isOffline) {
          await this.meetingService.updateMeetingProcedures(this.activityOfflineService.selectedActivity as AppointmentActivity);
        }
      }
    }
  }

  /**
   * Handles procedure log flow
   * @private
   */
  private async _handleProcedureLogFlow(newMeeting: any) {
    this.activityOfflineService.selectedActivity = newMeeting;
    
    if (this.activityOfflineService.selectedActivity instanceof AppointmentActivity) {
      await this.activityOfflineService.upsertMeetingsOfflineData(this.activityOfflineService.selectedActivity);
      
      if (this.device.isOffline) {
        (this.layoverViewPassedData as SurgeryOrderActivity).offlineMeetingId = newMeeting.ID;
      } else {
        (this.layoverViewPassedData as SurgeryOrderActivity).appointmentId = newMeeting.ID;
      }
      
      const action = {
        onDynamics: !this.device.isOffline,
        onLocalDatabase: true,
        onLocalCopy: true,
        operationDetail: {
          code: 'surgerOrderUpdate',
          message: 'surgerOrderUpdate',
        }
      };
      
      await this.uiService.displayLoader();
      const hasOfflineChanges = (this.layoverViewPassedData as SurgeryOrderActivity).pendingPushToDynamics || false;
      (this.layoverViewPassedData as SurgeryOrderActivity).pendingPushToDynamics = true;
      await this.surgeryOrderActivityDataService.updateOrderActivity(action, [this.layoverViewPassedData], new Date().getTime(), hasOfflineChanges);
      await this.uiService.dismissLoader();
    }
  }

  /**
   * Handles scientific activity flow
   * @private
   */
  private async _handleScientificActivityFlow(newMeeting: any) {
    this.activityOfflineService.selectedActivity = newMeeting;
    
    if (this.contact) {
      this.activityOfflineService.selectedActivity['contacts'].push(this.contactService.contactInformation);
    }
    
    if (this.activityOfflineService.selectedActivity instanceof AppointmentActivity) {
      if (this.device.isOffline) {
        await this.activityOfflineService.upsertMeetingsOfflineData(this.activityOfflineService.selectedActivity);
      }
      
      if (!this.device.isOffline && !this.activityOfflineService.hasOfflineMeetingData(this.activityOfflineService.selectedActivity.ID)) {
        await this.meetingService.addContactsToMeeting(this.activityOfflineService.selectedActivity);
      }
    }
  }

  /**
   * Handles presentation tools flow
   * @private
   */
  private async _handlePresentationToolsFlow(newMeeting: any) {
    this.activityOfflineService.selectedActivity = newMeeting;
    
    if (this.pres) {
      if (this.activityOfflineService.selectedActivity instanceof AppointmentActivity) {
        const loader = await this.loadingController.create();
        loader.present();
        
        if (!this.activityOfflineService.selectedActivity['presentations']) {
          this.activityOfflineService.selectedActivity['presentations'] = [];
        }
        this.activityOfflineService.selectedActivity['presentations'].push(this.pres);
        
        await this.activityOfflineService.upsertMeetingsOfflineData(this.activityOfflineService.selectedActivity);
        
        if (!this.device.isOffline && !this.activityOfflineService.hasOfflineMeetingData(this.activityOfflineService.selectedActivity.ID)) {
          try {
            await this.meetingService.addContentToMeeting(this.activityOfflineService.selectedActivity.presentations, this.activityOfflineService.selectedActivity);
          } catch (error) {
            this.notificationService.notify(this.translate.instant('ERROR_UPDATING_MEETING_PRESENTATIONS'), 'New Activity');
          }
        }
        
        loader.dismiss();
      }
    }
  }

  /**
   * Handles set booking flow
   * @private
   */
  private async _handleSetBookingFlow(newMeeting: any) {
    const currentSetBookingActivity = cloneDeep(this.setBooking) as SetBookingActivity;
    this.activityOfflineService.prevSelectedActivity = currentSetBookingActivity;
    this.activityOfflineService.selectedActivity = newMeeting;
    
    let contact: Contact;
    let account: Account;
    
    if (currentSetBookingActivity?.rawData) {
      const accountId = currentSetBookingActivity.rawData['_indskr_accountnamesoldto_value'];
      const contactId = currentSetBookingActivity.rawData['_indskr_surgeoncontact_value'];
      
      if (accountId) account = this.accountService.getAccountById(accountId);
      if (contactId) contact = this.contactService.getContactByID(contactId);
    }
    
    if (contact) {
      this.activityOfflineService.selectedActivity['contacts'].push(contact);
      this.contactService.addToRecentContacts(contact);
      if (contact.addressesList?.length) {
        const primaryAddress = contact.addressesList.find(address => address.isPrimary).compositeAdd;
        this.activityOfflineService.selectedActivity.location = primaryAddress;
      }
    }
    
    if (account) {
      this.accountService.moveAccountToSelected(account);
      const affiliatedContacts = await this.contactService.getAffiliatedContactsFromAccountsForMeeting([account]);
      if (affiliatedContacts.length === 1) {
        this.activityOfflineService.selectedActivity['contacts'].push(...affiliatedContacts);
        affiliatedContacts.forEach(affiliatedContact => {
          this.contactService.addToRecentContacts(affiliatedContact);
        });
      }
      
      if (!this.device.isOffline && !this.activityOfflineService.hasOfflineMeetingData(newMeeting.ID)) {
        await this.meetingService.addAccountsToMeeting(this.activityOfflineService.selectedActivity as AppointmentActivity);
      }
    }
    
    if (this.activityOfflineService.selectedActivity['contacts']) {
      const requestSuccess = await this.meetingService.addContactsToMeeting(this.activityOfflineService.selectedActivity, true);
      this.contentMatchingService.isNewContactAddedToMeeting = true;
      
      const payload = new UpdateMeetingPayload(
        this.activityOfflineService.selectedActivity.subject,
        this.activityOfflineService.selectedActivity.location
      );
      
      if (!requestSuccess || this.device.isOffline || this.activityOfflineService.hasOfflineMeetingData(this.activityOfflineService.selectedActivity.ID)) {
        await this.activityOfflineService.upsertMeetingsOfflineData(this.activityOfflineService.selectedActivity as AppointmentActivity);
      } else {
        try {
          await this.meetingService.updateMeeting(this.activityOfflineService.selectedActivity as AppointmentActivity, payload);
        } catch (error) {
          console.error('Set Booking DetailsComponent: addNewMeeting: ', error);
          this.activityOfflineService.upsertMeetingsOfflineData(this.activityOfflineService.selectedActivity as AppointmentActivity, false, true);
        }
      }
    }
    
    this.activityService.activityDetailsLoaded = true;
  }

  /**
   * Handles account plan flow
   * @private
   */
  private async _handleAccountPlanFlow(newMeeting: any, accountId: string) {
    const selectedAccount = this.accountService.getAccountById(accountId);
    this.activityOfflineService.selectedActivity = newMeeting;
    
    if (selectedAccount) {
      await this._updateAccountsOfSelectedMeeting([selectedAccount]);
    }
    
    this.uiService.showNewActivity = false;
    this.uiService.prevView = 'callPlanDetails';
    
    if (this.currentMasterPage === PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPageTab === 'plans') {
      this.uiService.activeView = 'ActivitiesPageRightPaneNav';
      this.uiService.showRightPane = true;
    } else {
      this.uiService.activeView = 'activityTimelineDetails';
      this.uiService.showRightPane = false;
    }
    
    this.navService.popChildNavPageWithPageTracking();
    
    if (this.currentMasterPage === PageName.CallPlanComponent) {
      this.pushChildNavPageWithPageTracking(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.CallPlanComponent, { from: PageName.CallPlanDetails });
    } else {
      this.pushChildNavPageWithPageTracking(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.CustomerCallPlanPage, { from: PageName.CustomerCallPlanDetails });
    }
    
    this.uiService.showCancelDoneOnActivityDetails = true;
    this.footerService.initButtons(FooterViews.Activities);
  }

  /**
   * Handles contact plan flow
   * @private
   */
  private async _handleContactPlanFlow(newMeeting: any, contactId: string) {
    const contact = this.contactService.getContactByID(contactId);
    if (!contact) {
      this.notificationService.notify(this.translate.instant('ERROR_FINDING_CONTACT_TO_ADD_TO_MEETING'), 'New Activity');
      return;
    }
    newMeeting['contacts'].push(contact);

    const requestSuccess = await this.meetingService.addContactsToMeeting(newMeeting, true);
    this.contentMatchingService.isNewContactAddedToMeeting = true;

    if (!requestSuccess) {
      await this.activityOfflineService.upsertMeetingsOfflineData(newMeeting);
    }

    this.activityOfflineService.selectedActivity = newMeeting;

    if (contact.addressesList?.length &&
        !this.authService.hasFeatureAction(FeatureActionsMap.ENABLE_GPS_CHECK_IN) &&
        (this.authService.user.buConfigs && !this.authService.user.buConfigs['indskr_populateaccountaddress'])) {
      await this.contactService.setLocationField(contact);

      const payload = new UpdateMeetingPayload(
        this.activityOfflineService.selectedActivity.subject,
        this.activityOfflineService.selectedActivity.location,
        this.activityOfflineService.selectedActivity.scheduledStart,
        this.activityOfflineService.selectedActivity.scheduledEnd
      );

      if (this.device.isOffline) {
        await this.activityOfflineService.upsertMeetingsOfflineData(this.activityOfflineService.selectedActivity as AppointmentActivity);
      } else {
        await this.meetingService.updateMeeting(this.activityOfflineService.selectedActivity as AppointmentActivity, payload);
      }
    }

    // OMNI-59164: Same affiliated-account rules as creating a meeting from the contact profile (addContactToMeeting).
    let accountsToUpdate: Account[] = [];
    const affiliatedAccounts = await this.accountService.getAffiliatedAccountsFromSelectedContactsForMeeting([contact]);
    if (affiliatedAccounts.length === 1) {
      accountsToUpdate = affiliatedAccounts;
    } else if (contact.primaryAccount) {
      accountsToUpdate = affiliatedAccounts.filter(af => af.id === contact.primaryAccount.id);
    }
    if (accountsToUpdate.length > 0) {
      await this._updateAccountsOfSelectedMeeting(accountsToUpdate);
    }

    this.uiService.showNewActivity = false;
    this.uiService.prevView = 'callPlanDetails';
    
    if (this.currentMasterPage === PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPageTab === 'plans') {
      this.uiService.activeView = 'ActivitiesPageRightPaneNav';
      this.uiService.showRightPane = true;
    } else {
      this.uiService.activeView = 'activityTimelineDetails';
      this.uiService.showRightPane = false;
    }
    
    this.navService.popChildNavPageWithPageTracking();
    
    if (this.currentMasterPage === PageName.CallPlanComponent) {
      this.pushChildNavPageWithPageTracking(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.CallPlanComponent, { from: PageName.CallPlanDetails });
    } else {
      this.pushChildNavPageWithPageTracking(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.CustomerCallPlanPage, { from: PageName.CustomerCallPlanDetails });
    }
    
    this.uiService.showCancelDoneOnActivityDetails = true;
    this.footerService.initButtons(FooterViews.Activities);
  }

  /**
   * Handles activities page flow
   * @private
   */
  private async _handleActivitiesPageFlow(newMeeting: any) {
    if (this.contactService.contactInformation) {
      const contact = this.contactService.getContactByID(this.contactService.contactInformation['ID']);
      if (contact) {
        newMeeting['contacts'].push(contact);
        const requestSuccess = await this.meetingService.addContactsToMeeting(newMeeting, true);
        if (!requestSuccess) {
          await this.activityOfflineService.upsertMeetingsOfflineData(newMeeting);
        }
        this.activityOfflineService.selectedActivity = newMeeting;
        this.uiService.showNewActivity = false;
        this.uiService.showCancelDoneOnActivityDetails = true;
        this.footerService.initButtons(FooterViews.Activities);
      }
    }
  }

  /**
   * Handles activities page non-plan flow
   * @private
   */
  private async _handleActivitiesPageNonPlanFlow(newMeeting: any) {
    this.clearContactJoinStatusOfCurrentSelectedMeeting();

    if (this.followUpMeetingContacts.length > 0) {
      if (this.activityOfflineService.selectedActivity instanceof AppointmentActivity) {
        this.activityOfflineService.selectedActivity['contacts'] = [];
        this.followUpMeetingContacts.map(contact => {
          this.contactService.moveContactToSelected(contact);
        });

        const requestSuccess = await this.meetingService.addContactsToMeeting(newMeeting, true);
        if (!requestSuccess) {
          await this.activityOfflineService.upsertMeetingsOfflineData(newMeeting);
        }

        if (this.uiService.activitiesPageTab === 'agenda') {
          this.activityOfflineService.selectedActivityOnAgenda = this.activityOfflineService.selectedActivity;
        }
      }

      this.contactService.followUpMeetingContacts = [];
    }
    
    this.activityOfflineService.selectedActivity = newMeeting;
    this.activityOfflineService.isNewActivityFlow = true;
    
    this.navService.setChildNavRoot(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.GoAppActivitiesPageComponent, { isNewlyCreatedActivity: true, from: PageName.GoAppHomeComponent });
    
    this.uiService.activeView = 'ActivitiesPageRightPaneNav';
    this.uiService.showNewActivity = false;
    this.uiService.showRightPane = true;
  }

  /**
   * Handles account plan details task
   * @private
   */
  private async _handleAccountPlanDetailsTask(newMeeting: any) {
    const meetingPayload = [{
      activityMeetingId: Guid.create().toString(),
      activityId: newMeeting.ID
    }];
    
    this.accountManagementDataService.saveMeetingsForAccountPlan(this.layoverViewPassedData.ID, meetingPayload).catch(error => console.error(error));
  }

  /**
   * Fetches activity details
   * @private
   */
  private async _fetchActivityDetails(newMeeting: any) {
    const tasks = [];
    
    if (newMeeting.accounts.length > 0 && !this.device.isOffline) {
      tasks.push(
        this.meetingService.fetchActivityAccountsByMeetingId(newMeeting.ID).then(activityAccounts => {
          if (activityAccounts) {
            newMeeting._raw_activityAccounts = activityAccounts;
          }
        })
      );
    }
    
    if (newMeeting.contacts.length > 0 && !this.device.isOffline) {
      const allContactsCovered = newMeeting.contacts.every((c: any) =>
        (newMeeting._raw_contactAttendees as any[])?.some((r: any) => r.indskr_contactid === c.ID)
      );
      if (!allContactsCovered) {
        tasks.push(
          this.meetingService.fetchActivityContactAttendiesByMeetingId(newMeeting.ID).then(activityContacts => {
            if (activityContacts) {
              newMeeting._raw_contactAttendees = activityContacts;
            }
          })
        );
      }
    }
    
    await Promise.all(tasks);
  }

  private _fetchActivityDetailsInBackground(newMeeting: any): void {
    this._fetchActivityDetails(newMeeting).then(async () => {
      if (this.activityOfflineService.selectedActivity?.ID === newMeeting.ID) {
        await this.activityOfflineService.upsertMeetingsOfflineData(this.activityOfflineService.selectedActivity as AppointmentActivity);
      }
    }).catch(error => {
      console.error('NewActivityComponent: background activity detail hydration failed', error);
    });
  }

  /**
   * Handles meeting creation failure
   * @private
   */
  private _handleMeetingCreationFailure() {
    console.error('createNewMeeting: No response!');
    if (!this.meetingService.isErrorStartDateCreateMeeting) {
      this.notificationService.notify(
        this.translate.instant('NEW_ACTIVITY_TOAST_ERROR_CREATING_NEW_MEETING'), 
        'New Activity', 
        'top', 
        ToastStyle.DANGER
      );
      this.meetingStructureService.createEmbeddedInteractions(null);
    }
    this._handleNavigationAfterFailure();
  }

  /**
   * Handles navigation after meeting creation failure
   * @private
   */
  private _handleNavigationAfterFailure() {
    if (this.navService.getPreviousActiveChildNavViewPageName() !== PageName.NothingSelectedView) {
      this.activityOfflineService.activitySource = null;
      this.uiService.showNewActivity = false;
      setTimeout(() => {
        this._performNavigationCleanup();
      }, 100);
    }
    this.uiService.dismissLoader();
    this.meetingService.isErrorStartDateCreateMeeting = false;
  }

  /**
   * Performs navigation cleanup after failure
   * @private
   */
  private _performNavigationCleanup() {
    const currentPage = this.navService.getActiveChildNavViewPageName();
    const prevPage = this.navService.getPreviousActiveChildNavViewPageName();
    
    if (this.uiService.activitiesPagePlanTabSelectedPlan === 'goalsPlansTab' && 
        prevPage === PageName.AccountPlanDetailsComponent) {
      // Nothing to do here
    } else if (this.layoverViewPushedFrom === 'OpportunityManagementTool' && 
               currentPage === PageName.ActivitiesDetailsPaneComponent) {
      this.navService.popChildNavPageWithPageTracking();
    } else {
      this.navService.popChildNavPageWithPageTracking();
    }
    
    this._updateFooterAfterFailure(currentPage);
    this.navService.setChildNavRightPaneView(true);
    this.uiService.showRightPane = false;
  }

  /**
   * Updates footer after failure based on current page
   * @private
   */
  private _updateFooterAfterFailure(currentPage: PageName) {
    const footerPages = [
      PageName.AccountDetailsComponent,
      PageName.AccountPlanDetailsComponent,
      PageName.ScientificActivityDetail
    ];
    
    if (footerPages.includes(currentPage) || 
        (currentPage === PageName.ContactDetailsComponent && this.uiService.contactDetailsSegment !== 'capture')) {
      this.footerService.initButtons(FooterViews.None);
    } else if (currentPage === PageName.ContactDetailsComponent && this.uiService.contactDetailsSegment === 'capture') {
      this.footerService.initButtons(FooterViews.ConsentCapture);
    }
  }

  /**
   * Prepares meeting payload with subtype handling
   * @private
   */
  private _prepareMeetingPayloadWithSubtype(subtype?: string): InitiateMeetingPayload {
    const payload = this._prepareMeetingPayload();
    if (subtype === 'live') {
      payload.location = 'LiveMeet';
      payload.subject = this.selectedEvent?.name || 'Live Meeting';
      payload.eventId = this.selectedEvent?.id;
    }
    return payload;
  }

  /**
   * Handles live meeting event participants
   * @private
   */
  private async _handleLiveMeetingParticipants(subtype: string, newMeeting: any) {
    if (subtype === 'live' && this.selectedEvent && !newMeeting.createdOffline) {
      const eventParticipants = await this.msEventService.getParticipantRegistrations(this.selectedEvent.id);
      const eventContacts = eventParticipants?.map(p => this.contactService.getContactByID(p)).filter(p => !!p);
      
      if (eventContacts?.length > 0) {
        newMeeting['contacts'].push(...eventContacts);
        if (!this.device.isOffline && !this.activityOfflineService.hasOfflineMeetingData(newMeeting.ID)) {
          await this.meetingService.addContactsToMeeting(newMeeting, true);
        } else {
          await this.activityOfflineService.upsertMeetingsOfflineData(newMeeting);
        }
      }
    }
  }

  /**
   * Handles meeting configuration setup
   * @private
   */
  private async _handleMeetingConfiguration(newMeeting: any) {
    this.activityOfflineService.addIoConfigDefaultValuesToActivity(newMeeting);
    
    if (newMeeting.appConfigFields?.length > 0) {
      if (!this.device.isOffline && !this.activityOfflineService.hasOfflineMeetingData(newMeeting.ID)) {
        try {
          await this.meetingService.updateappConfigFields(newMeeting, newMeeting.appConfigFields, true);
        } catch (error) {
          console.error('saveAdditionalConfigFields: ', error);
          this.activityOfflineService.upsertMeetingsOfflineData(newMeeting, false, true);
        }
      }
    }
  }

  private async createNewAccountVisit() {
    this.isLoaderOn = true;
    let success = false;
    let newAccountVisit: AppointmentActivity;

    try {
      const offlineMeetingId = this.activityOfflineService.generateOfflineMeetingId();
      newAccountVisit = new AppointmentActivity({
        subject: this.translate.instant('ACCOUNT_VISIT'),
        scheduledstart: new Date(this.startTime).getTime(),
        scheduledend: new Date(this.endTime).getTime(),
        offlineMeetingId,
        indskr_positionid: this.authService.user.xPositionID,
        statecode: 0,
        statuscode: 1,
        activityid: offlineMeetingId,
        indskr_ownerid: this.authService.user.systemUserID,
        indskr_ownerfullname: this.authService.user.displayName,
        indskr_isparentcall: true,
        indskr_meetingtype: 600000000,
      });
      // Add account if creating from acount tool
      if (this.isLayoverPushView) {
        if (this.layoverViewPushedFrom == 'AccountTool' && this.layoverViewPassedData && this.layoverViewPassedData.id) {
          const account = this.accountService.getAccountById(this.layoverViewPassedData.id);
          newAccountVisit.accounts = [account];
          if(this.authService.user.buConfigs && this.authService.user.buConfigs['indskr_populateaccountaddress']){
            const selectedAddress = await this.accountService.getPrimaryAddressOfAccount(newAccountVisit['accounts'][0].id);
            await this.accountService.addLocationToMeeting(newAccountVisit, selectedAddress);
          }
        }
      }

      const activityTypes = this.activityOfflineService.configuredActivityTypes(MeetingActivityTypeCode.MEETING, FormatType.ACCOUNT_VISIT);
      if (activityTypes.length !== 0) {
        const defaultActivityType = activityTypes.length == 1 ? activityTypes[0] : activityTypes.find(at => at.indskr_default);
        if (defaultActivityType) {
          const formattedDefaultActivityTypeName = this.localizationService.getTranslatedString(defaultActivityType.indskr_name, EntityNameForTranslation.ActivityType);
          newAccountVisit.indskr_activitytype = defaultActivityType.indskr_activitytypeid;
          newAccountVisit.activityTypeName = formattedDefaultActivityTypeName;
          newAccountVisit.subject = (isEmpty(newAccountVisit.accountString) ? '' : ((newAccountVisit.accountString + ' - '))) + this.translate.instant('ACCOUNT_VISIT') + ' - ' + formattedDefaultActivityTypeName;
        }
      }

      success = await this.meetingService.crudMeetingsOnlineWithOfflineUploadEndpoint([newAccountVisit]);
    } catch (error) {
      console.error('createNewAccountVisit: ', error);
    }

    // Post processing
    if (success) {
      this.clearContactJoinStatusOfCurrentSelectedMeeting();
      this.activityOfflineService.selectedActivity = newAccountVisit;

      if (this.currentMasterPage === PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPageTab !== 'plans') {
        this.activityOfflineService.isNewActivityFlow = true;

        if (this.device.isMobileDevicePortrait && this.navService.getActiveChildNavViewPageName() === PageName.NewActivityComponent) {
          this.pushChildNavPageWithPageTracking(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.GoAppActivitiesPageComponent, { isNewlyCreatedActivity: true });
        }
        this.uiService.activeView = 'ActivitiesPageRightPaneNav';
        this.uiService.showNewActivity = false;
        this.uiService.showRightPane = true;
      }

      if (!this.uiService.toolsActivityActive) {
        this.events.publish("refreshAgenda");
      } else {
        this.uiService.agendaRefreshRequired = true;
        this.activityOfflineService.signalActivityConflictCheck$.next(this.activityOfflineService.selectedActivity);
      }

      if (this.agendaFooterService.actSegment === 'week') this.events.publish('weekview:RefreshUI');

      this.meetingStructureService.createEmbeddedInteractions(newAccountVisit);
      this.activityService.activityDetailsLoaded = true;
      this.uiService.showNewActivity = false;

      if (this.agendaFooterService.actSegment === 'agenda' && this.agendaFooterService.planTabSegment === 'planTabTodo') {
        if (this.activityOfflineService.selectedActivity && this.activityOfflineService.selectedActivity.status !== 3 && this.activityOfflineService.selectedActivity.status !== 4) {
          this.events.publish('aciviiyCreatedRefreshTODO', this.activityOfflineService.selectedActivity);
        }
      }

      if (this.isLayoverPushView && this.layoverViewPushedFrom) {
        this.navService.popChildNavPageWithPageTracking();
        this.uiService.showCancelDoneOnActivityDetails = true;

        if (this.layoverViewPushedFrom == 'AccountTool') {
          this.pushChildNavPageWithPageTracking(PageName.ActivitiesDetailsPaneComponent, PageName.ActivitiesDetailsPaneComponent, PageName.AccountPageComponent, { from: 'AccountTool', isNewlyCreatedActivity: true });
        }
      } else if (this.navService.getCurrentMasterPageName() == PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPageTab !== 'plans') {
        this.uiService.showCancelDoneOnActivityDetails = false;
      }
      this.activityOfflineService.isNewMeetingFlow = true;
      this.activityOfflineService.selectedActivityAtHome = this.activityOfflineService.selectedActivity;
    } else {
      this.notificationService.notify(
        this.translate.instant('ACCOUNT_VISIT_ERROR_CREATING_NEW_ACCOUNT_VISIT'),
        'New Activity',
        'top',
        ToastStyle.INFO
      );
    }

    this.isLoaderOn = false;
  }

  private async _updateContactsOfSelectedMeeting(contacts: Contact[]) {
    if (this.activityOfflineService.selectedActivity && this.activityOfflineService.selectedActivity.type == ActivityType.Appointment && !(this.activityOfflineService.selectedActivity as AppointmentActivity).isCompleted) {
      this.activityOfflineService.selectedActivity['contacts'] = [];
      contacts.forEach(contact => {
        this.contactService.moveContactToSelected(contact);
      });
      if (this.activityOfflineService.selectedActivity.location !== "LiveMeet") {
        if (!this.authService.hasFeatureAction(FeatureActionsMap.ENABLE_GPS_CHECK_IN) &&  (this.authService.user.buConfigs && !this.authService.user.buConfigs['indskr_populateaccountaddress'])) {
          await this.contactService.setLocationField(contacts);
        }
      }

      if (!this.device.isOffline && !this.activityOfflineService.hasOfflineMeetingData(this.activityOfflineService.selectedActivity.ID)) {
        await this.meetingService.addContactsToMeeting(this.activityOfflineService.selectedActivity, true);
      }

      // Fix: contacts attached here (e.g. auto-populated affiliated contact from the Account
      // tool) were never folded into the secondary-info subject, so the server kept whatever
      // subject was computed before this contact existed on the meeting.
      await this.meetingService.recomputeSecInfoSubjectAfterAttach(this.activityOfflineService.selectedActivity as AppointmentActivity);
    }
  }

  private async addContactToMeeting(newMeeting: AppointmentActivity) {
    if (this.contactService.contactInformation) { //add contact to new activity if created from contact profile
      let contact = this.contactService.getContactByID(this.contactService.contactInformation['ID']);
      if (contact) {
        const alreadyEmbedded = (newMeeting._raw_contactAttendees as any[])?.some(
          (r: any) => r.indskr_contactid === contact.ID
        );
        if (!alreadyEmbedded) {
          newMeeting['contacts'].push(contact);
        }
        if (this.secondaryInfoService.isAppointmentSecInfoConfigured) {
          newMeeting.subject = await this.meetingService.setMeetingSubject(newMeeting);
        } else if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.MEETING_AUTO_SUBJECT)) {
          //HCP Name - Activity - Format - Rep name
          newMeeting.subject = [contact.fullName, this.translate.instant('MEETING'), newMeeting.activityTypeName, newMeeting.meetingOwnerName].filter(Boolean).join(' - ');
        }
        const requestSuccess = alreadyEmbedded
          ? true  // junction record already created by V2 POST — no PATCH needed
          : await this.meetingService.addContactsToMeeting(newMeeting, true);
        this.contentMatchingService.isNewContactAddedToMeeting = true;
        // TODO: Only hybrid app does offline stuff in future
        if (!requestSuccess /* && this.device.isHybridApp*/) {
          await this.activityOfflineService.upsertMeetingsOfflineData(newMeeting);
        }
        this.activityOfflineService.selectedActivity = newMeeting;
        if (contact.addressesList && contact.addressesList.length && !this.authService.hasFeatureAction(FeatureActionsMap.ENABLE_GPS_CHECK_IN) && (this.authService.user.buConfigs && !this.authService.user.buConfigs['indskr_populateaccountaddress'])) {
          await this.contactService.setLocationField(this.contactService.contactInformation);
          let payload = new UpdateMeetingPayload(
            this.activityOfflineService.selectedActivity.subject,
            this.activityOfflineService.selectedActivity.location,
            this.activityOfflineService.selectedActivity.scheduledStart,
            this.activityOfflineService.selectedActivity.scheduledEnd
          );
          const shouldSkipContactPatch = shouldSkipPostCreateMeetingPatch({
            isOffline: this.device.isOffline,
            hasOfflineData: this.activityOfflineService.hasOfflineMeetingData(newMeeting.ID),
            isAppointmentSecInfoConfigured: true,
            createFields: newMeeting['createRequestFields'] || {},
            finalFields: {
              subject: this.activityOfflineService.selectedActivity.subject,
              location: this.activityOfflineService.selectedActivity.location,
              scheduledStart: this.activityOfflineService.selectedActivity.scheduledStart,
              scheduledEnd: this.activityOfflineService.selectedActivity.scheduledEnd,
            },
          });
          if (this.device.isOffline) {
            await this.activityOfflineService.upsertMeetingsOfflineData(this.activityOfflineService.selectedActivity as AppointmentActivity);
          } else if (!shouldSkipContactPatch) {
            await this.meetingService.updateMeeting((this.activityOfflineService.selectedActivity as AppointmentActivity), payload);
          }
          // Trigger GPS capture when contact and location are set
          await this.meetingLocationCaptureService.captureContactLocationDistance(this.activityOfflineService.selectedActivity as AppointmentActivity);
        }
         // To Add/Remove affiliated accounts for meeting
        const hideAccountField = this.authenticationOfflineService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.BU_APPOINTMENT_GA_HIDE_ACCOUNT_FIELD) as boolean;
        let updateAccountsForMeetingFlag: boolean = false;
        let accountsToUpdate: Account[] = [];
        //Check for add
        if (!hideAccountField) {
          let affiliatedAccounts = await this.accountService.getAffiliatedAccountsFromSelectedContactsForMeeting([contact]);
          if (affiliatedAccounts.length === 1) {
            // Add the only affiliated contact
            updateAccountsForMeetingFlag = true;
            accountsToUpdate = affiliatedAccounts;
          }else if(contact.primaryAccount){
            let aff = affiliatedAccounts.filter(af => af.id == contact.primaryAccount.id)
            updateAccountsForMeetingFlag = true;
            accountsToUpdate.push(...aff);
          }
          if (updateAccountsForMeetingFlag) {
            await this._updateAccountsOfSelectedMeeting(accountsToUpdate);
          }
        }
        this.uiService.showNewActivity = false;
        this.uiService.showCancelDoneOnActivityDetails = true;
        this.footerService.initButtons(FooterViews.Activities);
      }
    }
  }

  private async _updateAccountsOfSelectedMeeting(accounts: Account[]) {
    if (this.activityOfflineService.selectedActivity && this.activityOfflineService.selectedActivity.type == ActivityType.Appointment && !(this.activityOfflineService.selectedActivity as AppointmentActivity).isCompleted) {
      this.activityOfflineService.selectedActivity['accounts'] = [];
      accounts.forEach(account => {
        this.accountService.moveAccountToSelected(account);
      });

      if (!this.device.isOffline && !this.activityOfflineService.hasOfflineMeetingData(this.activityOfflineService.selectedActivity.ID)) {
        try {
          await this.meetingService.addAccountsToMeeting((this.activityOfflineService.selectedActivity as AppointmentActivity));
            if(this.authService.user.buConfigs['indskr_populateaccountaddress']){
              const selectedAddress = await this.accountService.getPrimaryAddressOfAccount(this.activityOfflineService.selectedActivity['accounts'][0].id);
              await this.accountService.addLocationToMeeting(this.activityOfflineService.selectedActivity, selectedAddress);
            }
        } catch (error) {
          console.error('ContactListComponent: _updateAccountsOfSelectedMeeting: ', error);
          await this.activityOfflineService.upsertMeetingsOfflineData(this.activityOfflineService.selectedActivity as AppointmentActivity, false, true);
        }
      } else {
        await this.activityOfflineService.upsertMeetingsOfflineData(this.activityOfflineService.selectedActivity as AppointmentActivity);
      }

      // Fix: the account attached here (e.g. auto-populated affiliated account when a meeting
      // is created starting from a contact) was never folded into the secondary-info subject,
      // so the server kept whatever subject was computed before this account existed on the
      // meeting.
      await this.meetingService.recomputeSecInfoSubjectAfterAttach(this.activityOfflineService.selectedActivity as AppointmentActivity);
    }
  }

  private _preparePhoneCallPayload(): InitiatePhoneCallPayload {

    const phoneCallStartTime: number = new Date(this.startTime).getTime();
    const phoneCallEndTime: number = new Date(this.endTime).getTime();
    let subject = 'Phone Call';
    if (this.followupMeetingSubject && this.followupMeetingSubject.length > 0) {
      subject = this.followupMeetingSubject
    }
    else if (this.currentMasterPage === PageName.ContactPageComponent && this.contactService.contactInformation && this.contactService.contactInformation.fullName) {
      subject = `${this.contactService.contactInformation.fullName} - ${this.translate.instant('NEW_ACTIVITY_PHONECALL')}`;
    }

    const payload: InitiatePhoneCallPayload = new InitiatePhoneCallPayload(
      phoneCallStartTime,
      phoneCallEndTime,
      subject,
      OFFLINE_PHONE_CALL_ID_PREFIX + new Date().getTime(),
      0,
      this.device._isOffline && this.navService.getPreviousActiveChildNavViewPageName() === PageName.AccountPlanDetailsComponent ? this.layoverViewPassedData.ID : undefined
    );

    return payload;
  }

  private _prepareMeetingPayload(): InitiateMeetingPayload {
    let start = this.startTime;
    let end = this.endTime;
    // If start time is in the past (user kept page idle), use current time (ERR_IO_ME12 fix)
    const duration = this.authService.user?.meeting_duration || this._getActivityDuration();
    if (isPast(new Date(start)) && !this.cellData) {
      start = format(new Date());
      end = format(addMinutes(new Date(), duration));
    }
    let meetingStartTime: number = new Date(start).getTime();
    let meetingEndTime: number = new Date(end).getTime();
    
    // Fix: Ensure meeting uses configured duration even if endTime was calculated incorrectly
    // This can happen when setCellData() is called with activeViewNewMeeting set to 'email' 
    // after email creation, causing _getActivityDuration() to return 30 instead of configured duration
    const calculatedDurationMinutes = Math.round((meetingEndTime - meetingStartTime) / (1000 * 60));
    const configuredDuration = this.authService.user?.meeting_duration;
    if (configuredDuration && configuredDuration > 0 && calculatedDurationMinutes !== configuredDuration) {
      end = this.dateTimeFormatsService.toISOString(this.dateTimeFormatsService.addMinutesToDate(new Date(start), configuredDuration));
      meetingEndTime = new Date(end).getTime();
    }
    
    const isAcinoBaseUser = this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.VISIT_AUTO_SUBJECT);
    const activityTypes = this.meetingActivityTypes?.length > 0
      ? this.meetingActivityTypes
      : (this.activityOfflineService.configuredActivityTypes(MeetingActivityTypeCode.MEETING, FormatType.HCP_MEETING) || []);
    const selectedActivityType = this.selectedMeetingActivityType || this.getDefaultMeetingActivityType(activityTypes);
    const selectedActivityTypeName = selectedActivityType ? this.localizationService.getTranslatedString(selectedActivityType.indskr_name, EntityNameForTranslation.ActivityType) : '';
    const selectedActivitySubType = this.getDefaultMeetingSubActivityType(selectedActivityType);
    let kitBookingId = '';

    /** 
     * Note: This subject setting is currently overridden in setMeetingSubject(), which is called from _handlePostCreationTasks(). 
     * Keeping this here for now in case it becomes needed again.
     */
    // % % % Ability Autoname Subject in Meeting and Procedure Log % % % //
    if(this.secondaryInfoService.isAppointmentSecInfoConfigured)
      this.subject = this.translate.instant('MEETING');
    // % % % Ability Autoname Subject in Meeting and Procedure Log % % % //
    else if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.MEETING_AUTO_SUBJECT))
      this.subject = this.translate.instant('MEETING') + ' - ' + this.authService.user.displayName;
    else
      this.subject = this.translate.instant('MEETING');
    if (isAcinoBaseUser) {
      this.subject = this.translate.instant('VISIT');
    }
    if (((this.currentMasterPage === PageName.ContactPageComponent || this.currentMasterPage === PageName.CustomerCallPlanPage)
        ||(this.currentMasterPage === PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPageTab === 'plans'
            && this.uiService.activitiesPagePlanTabSelectedPlan === 'goalsPlansTab'))
        && this.contactService.contactInformation
        && this.contactService.contactInformation.fullName) {
      this.subject = `${this.contactService.contactInformation.fullName} - ${this.translate.instant('MEETING')}`;
      if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.MEETING_AUTO_SUBJECT)) {
        this.subject = [this.contactService.contactInformation.fullName, this.translate.instant('MEETING'), selectedActivityTypeName, this.authService.user.displayName].filter(Boolean).join(' - ');
      }
      if (isAcinoBaseUser) {
        this.subject = `${this.translate.instant('VISIT')} - ${this.contactService.contactInformation.fullName}`;
      }
    } else if (this.callPlanOfflineService.selectedRepCallPlan && (this.currentMasterPage === PageName.CallPlanDetails
            || this.currentMasterPage === PageName.CallPlanComponent
            || (this.currentMasterPage === PageName.GoAppActivitiesPageComponent && this.uiService.activitiesPageTab === 'plans'
             && this.uiService.activitiesPagePlanTabSelectedPlan === 'goalsPlansTab')
             || this.currentMasterPage === PageName.CustomerCallPlanDetails
             || this.navService.getCurrentMasterPageName() == PageName.CustomerCallPlanPage )) {
      let contact = this.contactService.getContactByID(
        this.callPlanOfflineService.selectedRepCallPlan['contactId']
      );
      if (contact && contact.fullName) {
        this.subject = (contact && contact.fullName) ? `${contact.fullName} -${this.translate.instant('MEETING')}` : this.translate.instant('MEETING');
        if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.MEETING_AUTO_SUBJECT)) {
          this.subject = [contact.fullName, this.translate.instant('MEETING'), selectedActivityTypeName, this.authService.user.displayName].filter(Boolean).join(' - ');
        }
        if (isAcinoBaseUser) {
          this.subject = `${this.translate.instant('VISIT')} - ${contact.fullName}`;
        }
      }
    } else if (this.followupMeetingSubject.length > 0) {
      this.subject = this.followupMeetingSubject;
      if (isAcinoBaseUser) {
        this.subject = `${this.translate.instant('VISIT')} - ${this.contactService.contactInformation.fullName}`;
      }
    } else if (this.layoverViewPushedFrom == 'ScientificActivityPage') {
      if (this.contact) {
        let contact = this.contactService.getContactByID(
          this.contactService.contactInformation['ID']
        );
        if (contact) {
          this.subject = `${contact.fullName} - ${this.translate.instant('MEETING')}`;
          if (this.authenticationOfflineService.hasFeatureAction(FeatureActionsMap.MEETING_AUTO_SUBJECT)) {
            this.subject = [contact.fullName, this.translate.instant('MEETING'), selectedActivityTypeName, this.authService.user.displayName].filter(Boolean).join(' - ');
          }
          if (isAcinoBaseUser) {
            this.subject = `${this.translate.instant('VISIT')} - ${this.contactService.contactInformation.fullName}`;
          }
        }
      }
    } else if (this.layoverViewPushedFrom == PageName.SetBookingActivityDetailsComponent) {
      let startTime, endTime;
      let currentSetBookingActivity = this.activityOfflineService.selectedActivity;
      kitBookingId = currentSetBookingActivity.ID;
    }

    const payload: InitiateMeetingPayload = new InitiateMeetingPayload(
      this.subject,
      this._getContactCreateLocation() || this.location,
      meetingStartTime,
      meetingEndTime,
      this.notes,
      this.activityOfflineService.generateOfflineMeetingId(),
      this.device._isOffline && this.navService.getPreviousActiveChildNavViewPageName() === PageName.AccountPlanDetailsComponent ? this.layoverViewPassedData.ID : undefined,
      null,
      kitBookingId,
      selectedActivityType?.indskr_activitytypeid,
      selectedActivityTypeName || null,
      selectedActivitySubType?.indskr_activitysubtypeid,
      selectedActivitySubType ? this.localizationService.getTranslatedString(selectedActivitySubType.indskr_name, EntityNameForTranslation.ActivityType) : null
    );
    this._finalizeDefaultCreatePayload(payload);
    this._finalizeContactCreatePayload(payload);

    return payload;
  }

  private _finalizeDefaultCreatePayload(payload: InitiateMeetingPayload): void {
    if (!payload.location) {
      payload.location = this.translate.instant('NO_LOCATION');
    }

    if (!this.secondaryInfoService.isAppointmentSecInfoConfigured || payload.isSubjectFinalForCreate) {
      return;
    }

    const meetingForSubject = new AppointmentActivity({
      subject: payload.subject,
      location: payload.location,
      scheduledstart: payload.scheduledStart,
      scheduledend: payload.scheduledEnd,
      activityid: payload.offlineMeetingId,
      indskr_ownerfullname: this.authService.user.displayName,
      indskr_activitytype: payload.indskr_activitytypeid,
      activityTypeName: payload.activityTypeName,
      indskr_activitysubtype: payload.indskr_activitysubtypeid,
      activitySubTypeName: payload.activitySubTypeName,
    });
    payload.subject = this.meetingService.setMeetingSubject(meetingForSubject);
    payload.isSubjectFinalForCreate = true;
  }

  private _finalizeContactCreatePayload(payload: InitiateMeetingPayload): void {
    if (this.currentMasterPage !== PageName.ContactPageComponent || !this.contactService.contactInformation) {
      return;
    }

    const contact = this.contactService.getContactByID(this.contactService.contactInformation['ID']);
    if (!contact) {
      return;
    }

    if (!payload.location) {
      payload.location = this.translate.instant('NO_LOCATION');
    }

    payload.contactForCreateSubject = contact;
    if (this.secondaryInfoService.isAppointmentSecInfoConfigured) {
      const meetingForSubject = new AppointmentActivity({
        subject: payload.subject,
        location: payload.location,
        scheduledstart: payload.scheduledStart,
        scheduledend: payload.scheduledEnd,
        activityid: payload.offlineMeetingId,
        indskr_ownerfullname: this.authService.user.displayName,
        indskr_activitytype: payload.indskr_activitytypeid,
        activityTypeName: payload.activityTypeName,
        indskr_activitysubtype: payload.indskr_activitysubtypeid,
        activitySubTypeName: payload.activitySubTypeName,
      });
      meetingForSubject.contacts = [contact];
      payload.subject = this.meetingService.setMeetingSubject(meetingForSubject);
      payload.isSubjectFinalForCreate = true;
    }
  }

  private _getContactCreateLocation(): string {
    if (this.currentMasterPage !== PageName.ContactPageComponent || !this.contactService.contactInformation) {
      return '';
    }

    if (this.authService.hasFeatureAction(FeatureActionsMap.ENABLE_GPS_CHECK_IN) || !this.authService.user.buConfigs || this.authService.user.buConfigs['indskr_populateaccountaddress']) {
      return '';
    }

    const contact = this.contactService.getContactByID(this.contactService.contactInformation['ID']);
    const addresses = contact?.addressesList || [];
    if (!addresses.length) {
      return '';
    }

    const favoriteAddresses = addresses.filter(address => address['isFavourite']);
    const address = favoriteAddresses.length === 1
      ? favoriteAddresses[0]
      : addresses.find(item => item.isPrimary) || (addresses.length === 1 ? addresses[0] : null);

    return address?.compositeAdd || '';
  }

  private getDefaultMeetingActivityType(activityTypes: MeetingActivityType[]): MeetingActivityType {
    if (isEmpty(activityTypes)) {
      return null;
    }
    const isKitBookingFlow = this.layoverViewPushedFrom == PageName.SetBookingActivityDetailsComponent;
    if (isKitBookingFlow) {
      const kitBookingDefault = activityTypes.find(at => at.indskr_defaultformatforkitbooking);
      if (kitBookingDefault) {
        return kitBookingDefault;
      }
    }
    const defaultType = activityTypes.find(at => at.indskr_default);
    if (defaultType) {
      return defaultType;
    }
    return this.isMeetingFormatRequired ? activityTypes[0] : null;
  }

  private getDefaultMeetingSubActivityType(activityType: MeetingActivityType): MeetingSubActivityType {
    if (!activityType?.indskr_activitytypeid) {
      return null;
    }
    const activitySubTypes = this.activityOfflineService.getActivitySubTypesByActivityType(
      MeetingActivityTypeCode.MEETING,
      activityType.indskr_activitytypeid
    );
    if (isEmpty(activitySubTypes)) {
      return null;
    }
    return activitySubTypes.find(ast => ast.indskr_default) || null;
  }

  onMeetingActivityTypeChange(activityType: MeetingActivityType) {
    this.selectedMeetingActivityType = activityType;
    this.setActiveView('meeting');
  }

  /**
   * Meeting-format picker: choosing a format proceeds with the standard create
   * flow; the mic on a format row selects it and starts dictation instead.
   */
  public async openMeetingFormatPopover(event: Event): Promise<void> {
    const { MeetingFormatPopoverComponent } = await import('./meeting-format-popover/meeting-format-popover');
    const popover = await this.popoverCtrl.create({
      component: MeetingFormatPopoverComponent,
      componentProps: {
        options: (this.meetingActivityTypes ?? []).map(activityType => ({
          label: this.localizationService.getTranslatedString(activityType.indskr_name, this.activityTypeTranslationEntity),
          value: activityType,
          selected: activityType === this.selectedMeetingActivityType,
        })),
        micEnabled: this.hasVoiceNoteTakerEnabled,
      },
      event,
      cssClass: 'activity-type-popover',
      showBackdrop: false,
    });
    await popover.present();
    const { data } = await popover.onDidDismiss();
    if (!data) {
      return;
    }
    if (data.dictate) {
      this.selectedMeetingActivityType = data.value as MeetingActivityType;
      this._cd.markForCheck();
      await this.openVoiceNoteCapture();
      return;
    }
    this.onMeetingActivityTypeChange(data.value as MeetingActivityType);
  }

  createNewSampleDeliveryRequest() {
    this.uiService.showNewActivity = false;
    this.navService.popChildNavPageWithPageTracking();
    this.navService.pushChildNavPageWithPageTracking(
      PageName.NewSampleDeliveryRequestComponent,
      PageName.NewSampleDeliveryRequestComponent,
      PageName.ContactPageComponent,
      { contact: this.contactService.contactInformation, from: PageName.ContactPageComponent },
    );
  }

  public async createNewSampleRequest() {
    let start, end, orderDate: string, orderTime: string, contactID: string;
    start = new Date();
    end = this.dateTimeFormatsService.addMinutesToDate(start, 30);
    orderDate = start.toDateString();
    orderTime = start.toLocaleTimeString('en-US', { hour12: true, hour: '2-digit', minute: '2-digit' });
    if (start) {
      let orderStartTime: any = new Date(start);
      let orderEndTime: any = new Date(end);
      this.logService.logDebug('start ', start);
      let contactID = '', addressID = '', location = '', subject: string = 'Allocation Order';
      if (this.NewActivitySource == 'ContactInfo') {
        this.contactService.addToRecentContacts(this.contactService.contactInformation);
        let addressList = this.contactService.contactInformation.addressesList;
        addressList =  uniqBy(addressList, 'addressId');
        addressID = '';
        location = ''
        // Keep contact selected when allocation order is created from Contact details.
        // Address can remain blank if there are multiple addresses or license validation fails.
        contactID = this.contactService.contactInformation.ID;
        subject = 'Allocation Order with ' + this.contactService.contactInformation.fullName;
        if (addressList.length == 1 && await this.sampleDataService.hasValidStateLicense(addressList[0].stateId, contactID)) {
          addressID = addressList[0].customerAddressID;
          location = addressList[0].compositeAdd;
        }
      }
      let sampleDropPayload: CreateSampleDropRequestBody = new CreateSampleDropRequestBody({
        scheduledStart: orderStartTime,
        scheduledEnd: orderEndTime,
        offlineActivityId: 'offlineSampleOrder_' + new Date().getTime(),
        subject: subject,
        contactID: contactID,
        addressID: addressID
      });
      sampleDropPayload.indskr_ownerid = this.authenticationOfflineService.user.systemUserID;
      try {
        let response = await this.samplingService.initiateSampleOrder(sampleDropPayload);

        if (response) { // this check ensures the meeting is in sync with our backend , do not take your chances with backend you will regret
          // Doing this only to update the dx-scheduler on 'activity-3day-view.ts'...
          // Need to revise this structure later on...
          let data;

          if (response['activityId']) {
            // successfully created online into dynamics
            data = { id: response.activityId, ...sampleDropPayload }
          } else {
            // Offline created meeting
            data = {
              id: response.offlineActivityId,
              subject: response.subject,
              location: response.location,
              scheduledStart: response.scheduledStart,
              scheduledEnd: response.scheduledEnd,
            };
          }

          if (data) {
            this.uiService.setUIServiceData({
              view: 'new-activity', data,
            }); // this is an observable stream
          } else {
          }
        }
        let activity: SampleActivity = response;
        if (this.currentMasterPage === PageName.GoAppActivitiesPageComponent ||
          this.currentMasterPage == PageName.GoAppHomeComponent ||
          (this.currentMasterPage == PageName.ContactPageComponent)
        ) {
          if (this.NewActivitySource == 'ContactInfo' && response['contactID']) {
            activity.contactName = this.contactService.contactInformation.fullName;
          }
          this.activityOfflineService.selectedActivity = activity;
          await this.activityOfflineService.addActivity(activity);
        }
        if (!this.uiService.toolsActivityActive) {
          this.events.publish('refreshAgenda');
        } else this.uiService.agendaRefreshRequired = true;
        this.activityOfflineService.publishActivityEvent({ action: "Create", activity: activity });
        this.activityService.activityDetailsLoaded = true;
        this.uiService.showNewActivity = false;
        this.uiService.activeView = 'Sample';
        this.uiService.showRightPane = true;
        this.navService.popChildNavPageWithPageTracking();
        if (this.currentMasterPage === PageName.ContactPageComponent) {
          this.samplingOfflineService.samplingDetailsViewMode = SamplingDetailsViewMode.CREATE_FROM_CONTACT_PROFILE;
          this.pushChildNavPageWithPageTracking(PageName.NewSampleActivityComponent, PageName.NewSampleActivityComponent, this.currentMasterPage, { from: PageName.ContactPageComponent });
        } else {
          this.navService.setChildNavRoot(PageName.NewSampleActivityComponent, PageName.NewSampleActivityComponent, this.currentMasterPage, { from: PageName.GoAppHomeComponent });
        }
        this.footerService.initButtons(FooterViews.SampleDropDetails);
        this.footerService.disableButton(['samplingeligibilities', 'signature'])
      } catch (error) {
        this.notificationService.notify(this.translate.instant('NEW_ACTIVITY_TOAST_ERROR_CREATING_NEW_ALLOWCATION_ORDER'), 'New Activity', 'top', ToastStyle.INFO);
      }
    }
  }
  private async pushChildNavPageWithPageTracking(pageComponentToPush: any, newPageName: PageName, masterPageName?: PageName, params?: any, options?: any) {
    if (await this.navService.getActiveChildComponent() === NewActivityComponent && !await this.navService.canChildNavGoBack()) {
      await this.navService.setChildNavRoot(PageName.NothingSelectedView, PageName.NothingSelectedView, masterPageName, params);
    }
    return this.navService.pushChildNavPageWithPageTracking(pageComponentToPush, newPageName, masterPageName, params, options);
  }
  private async pushWithPageTracking(pageComponentToPush: any, newPageName: PageName, params?: any, masterPageName?: PageName, options?: any, navCtrl?: IonNav) {
    params = {
      __source: 'menu',
      ...(params || {})
    };
    return this.navService.pushWithPageTracking(pageComponentToPush, newPageName, params, masterPageName, options, navCtrl);
  }

  /**
   *
   *
   * @returns
   * @memberof NewActivityComponent
   */
  getRoundedTime(mDate) {
    if(this.authService.user.buSettings["indskr_meetingstarttimerounding"] === false) return mDate
    let d = mDate;
    if (d.getMinutes() < 30) {
      d.setMinutes(30);
      return d;
    } else {
      d.setMinutes(0);
      d.setHours(d.getHours() + 1);
      return d;
    }
  }

  private _selectedEvent;
  public get selectedEvent() {
    return this._selectedEvent;
  }

  public set selectedEvent(event) {
    this._selectedEvent = event;
    if (event) {
      this.startTime = event.startDate.toISOString();
      this.endTime = event.endDate.toISOString();
      this.prevStartTime = event.startDate.toISOString();
      this.prevEndTime = event.endDate.toISOString();
      this.orgDiffMinutes = this.dateTimeFormatsService.getDifferenceInMinutes(this.endTime, this.prevStartTime);
      this.duration = this.dateTimeFormatsService.getFormattedTimeInterval(this.startTime, this.endTime);
      this.initDateTimeFormFields();
    }
  }

  getFormattedTimeInterval(): void {
    let days: any = this.dateTimeFormatsService.getDifferenceInDays(this.endTime, this.startTime);
    let timeDifference: Date = new Date((new Date(this.endTime).setSeconds(0).valueOf() - new Date(this.startTime).setSeconds(0).valueOf()));
    let minutes: any = timeDifference.getUTCMinutes();
    let hours: any = timeDifference.getUTCHours();
    if (days === 0) {
      days = '';
    } else if (days <= 1) {
      days = days + ` ${this.translate.instant('DAY')}, `;
    }
    else {
      days = days + ` ${this.translate.instant('DAYS')}, `;
    }
    if (hours === 0) {
      hours = '';
    } else if (hours <= 1) {
      hours = hours + ` ${this.translate.instant('HOUR')}, `;
    }
    else {
      hours = hours + ` ${this.translate.instant('HOURS')}, `;
    }
    this.duration = days + '' + hours + '' + minutes + ` ${this.translate.instant('MINUTES')}`;
  }

  /**
   * Gets the duration in minutes for the current activity type
   * @returns {number} Duration in minutes (defaults to 30 if not available)
   * @private
   */
  private _getActivityDuration(): number {
    // Only use meeting_duration when explicitly creating a meeting
    if (this.uiService.activeViewNewMeeting === "meeting") {
      // Use meeting_duration if available and valid, otherwise default to 30
      const meetingDuration = this.authService.user?.meeting_duration;
      return (meetingDuration && meetingDuration > 0) ? meetingDuration : 30;
    }
    // For all other activity types, default to 30
    return 30;
  }

  setCellData() {
    const data: { view: string, data: { startDate: Date, endDate: Date } } = this.uiService.getCellData;
    const today = new Date();
    this.followupMeetingSubject = '';
    this.followUpMeetingContacts = [];

    if (this.navService.getCurrentMasterPageName() != PageName.GoAppActivitiesPageComponent) {
      this.startTime = (this.getRoundedTime(today)).toString();
    } else if (data && data.view === 'day-week-views') {
      this.cellData = data.data;
      this.startTime = this.cellData.startDate.toString();
    } else if (data && data.view === 'follow-up') {
      this.startTime = data.data.startDate.toString();
      this.endTime = data.data.endDate.toString();
      this.followupMeetingSubject = (this.activityOfflineService.selectedActivity) ? 'Follow-up: ' + this.activityOfflineService.selectedActivity.subject : 'Follow-up : New Activity';
      this.followUpMeetingContacts = (this.contactService.followUpMeetingContacts && this.contactService.followUpMeetingContacts.length > 0) ? this.contactService.followUpMeetingContacts : [];
    } else {
      this.startTime = (this.getRoundedTime(today)).toString();
    }
    this.startTime = this.dateTimeFormatsService.formatDateForAPI(this.startTime);
    if (this.cellData?.allDay) {
      this.endTime = data.data.endDate.toString();
    } else {
      this.endTime = this.dateTimeFormatsService.addMinutesToDate(this.startTime, this._getActivityDuration()).toISOString();
    }
    this.duration = this.dateTimeFormatsService.getFormattedTimeInterval(this.startTime, this.endTime);
    let dateTime = { startDateTime: this.startTime, endDateTime: this.endTime };
    this.dateTimeFormatsService.updateLimitedMinTime.next(dateTime);
  }

  private _initTimeForCalendarPage(isSetActivity: boolean = false) {
    if (this.updateCellClicked && this.cellData) {
      return;
    }
    
    let selectedDate: Date = new Date();
    const today: Date = new Date();
    let isInCalendarView: boolean = false;
    if (this.agendaFooterService.actSegment == "week" && this.uiService.selectedCalendarDateInWeekView && this.dateTimeFormatsService.isValidDate(this.uiService.selectedCalendarDateInWeekView)) {
      isInCalendarView = true;
      selectedDate = this.uiService.selectedCalendarDateInWeekView;
    }
    if (isInCalendarView && isSetActivity) {
      this.startTime = selectedDate.toString();
    } else {
      if (this.dateTimeFormatsService.isTodayDate(selectedDate)) {
        selectedDate.setHours(today.getHours());
        selectedDate.setMinutes(today.getMinutes());
        this.startTime = (this.getRoundedTime(selectedDate)).toString();
      } else {
        selectedDate.setHours(8);
        selectedDate.setMinutes(0);
        selectedDate.setMilliseconds(0);
        this.startTime = selectedDate.toString();
      }
    }

    this.startTime = this.dateTimeFormatsService.formatDateForAPI(this.startTime);
    this.endTime = this.dateTimeFormatsService.addMinutesToDate(this.startTime, this._getActivityDuration()).toISOString();
    this.duration = this.dateTimeFormatsService.getFormattedTimeInterval(this.startTime, this.endTime);
    let dateTime = { startDateTime: this.startTime, endDateTime: this.endTime };
    this.dateTimeFormatsService.updateLimitedMinTime.next(dateTime);
  }

  private async createNewTimeOff() {
    if (this._newTimeOffCmp instanceof NewTimeOffComponent) {
      await this._newTimeOffCmp.saveTimeOff(false);
    }
  }

  channelNameTranslation(channel) {
    return this.directMessagingService.translateNewActivityChannelTitle(channel);
  }


  updateFollowUpTaskCategory(category: string) {
    this.followUpActionCategory = this.followUpActionCategory != category ? category : null;
  }

  private async handleNewSAPFollowUpAction(): Promise<any> {
    return new Promise(async (resolve, reject) => {

      this.trackingService.tracking('ScientificPlanFollowupTask', TrackingEventNames.SCIENTIFICACTIVITYPLAN);
      let errorOccured: boolean = false;
      let currentTime = new Date().getTime();
      let start = this.dateTimeFormatsService.toISOString(new Date().setHours(0, 0, 0, 0));

      if (this.uiService.activitiesPageTab === 'day' && this.uiService.selectedCalendarDateInWeekView) {
        start = this.dateTimeFormatsService.toISOString(this.uiService.selectedCalendarDateInWeekView.setHours(0, 0, 0, 0));
      }
      if (this.agendaFooterService.actSegment === 'week' && this.uiService.selectedCalendarDateInWeekView && this.navService.getCurrentMasterPageName() === PageName.GoAppActivitiesPageComponent) {
        start = this.dateTimeFormatsService.toISOString(this.uiService.selectedCalendarDateInWeekView.setHours(0, 0, 0, 0));
      }
      if (this.uiService.activitiesPageTab === 'agenda' && this.uiService.selectedCalendarDateInMonthView) {
        start = this.uiService.selectedCalendarDateInMonthView.toLocaleDateString();
      }

      let payload = {
        activityId: 'offline_followup_' + currentTime,
        activitytypecode: 'followuptask',
        subject: 'Follow-up Action',
        offlineId: 'offline_followup_' + currentTime,
        scheduledstart: new Date(start).getTime(),
        indskr_plantype: FOLLOW_UP_TYPE.SCIENTIFIC_PLAN,
      };
      if (this.isLayoverPushView) {
        if (this.layoverViewPushedFrom == 'ScientificActivityPage') {
          if (this.layoverViewPassedData) {
            payload['indskr_scientificplan'] = this.layoverViewPassedData.ID;
            payload['scientifiPlanName'] = this.layoverViewPassedData.scientificActivityPlanName;
          }
          if (this.contact) {
            payload['indskr_contact'] = this.contactService.contactInformation.ID;
            payload['contactName'] = this.contactService.contactInformation.fullName;
          }
        }
      }
      if (this.currentMasterPage == PageName.ContactPageComponent && this.contactService.contactInformation) {
        payload['indskr_contact'] = this.contactService.contactInformation.ID;
        payload['contactName'] = this.contactService.contactInformation.fullName;
      }
      else {
      }
      let newFollowUp = new FollowUpActivity(payload);
      newFollowUp.state = 0;
      newFollowUp.statusString = 'Open';
      newFollowUp.ownerId = this.authenticationOfflineService.user.systemUserID;
      newFollowUp.ownerNameString = this.authenticationOfflineService.user.displayName;
      newFollowUp.pendingPushToDynamics = true;
      await this.followUpActivityDataService.createFollowUpActivity({ onDynamics: !this.device.isOffline, onLocalCopy: true, onLocalDatabase: true }, [newFollowUp], currentTime, false).then(succ => {
        //Successfully created new follow up activity
        this.activityOfflineService.selectedActivity = newFollowUp;
      }).catch(err => {
        // Handle any error occured during follow up activity creation
        reject('Error occured while creating Scientific Activity Plan');
        errorOccured = true;
      });
      if (!errorOccured) {
        let from: string = 'AgendaView';
        let pageName: PageName = PageName.GoAppActivitiesPageComponent;
        if (this.isLayoverPushView) {
          this.navService.popChildNavPageWithPageTracking();
          if (this.layoverViewPushedFrom == 'ScientificActivityPage') {
            from = 'ScientificActivityPage';
            pageName = PageName.ScientificActivityPage;
            if (this.uiService.activitiesPagePlanTabSelectedPlan === 'scientificPlans') {
              this.uiService.activeView = 'ActivitiesPageRightPaneNav';
              this.uiService.showNewActivity = false;
              this.uiService.showRightPane = true;
            }
            this.pushChildNavPageWithPageTracking(PageName.ScientificPlanFollowUpTask, PageName.ScientificPlanFollowUpTask, PageName.ScientificActivityPage, { from: from, activity: newFollowUp });
          } else if (this.layoverViewPushedFrom === 'ContactPageComponent') {
            from = 'ContactTools';
            pageName = PageName.ContactPageComponent;
            this.uiService.showNewActivity = false;
            this.pushChildNavPageWithPageTracking(PageName.ScientificPlanFollowUpTask, PageName.ScientificPlanFollowUpTask, PageName.ScientificActivityPage, { from: from, activity: newFollowUp });
          }
        }
        /**
         *  HANDLE OTHER CASES
         */
        else { // Assume follow up actiion is being created from agenda
          this.navService.setChildNavRoot(PageName.ScientificPlanFollowUpTask, PageName.ScientificPlanFollowUpTask, PageName.GoAppActivitiesPageComponent, { from: from, activity: newFollowUp });
          this.uiService.activeView = 'ActivitiesPageRightPaneNav';
          this.uiService.showNewActivity = false;
          this.uiService.showRightPane = true;
          if (this.uiService.activitiesPageTab == 'day' || this.activityOfflineService.newHomeView === 'calendarView') {
            let data = {
              id: newFollowUp.ID,
              subject: newFollowUp.subject,
              location: newFollowUp.location,
              scheduledStart: newFollowUp.scheduledStart,
              scheduledEnd: newFollowUp.scheduledEnd,
              type: newFollowUp.type,
            };
            this.uiService.setUIServiceData({
              view: 'new-activity', data,
            });
          }
        }
        if (this.navService.getCurrentMasterPageName() == PageName.GoAppActivitiesPageComponent && this.activityOfflineService.newHomeView !== 'calendarView') {

          this.events.publish('refreshAgenda');
        } else {
          this.uiService.agendaRefreshRequired = true;
        }
        resolve('');
      }
    });
  }

  private async createCustomerInquiryForMeeting(source: AccesingMode) {
    await this.sharedDataService.createInMeetingInquiry(source, this.type);
    if (source === AccesingMode.PRESENTATION) {
      this.trackingService.tracking('InquiryActivityFromMeetingPresentation', TrackingEventNames.CUSTOMER_INQUIRY);
    }
    else if (source === AccesingMode.INMEETING) {
      this.trackingService.tracking('InquiryActivityFromMeeting', TrackingEventNames.CUSTOMER_INQUIRY);
    } else if (source == AccesingMode.IN_PHONE_CALL) {
      this.trackingService.tracking('SelectConfirm', TrackingEventNames.PHONECALL);
      this.phoneCallMeetingStructureService.createInPhoneCallMeetingEmbededActivity(this.caseManagementService.currentCase);
      await this.phoneCallMeetingStructureService.openInPhoneCallMeetingCaseModal(this.caseManagementService.currentCase);
      return
    }
    else if(source == AccesingMode.IN_SET_BOOKING) {
      this.setBookingDataService.createInKitBookingMeetingEmbededActivity(this.caseManagementService.currentCase);
      await this.setBookingDataService.openInKitBookingMeetingCaseModal(this.caseManagementService.currentCase);
      return
    }
    this.meetingStructureService.createInMeetingEmbededActivity(this.caseManagementService.currentCase);
    await this.meetingStructureService.openInMeetingCaseModal(this.caseManagementService.currentCase);
  }

  async openCaseDetailsView(data, source: AccesingMode) {
    /* If modal is already opened then ignore request else open a new modal and destroy instance on*/
    if (this.pageModal) return;

    this.caseManagementService.accessedFrom = source;
    this.caseManagementService.assignSelectedCase(data);
    const cssClass = this.navService.getCurrentPageName() === PageName.GoAppActivitiesPageComponent && !this.device.isMobileDevice ? ['inMeetingCases', 'HomeScreen'] : ['inMeetingCases'];
    this.pageModal = await this.modalCtrl.create({
      component: InMeetingCasesComponent, componentProps: {
        type: ActivityType.CaseIntake,
        view: 'case-details'
      }, backdropDismiss: false, cssClass: cssClass
    })
    this.pageModal.present();
    this.pageModal.onDidDismiss().then((data) => {
      this.events.publish('detectChangesOnActivityDetails');
      if (source === AccesingMode.PRESENTATION) {
        this.footerService.initButtons(FooterViews.PreviewMeeting);
      }
      else if (source === AccesingMode.INMEETING) {
        this.footerService.initButtons(FooterViews.Activities);
      }

      //reset the modalHandler for next flow
      this.pageModal = undefined;
    });
  }
  procedureLogSelectionType(type: string) {
    if (type == 'procedureLog') {
      this.procedureLogSelection = type;
      this.procedureCategory = null;
    }
  }
  selectProcedureCategory(procedureCategory: string) {
    if (procedureCategory == 'procedure_tracker') {
      this.procedureLogSelection = '';
    }
    this.procedureCategory = this.procedureCategory !== procedureCategory ? procedureCategory : null;
    this._cd.markForCheck();
    this.initHeaderOnOptionSelection();
  }

  onProcedureCategoryChange(procedureCategory: string) {
    if (procedureCategory == 'procedure_tracker') {
      this.procedureLogSelection = '';
    }
    this.procedureCategory = procedureCategory;
  }
  selectMessagingType(type) {
    this.selectedMessagingChannelType = this.selectedMessagingChannelType != type ? type : null;
    this._cd.markForCheck();
    this.initHeaderOnOptionSelection();
  }

  onChannelChange(channel) {
    this.selectedMessagingChannelType = channel;
  }

  selectCaseType(type) {
    this.type = type;
  }

  selectCaseManagementType(type) {
    if(this.caseManagementService.caseTypeList && this.caseManagementService.caseTypeList.length === 1) {
      this.type = this.caseManagementService.caseTypeList[0];
    } else {
      this.type = this.type != type ? type : null;
    }
    this._cd.markForCheck();
    this.initHeaderOnOptionSelection();
  }

  selectFollowupActionCategory(category) {
    this.followUpActionCategory = this.followUpActionCategory !== category ? category : null;
    this._cd.markForCheck();
    this.initHeaderOnOptionSelection();
  }

  getFollowUpActionCategories(): {label: string, value: string}[] {
    const categories: {label: string, value: string}[] = [];
    
    if (this.isNoneTaskEnabled) {
      categories.push({ label: 'NONE', value: 'none' });
    }
    if (this.isAccountPlanTaskEnabled) {
      categories.push({ label: 'NEW_ACTIVITY_ACCOUNT_PLAN_ACTION', value: 'accountplantask' });
    }
    if (this.isScientificPlanTaskEnabled) {
      categories.push({ label: 'NEW_ACTIVITY_SCIENTIFIC_PALN_ACTION', value: 'scientificplantask' });
    }
    if (this.isOpportunityTaskEnabled) {
      categories.push({ label: 'NEW_ACTIVITY_OPPORTUNITY_ACTION', value: 'opportunitytask' });
    }
    if (this.isMeetingTaskEnabled) {
      categories.push({ label: 'NEW_ACTIVITY_MEETING_ACTION', value: 'meetingtask' });
    }
    if (this.isMarketingPlanTaskEnabled) {
      categories.push({ label: 'MARKETING_BUSINESS_PLAN_ACTION', value: 'marketingplantask' });
    }
    if (this.isEventFollowUpActionEnabled) {
      categories.push({ label: 'EVENT_ACTION', value: 'eventtask' });
    }
    
    return categories;
  }

  onFollowUpActionCategoryChange(category: string) {
    this.followUpActionCategory = category;
  }

  selectInsightType(type: INSIGHT_TYPE) {
    this.selectedInsightType = this.selectedInsightType !== type ? type : null;
    this._cd.markForCheck();
    this.initHeaderOnOptionSelection();
  }

  private initDateTimeFormFields() {
    let dateTimeValue = this.getFormattedDateTimeText();
    if (dateTimeValue) {
      this.startDateTime = dateTimeValue.startDateTime;
      this.startDateValue = dateTimeValue.startDate;
      this.startTimeValue = dateTimeValue.startTime;
      this.endDateTime = dateTimeValue.endDateTime;
      this.endDateValue = dateTimeValue.endDate;
      this.endTimeValue = dateTimeValue.endTime;
      this.duration = dateTimeValue.duration;
    }
    this.startDateField = {
      isDateField: true,
      isNewActivityView: true,
      label: this.translate.instant('START_DATE'),
      inputText: this.startDateValue,
      startDateTimeValue: this.startDateTime,
      endDateTimeValue: this.endDateTime,
      fromViewPage: CurViewPageType.NewActivity,
      id: DateTimeFieldType.StartDateField,
      isReadOnly: true,
      isDisabled: false,
      showArrow: true,
      eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
    };
    this.startTimeField = {
      isTimeField: true,
      isNewActivityView: true,
      label: this.translate.instant('START_TIME'),
      inputText: this.startTimeValue,
      startDateTimeValue: this.startDateTime,
      endDateTimeValue: this.endDateTime,
      fromViewPage: CurViewPageType.NewActivity,
      id: DateTimeFieldType.StartTimeField,
      isReadOnly: true,
      isDisabled: false,
      showArrow: true,
    };
    this.endDateField = {
      isDateField: true,
      isNewActivityView: true,
      label: this.translate.instant('END_DATE'),
      inputText: this.endDateValue,
      startDateTimeValue: this.startDateTime,
      endDateTimeValue: this.endDateTime,
      fromViewPage: CurViewPageType.NewActivity,
      id: DateTimeFieldType.EndDateField,
      isReadOnly: true,
      isDisabled: false,
      showArrow: true,
      eventHandler: (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName),
    };
    this.endTimeField = {
      isTimeField: true,
      isNewActivityView: true,
      label: this.translate.instant('END_TIME'),
      inputText: this.endTimeValue,
      startDateTimeValue: this.startDateTime,
      endDateTimeValue: this.endDateTime,
      fromViewPage: CurViewPageType.NewActivity,
      id: DateTimeFieldType.EndTimeField,
      isReadOnly: true,
      isDisabled: false,
      showArrow: true,
      isHidden: !this.hasMeetingEndDateEnabled,
    };
    this.durationField = {
      isDurationField: true,
      isNewActivityView: true,
      label: this.translate.instant('DURATION'),
      inputText: this.duration,
      id: DateTimeFieldType.TimeDurationField,
      isReadOnly: true,
      isDisabled: false,
      showArrow: false,
      isHidden: !this.hasMeetingDurationEnabled && !this.hasMeetingEndDateEnabled,
    };
    if (this.hasMeetingDurationEnabled) {
      this.durationField.showArrow = true;
      this.durationField.eventHandler = (id: string, event, eventName) => this.handleFormFieldEvent(id, event, eventName);
    }

    if (this.hasMeetingDurationRequired) {
      this.durationField.isRequired = true;
    }

    this.activityOfflineService.signalConflictCheck$.next({ componentUuid: this.uuid, signal: true, start: new Date(this.startDateTime), end: new Date(this.endDateTime) });
  }

  private handleFormFieldEvent(id, event, eventName) {
    if (id) {
      switch (id) {
        case 'start-date-field':
          this.openStartDatePicker(event);
          break;
        case 'end-date-field':
          this.openEndDatePicker(event);
          break;
        case DateTimeFieldType.TimeDurationField:
          this.selectDuration(event);
          break;
        default:
          break;
      }
    }
  }

  async openStartDatePicker(myEvent) {
    this.activityOfflineService.dateTimePickerType = DateTimeFieldType.StartDateField;
    let popover = await this.popoverCtrl.create(
      {
        component: IndDatetimeFormComponent,
        componentProps: {
          currentViewPage: CurViewPageType.NewActivity,
          startDateTimeValue: this.startDateTime,
          endDateTimeValue: this.endDateTime
        },
        cssClass: "datetime-popover"
      }
    );
    popover.onDidDismiss().then((data: any) => {
      this.logService.logDebug(data);
      if (data !== null && !isEmpty(data.data) && data.data.startTime != '') {
        let selectedDate = data.data.startTime;
        let selectedTime = this.dateTimeFormatsService.getFormattedTimeValue(this.startDateTime);
        // new Date() is not supported date format as "DD/MM/YY" and "D/M/YY" when date and time are combined.
        // set 'MMM dd, yyyy' and 'en-US' to combine date and time, and changed date format will be adjusted through getFormattedDateTimeText().
        let getStartDate = this.datePipe.transform(selectedDate, "MMM dd, yyyy", undefined, 'en-US');
        let setCombinedDateTime = new Date(getStartDate + ' ' + selectedTime).toISOString();
        this.startTime = setCombinedDateTime;
      }
      this.handleStartDateTimeValue();
    });
    popover.present();
  }

  async openEndDatePicker(myEvent) {
    this.activityOfflineService.dateTimePickerType = DateTimeFieldType.EndDateField;
    let popover = await this.popoverCtrl.create(
      {
        component: IndDatetimeFormComponent,
        componentProps: {
          currentViewPage: CurViewPageType.NewActivity,
          startDateTimeValue: this.startDateTime,
          endDateTimeValue: this.endDateTime
        },
        cssClass: "datetime-popover"
      }
    );
    popover.onDidDismiss().then((data: any) => {
      this.logService.logDebug(data);
      if (data !== null && !isEmpty(data.data) && data.data.endTime != '') {
        let selectedDate = data.data.endTime;
        let selectedTime = this.dateTimeFormatsService.getFormattedTimeValue(this.endDateTime);
        // new Date() is not supported date format as "DD/MM/YY" and "D/M/YY" when date and time are combined.
        // set 'MMM dd, yyyy' and 'en-US' to combine date and time, and changed date format will be adjusted through getFormattedDateTimeText().
        let getEndDate = this.datePipe.transform(selectedDate, "MMM dd, yyyy", undefined, 'en-US');
        let setCombinedDateTime = new Date(getEndDate + ' ' + selectedTime).toISOString();
        this.endTime = setCombinedDateTime;
      }
      this.handleEndDateTimeValue();
    });
    popover.present();
  }

  private async selectDuration(event) {
    const popover = await this.popoverCtrl.create({
      component: IndDropdownListComponent,
      componentProps: {
        viewData: {
          id: 'duration-field',
          data: range(1, 61).map(option => {
            return { title: option == 60 ? '1 Hour' : `${option} Minute${option > 1 ? 's' : ''}`, id: option.toString(), isSelected: false }
          })
        }
      },
      cssClass: 'subject-popover',
      event: event
    });
    await popover.present();
    const data = (await popover.onDidDismiss())?.data?.selectedItems[0];
    if (this.backgroundUploadInProgress) return;
    if (data) {
      let selectedDuration = parseInt(data.id);
      if (!this.dateTimeFormatsService.isValidDate(new Date(this.startTime))) {
        this.notificationService.notify(this.translate.instant('NEW_ACTIVITY_TOAST_INVALID_DATE'), 'New Activity', 'top', ToastStyle.DANGER);
        return;
      } else {
        this.endTime = this.dateTimeFormatsService.addMinutesToDate(this.startTime, selectedDuration).toISOString();
        this.duration = this.dateTimeFormatsService.getFormattedTimeInterval(this.startTime, this.endTime);
        this.initDateTimeFormFields();
        this._cd.markForCheck();
      }
    }
  }

  private handleStartDateTimeValue() {
    if (this.uiService.activeViewNewMeeting == 'phonecall') {
      this.trackingService.tracking('Select Start Date', TrackingEventNames.PHONECALL)
    }
    if (!this.dateTimeFormatsService.isValidDate(new Date(this.startTime))) {
      this.notificationService.notify(this.translate.instant('NEW_ACTIVITY_TOAST_INVALID_DATE'), 'New Activity', 'top', ToastStyle.DANGER);
      this.startTime = this.prevStartTime;
    } else {
      if (this.uiService.activeViewNewMeeting == 'meeting' && this.uiService.activeViewNewMeetingType === 'live') {
        this.endTime = this.dateTimeFormatsService.addMinutesToDate(this.startTime, this.orgDiffMinutes).toISOString();
      } else {
        let addedMinutes: number = this._getActivityDuration();
        this.endTime = this.dateTimeFormatsService.addMinutesToDate(this.startTime, addedMinutes).toISOString();
      }
      this.prevStartTime = this.startTime;
      this.duration = this.dateTimeFormatsService.getFormattedTimeInterval(this.startTime, this.endTime);
      this.initDateTimeFormFields();
      this._cd.markForCheck();
    }
  }

  private handleEndDateTimeValue() {
    if (this.uiService.activeViewNewMeeting == 'phonecall') {
      this.trackingService.tracking('Select End time', TrackingEventNames.PHONECALL)
    }
    if (!this.dateTimeFormatsService.isValidDate(new Date(this.endTime))) {
      this.notificationService.notify(this.translate.instant('NEW_ACTIVITY_TOAST_INVALID_DATE'), 'New Activity', 'top', ToastStyle.DANGER);
      this.endTime = this.prevEndTime;
    } else {
      this.prevEndTime = this.endTime;
      this.duration = this.dateTimeFormatsService.getFormattedTimeInterval(this.startTime, this.endTime);
      this.initDateTimeFormFields();
      this._cd.markForCheck();
    }
  }

  getFormattedDateTimeText(): any {
    let startDateTimeValue: Date = new Date(this.startTime);
    let endDateTimeValue: Date = new Date(this.endTime);
    let startDay = this.datePipe.transform(startDateTimeValue, this.dateTimeFormatsService.date, undefined, this.translate.currentLang);
    let endDay = this.datePipe.transform(endDateTimeValue, this.dateTimeFormatsService.date, undefined, this.translate.currentLang);
    let startTime = startDateTimeValue.toLocaleTimeString('en-US', { hour12: this.dateTimeFormatsService.is12HourFormat, hour: '2-digit', minute: '2-digit' });
    let endTime = endDateTimeValue.toLocaleTimeString('en-US', { hour12: this.dateTimeFormatsService.is12HourFormat, hour: '2-digit', minute: '2-digit' });
    let formattedDuration = this.dateTimeFormatsService.getFormattedTimeInterval(startDateTimeValue, endDateTimeValue);

    let dateTimeValue: any = {
      startDateTime: null,
      startDate: null,
      startTime: '',
      endDateTime: '',
      endDate: '',
      endTime: '',
      duration: '',
    };

    dateTimeValue = {
      startDateTime: startDateTimeValue,
      startDate: startDay,
      startTime: startTime,
      endDateTime: endDateTimeValue,
      endDate: endDay,
      endTime: endTime,
      duration: formattedDuration,
    };
    return dateTimeValue;
  }

  selectConsentCustomer(contact, forceSelect?) {
    this.selectedConsentCustomer = (forceSelect || this.selectedConsentCustomer != contact) ? contact : null;
    this.contactService.contactInformation = this.selectedConsentCustomer;
    this._cd.markForCheck();
    this.initHeaderOnOptionSelection();
  }

  private _handleNewOpportunity() {
    if (this.contact && this.contact.accountRelationships && this.contact.accountRelationships.length > 0 && this.opportunityService.stakeholderRoles.length > 0) {
      let account;
      for (let i = 0; i < this.contact.accountRelationships.length && !account; i++) {
        account = this.accountService.getAccountById(this.contact.accountRelationships[i].accountId);
      }
      if (account) {
        this.uiService.prevView = this.uiService.activeView;
        this.navService.popToRootWithPageTracking();
        this.pushWithPageTracking(PageName.OpportunityManagementPage, PageName.OpportunityManagementPage, { 'listMode': ComponentViewMode.LISTVIEW, contactToCreateOpportunity: this.contact }, PageName.OpportunityManagementPage);
      }
    }
    else if (this.account) {
      let account;
      account = this.accountService.getAccountById(this.account.id);
      if (account) {
        this.uiService.prevView = this.uiService.activeView;
        this.navService.popToRootWithPageTracking();
        this.pushWithPageTracking(PageName.OpportunityManagementPage, PageName.OpportunityManagementPage, { 'listMode': ComponentViewMode.LISTVIEW, accountToCreateOpportunity: this.account }, PageName.OpportunityManagementPage);
      }
    }
    else {
      this.notificationService.notify(this.translate.instant('NEW_OPPORTUNITY_TOAST_NO_ACCOUNT'), 'New Activity', 'top', ToastStyle.DANGER);
      return;
    }
  }

  private _openSurvey() {
    if (!this.contactService.loadedContacts || this.backgroundUploadInProgress) return;
    this.uiService.prevView = this.uiService.activeView;
    this.uiService.showNewActivity = false;
    this.customerSurveyService.inMeetingSelectedSurveyId = null;
    this.pushWithPageTracking(PageName.SurveyPageComponent, PageName.SurveyPageComponent,
      { appointmentId: this.activityOfflineService.selectedActivity.ID, from: this.activityOfflineService.activitySource, __fullscreen: true}, PageName.SurveyPageComponent);
  }

  private async handleNewKitBooking(){
    let kitBookingDynamicForm: DynamicForm = this.dynamicFormService.getFormDefinitionForEntity('indskr_setbooking',FormType.CREATEFORM);
    const nonVisibleFormSection = this.setBookingDataService.formSectionConfigure?.filter(config => config['_indskr_mobileappform_value'] == kitBookingDynamicForm?.mobileFormId && !config['indskr_visibility']);
    kitBookingDynamicForm?.metadata.forEach(tab => {
      tab.controls.forEach(control => {
        if (control.dataType && control.attributeName && !isEmpty(nonVisibleFormSection) && nonVisibleFormSection.some(sec => sec['indskr_name'].toLowerCase() == control.attributeName.toLowerCase())) {
          control.isVisible = false;
          control.forceHide = true;
        } else if (!control.dataType && control.subgrid && !isEmpty(nonVisibleFormSection) && nonVisibleFormSection.some(sec => sec['indskr_name'].toLowerCase() == control.attributeName.toLowerCase())) {
          control.isVisible = false;
          control.forceHide = true;
        }
      });
    });
    const formType = DynamicFormType.CONFIGUREDFORM;
    if (kitBookingDynamicForm) {
      let formDetail: DynamicFormComponentModel = {
        title: this.translate.instant('KIT_BOOKING'),
        LookupEntitySetName: 'indskr_setbookings',
        showLeftHeaderButton: true,
        leftHeaderBtnIcon: 'chevron-back-outline',
        showRightHeaderButton: true,
        rightHeaderImgSrc: 'assets/imgs/header_save.svg',
        rightHeaderBtnText: this.translate.instant('SAVE'),
        formMetadata: kitBookingDynamicForm,
        formEntityObject: null,
        mainEntityObjectId: null,
        dynamicFormType: formType,
        navOptions: { animate: false },
        eventsHandler: (data: any, eventTarget: string, refData: DynamicFormComponentModel) => this._handleKitBookingFormComponentEvent(data, eventTarget, refData),
      };
      if(this.layoverViewPushedFrom){
        let from ="";
        formDetail.formEntityObject = {};
        let pageName;
        if(this.layoverViewPushedFrom == "AccountTool"){
          formDetail.formEntityObject['_indskr_accountnamesoldto_value'] = this.layoverViewPassedData?.id;
          formDetail.formEntityObject['_indskr_accountnamesoldto_value@OData.Community.Display.V1.FormattedValue'] = this.layoverViewPassedData?.accountName;
          from = "KitBookingfromAccountTool";
          pageName = PageName.AccountPageComponent;
          this.uiService.activeView = 'AccountPageRightPaneNav';
        }
        if(this.layoverViewPushedFrom == "ContactPageComponent"){
          formDetail.formEntityObject['_indskr_surgeoncontact_value'] = this.contactService.contactInformation?.ID;
          formDetail.formEntityObject['_indskr_surgeoncontact_value@OData.Community.Display.V1.FormattedValue'] = this.contactService.contactInformation?.fullname;
          from = "KitBookingfromContactTool";
          pageName = PageName.ContactPageComponent;
          this.uiService.activeView = 'ContactPageRightPaneNav';
        }
        this.uiService.showNewActivity = false;
        await this.navService.popChildNavPageWithPageTracking();
        this.pushChildNavPageWithPageTracking(PageName.DynamicFormComponent, PageName.DynamicFormComponent, pageName, {
          MODE: 'CREATE_MODE',
          FORM_DETAIL: formDetail,
          from: from,
        });
        this.footerService.initButtons(FooterViews.Accounts);
        this.activityOfflineService.finalizeAgendaRefresh();
      }
      else{
        this.navService.setChildNavRoot(PageName.DynamicFormComponent, PageName.DynamicFormComponent, PageName.GoAppActivitiesPageComponent, {
          MODE: 'CREATE_MODE',
          FORM_DETAIL: formDetail,
        });
        this.footerService.initButtons(FooterViews.Accounts);
        this.navService.setChildNavRightPaneView(true);
        this.uiService.showNewActivity = false;
        this.activityOfflineService.selected = null;
      }

    }
  }

  private async handleNewMedicalInquiry(): Promise<void> {
    this.uiService.showNewActivity = false;
    this.uiService.showRightPane = true;

    // Contact tool: open in the contact page's own child nav, the shape Customer Inquiry and
    // Phone Call use from here, rather than throwing the user over to the agenda right pane.
    if (this.layoverViewPushedFrom === 'ContactPageComponent') {
      // Recorded before we navigate so the detail's back button has a view to restore,
      // the same handshake case-management-detail relies on for AccesingMode.CONTACT.
      this.uiService.prevView = this.uiService.activeView;
      await this.navService.popChildNavPageWithPageTracking();
      await this.pushChildNavPageWithPageTracking(
        MedicalInquiryNewComponent,
        PageName.MedicalInquiryNewComponent,
        PageName.ContactPageComponent,
        { from: 'ContactTool', contact: this.contactService.contactInformation }
      );
      return;
    }

    if (this.NewActivitySource === ActivitySource.MEETING_DETAIL
      || this.NewActivitySource === ActivitySource.MEETING_PRESENTATION) {
      this.medicalInquiryService.isCreatingFromMeeting = true;
      await this.createMedicalInquiryForMeeting();
      if (this.isLayoverPushView) {
        this.navService.popChildNavPageWithPageTracking();
      }
    } else {
      // HOME context: push into Activities right pane
      this.uiService.activeView = 'ActivitiesPageRightPaneNav';
      this.navService.setChildNavRoot(
        PageName.NothingSelectedView,
        PageName.NothingSelectedView,
        PageName.GoAppActivitiesPageComponent
      );
      await this.pushChildNavPageWithPageTracking(
        MedicalInquiryNewComponent,
        PageName.MedicalInquiryNewComponent,
        PageName.GoAppActivitiesPageComponent,
        { from: 'NewActivity' }
      );
    }
  }

  private async createMedicalInquiryForMeeting(): Promise<void> {
    // The presentation screen has no in-meeting modal - its activities open in the screen's own
    // child nav. Same shape openInMeetingCaseModal uses for Customer Inquiry from presentation.
    if (this.NewActivitySource === ActivitySource.MEETING_PRESENTATION) {
      await this.navService.popToRootChildNavPageWithPageTracking();
      await this.navService.pushChildNavPageWithPageTracking(
        PageName.MedicalInquiryNewComponent,
        PageName.MedicalInquiryNewComponent,
        PageName.PresentationMeetingComponent,
        { from: 'InMeetingPresentation' }
      );
      return;
    }
    // Follows the createCustomerInquiryForMeeting pattern
    await this.meetingStructureService.openInMeetingMedicalInquiryModal();
  }

  private async _validateLimitedReleaseProducts(data: any, eventTarget: string): Promise<boolean> {
    if(eventTarget != 'SUBMITKITBOOKING' || !data.formValue["indskr_setbookingid"]) {
      return true;
    }
    const selectedProductIds = await this._getSelectedProductIds(data);
    if(!selectedProductIds?.length) return true;

    const productLimitedRelease = await this.setBookingDataService.getLimitedReleaseInfoForSelectedProduct(selectedProductIds);
    if(!productLimitedRelease?.length) return true;

    const limitedReleaseProducts = productLimitedRelease.filter(pr => pr.indskr_limitedrelease);
    if(limitedReleaseProducts.length > 0) {
      return await this._validatePHMCAccount(data);
    }
    
    return true;
  } 

  private async _getSelectedProductIds(data: any): Promise<string[]> {
    const selectedProductIds: string[] = [];

    if(this.linkEntitiesReqPayload?.length) {
      this.linkEntitiesReqPayload.forEach(payload => {
        if(payload.values?.lookupfields?.length) {
          payload.values.lookupfields.forEach((field: any) => {
            if(field.name === "indskr_product") {
              selectedProductIds.push(field.id);
            }
          });
        }
      });
    } else {
      const setBookingProductsArray = await this.diskService.retrieve(DB_KEY_PREFIXES.SET_BOOKING_LINKED_ENTITY + "indskr_setbookingproduct");
      const linkEntityProductsData = setBookingProductsArray?.raw?.filter(x => 
        x["indskr_setbookingid"] === data.formValue["indskr_setbookingid"] && 
        (!x.hasOwnProperty('indskr_setbookingproduct.statecode') || x['indskr_setbookingproduct.statecode'] == 0)
      );
      
      if(linkEntityProductsData?.length) {
        linkEntityProductsData.forEach(pro => {
          selectedProductIds.push(pro["indskr_setbookingproduct.indskr_product"]);
        });
      }
    }

    return selectedProductIds;
  }



  private async _validatePHMCAccount(data: any): Promise<boolean> {
    const phmcIndex = this._findPHMCAccountIndex(data.formValue);
    
    if(phmcIndex >= 0 && this.authService.user.buSettings["indskr_limitedreleasebookingmessage"]) {
      const res = await this.alertService.showAlert({
        header: this.translate.instant('NOTE'),
        message: this.authService.user.buSettings["indskr_limitedreleasebookingmessage"],
        backdropDismiss: false,
      }, this.translate.instant('OK'));
      
      if(res?.role === "cancel") return false;
    } else if(phmcIndex < 0) {
      this.notificationService.notify(this.translate.instant('KIT_BOOKING_PHMC_ERROR_MSG'), 'New Activity', 'top', ToastStyle.DANGER);
      return false;
    }

    return true;
  }

  private _findPHMCAccountIndex(formValue: any): number {
    if(!formValue.hasOwnProperty('lookupfields')) return -1;
    
    return formValue['lookupfields'].findIndex((a: any) => 
      a.name === "indskr_PHMCAccount" && 
      !(a['isDeleted'] && a['isDeleted'] === true) && 
      a.id
    );
  }

  private _handleKitBookingSuccess(newSetBooking: SetBookingActivity, data: any, eventTarget: string, res: any) {
    if (this.uiService.activitiesPageTab == 'day' || this.activityOfflineService.newHomeView === 'calendarView') {
      let uiData = {
        id: newSetBooking.ID,
        subject: newSetBooking.subject,
        location: newSetBooking.statusString,
        scheduledStart: newSetBooking.scheduledStart,
        scheduledEnd: newSetBooking.scheduledEnd,
        type: newSetBooking.type,
      };
      this.uiService.setUIServiceData({
        view: 'new-activity', data: uiData,
      });
    }
    this.activityOfflineService.finalizeAgendaRefresh();
    if (this.agendaFooterService.actSegment === 'week') {
      this.events.publish('weekview:RefreshUI');
    }
    
    if(!data || !data.eventsHandler) {
      return;
    }
    
    let rawDetails = { indskr_setbookingid: newSetBooking.ID };
    this.activityOfflineService.selected = newSetBooking;
    this.dynamicFormService.linkedEntityFormIsDirtyTracker = false;
    this.setBookingDataService._isCreateEditKitBookingFormDirty = false;
    
    if (data.isFormSaved) {
      this._handleFormSavedNavigation(data, eventTarget, newSetBooking);
      data.eventsHandler(rawDetails, 'NEWDATAUPDATED');
      if(eventTarget == "SUBMITKITBOOKING") {
        this.notificationService.notify(this.translate.instant('KIT_BOOKING_USER_SUBMITTED'), "ContactInfoComponent", "top", ToastStyle.KITBOOKING_INFO, 3000);
      } else {
        this.notificationService.notify(this.translate.instant('UPDATED_SUCCESS'), "ContactInfoComponent", "top", ToastStyle.INFO, 3000);
      }
    } else {
      data.eventsHandler(rawDetails, 'NEWDATACREATED');
      this.notificationService.notify(this.translate.instant('KIT_BOOKING_NEW_CREATED'), "DynamicFormComponent", "top", ToastStyle.INFO, 3000);
    }
  } 

  private _handleFormSavedNavigation(data: any, eventTarget: string, newSetBooking: SetBookingActivity) {
    if(data.layoverViewPushedFrom && (data.layoverViewPushedFrom == 'KitBookingfromAccountTool' || data.layoverViewPushedFrom == 'KitBookingfromContactTool')){
      if(eventTarget == 'SUBMITKITBOOKING'){
        if(data.layoverViewPushedFrom == 'KitBookingfromAccountTool'){
          this.uiService.activeView = 'accountDetails';
          this.footerService.initButtons(FooterViews.Accounts);
          this.navService.popChildNavPageWithPageTracking();
        } else if(data.layoverViewPushedFrom == 'KitBookingfromContactTool'){
          this.uiService.activeView = 'contactDetails';
          this.footerService.initButtons(FooterViews.Contacts);
          this.navService.popChildNavPageWithPageTracking();
        }
      }
    } else {
      this.events.publish('activity-pane:selectActivity-kitBookingSubmission', newSetBooking);
    }
  }

  private _handleCancelNavigation(data: any) {
    if(data.layoverViewPushedFrom && data.layoverViewPushedFrom == 'KitBookingfromAccountTool'){
      this.uiService.activeView = 'accountDetails';
      this.footerService.initButtons(FooterViews.Accounts);
      this.navService.popChildNavPageWithPageTracking();
    } else if(data.layoverViewPushedFrom && data.layoverViewPushedFrom == 'KitBookingfromContactTool'){
      this.uiService.activeView = 'contactDetails';
      this.footerService.initButtons(FooterViews.Contacts);
      this.navService.popChildNavPageWithPageTracking();
    } else {
      this.navService.popToRootChildNavPageWithPageTracking();
      this.navService.setChildNavRoot(PageName.NothingSelectedView, PageName.NothingSelectedView, PageName.GoAppActivitiesPageComponent);
      this.uiService.showRightPane = false;
      this.navService.setChildNavRightPaneView(false);
    }
  }
  
  private async _handleKitBookingFormComponentEvent(data, eventTarget, refData: DynamicFormComponentModel) {
    if (!eventTarget) return;

    switch (eventTarget) {
      case 'DONEBUTTONCLICK':
      case 'SUBMITKITBOOKING':
      case 'SAVEKITBOOKING':
        await this._handleKitBookingSubmission(data, eventTarget);
        break;
      case 'CANCELBUTTONCLICK':
        await this._handleKitBookingCancellation(data);
        break;
      case 'ADDEDLINKEDENTITY':
      case 'SCRAPLINKEDENTITY':
        await this._handleLinkedEntityEvent(data);
        break;
      case 'ISFORMDIRTY':
        this._handleFormDirtyEvent(data);
        break;
    }
  }

  private async _handleKitBookingSubmission(data: any, eventTarget: string) {
    if (!data?.formValue) return;

    if (eventTarget === 'SUBMITKITBOOKING') {
      this.trackingService.tracking('KitBookingSubmitClick', TrackingEventNames.KITBOOKING);
    }

    if (!(await this._validateLimitedReleaseProducts(data, eventTarget))) {
      return;
    }

    if (!(await this._validateUrgentKitBooking(data, eventTarget))) {
      return;
    }

    if (!(await this._validateLateKitBooking(data, eventTarget))) {
      return;
    }

    if (!(await this._validateStartDate(data, eventTarget))) {
      return;
    }

    await this._processKitBookingSubmission(data, eventTarget);
  }

  private async _validateUrgentKitBooking(data: any, eventTarget: string): Promise<boolean> {
    if (eventTarget === "SUBMITKITBOOKING" && 
        this.authService.user.buSettings["indskr_urgentkitbookingmessage"] && 
        data.formValue["indskr_urgent"]) {
      await this.alertService.showAlert({
        header: this.translate.instant('NOTE'),
        message: this.authService.user.buSettings["indskr_urgentkitbookingmessage"],
        backdropDismiss: false,
        buttons: [{ text: this.translate.instant('OK'), role: "ok" }]
      });
    }
    
    return true;
  }

  private async _validateLateKitBooking(data: any, eventTarget: string): Promise<boolean> {
    if (eventTarget !== 'SUBMITKITBOOKING' ||
        !this._isLateKitBookingConfigured() ||
        !this.authService.user.buSettings["indskr_latekitbookingmessage"]) {
      return true;
    }

    const daysDiff = this.dateTimeFormatsService.getDifferenceInCalendarDays(data.formValue["indskr_startdate"], new Date());
    const maxDays = this.authService.user.buSettings["indskr_latekitbookingdays"];
    
    if (daysDiff < 0 || daysDiff > maxDays) {
      return true;
    }

    const res = await this.alertService.showAlert({
      header: `Booking required within ${maxDays} days`,
      message: this.authService.user.buSettings["indskr_latekitbookingmessage"],
      backdropDismiss: false
    }, this.translate.instant('SUBMIT'));

    return !(res?.role === "cancel");
  }

  private _isLateKitBookingConfigured(): boolean {
    const setting = this.authService.user.buSettings["indskr_latekitbookingdays"];
    return setting !== undefined && setting !== null;
  }

  private async _validateStartDate(data: any, eventTarget: string): Promise<boolean> {
    if (eventTarget !== 'SUBMITKITBOOKING') {
      return true;
    }

    const daysDiff = this.dateTimeFormatsService.getDifferenceInCalendarDays(data.formValue["indskr_startdate"], new Date());
    const diffInMin = this.dateTimeFormatsService.getDifferenceInMinutes(new Date(data.formValue["indskr_startdate"]), new Date());
    
    if (daysDiff < 0 || (daysDiff === 0 && diffInMin < 0)) {
      this.notificationService.notify(
        this.translate.instant('DATE_PICKER_START_DATE_CAN_NOT_BEFORE_CURRENT_DATE', { kitbookingaction: "submitted" }), 
        'New Activity', 
        'top', 
        ToastStyle.DANGER
      );
      return false;
    }
    return true;
  }

  private async _processKitBookingSubmission(data: any, eventTarget: string) {
    this.uiService.displayLoader();
    
    await this._processLinkedEntities();
    const newSetBooking = await this._createSetBookingActivity(data, eventTarget);
    await this._saveSetBookingActivity(newSetBooking, data, eventTarget);
    
    this.uiService.dismissLoader();
  }

  private async _processLinkedEntities() {
    const taskScrap = this._getScrapTasks();
    await Promise.all(taskScrap).then(() => {}).catch(() => {});
    
    const tasks = this._getCreateTasks();
    await Promise.all(tasks);
  }

  private _getScrapTasks(): Promise<any>[] {
    if (!this.linkEntitiesReqPayload?.length) return [];
    
    return this.linkEntitiesReqPayload
      .filter(reqPayload => reqPayload.values?.statecode === 1)
      .map(reqPayload => this.dynamicFormService.createLinkedEntity(reqPayload.values, reqPayload.entity));
  }

  private _getCreateTasks(): Promise<any>[] {
    if (!this.linkEntitiesReqPayload?.length) return [];
    
    const tasks = this.linkEntitiesReqPayload
      .filter(reqPayload => reqPayload.values?.statecode !== 1)
      .map(reqPayload => this.dynamicFormService.createLinkedEntity(reqPayload.values, reqPayload.entity));
    
    this.linkEntitiesReqPayload = [];
    return tasks;
  }

  private async _createSetBookingActivity(data: any, eventTarget: string): Promise<SetBookingActivity> {
    const newSetBooking = new SetBookingActivity(data.formValue);
    newSetBooking.allDayEvent = !this.dateTimeFormatsService.isSameDayCheck(newSetBooking.scheduledStart, newSetBooking.scheduledEnd);
    newSetBooking.serviceDTO = cloneDeep(data.formValue);
    
    this._removeDefaultCaseTeamIfUnchanged(newSetBooking, data);
    this._mapDateFields(newSetBooking);
    this._setBookingStatus(newSetBooking, data, eventTarget);
    
    return newSetBooking;
  }

  private _removeDefaultCaseTeamIfUnchanged(newSetBooking: SetBookingActivity, data: any) {
    const selectedActivity = this.activityOfflineService.getActivityByID(newSetBooking.ID) as SetBookingActivity;
    if (selectedActivity?.rawData?.['indskr_defaultcaseteam'] !== undefined && 
        selectedActivity.rawData['indskr_defaultcaseteam'] === data.formValue['indskr_defaultcaseteam']) {
      delete newSetBooking.serviceDTO['indskr_defaultcaseteam'];
    }
  }

  private _mapDateFields(newSetBooking: SetBookingActivity) {
    if (newSetBooking.serviceDTO['indskr_startdate']) {
      newSetBooking.serviceDTO['indskr_operationstartdate'] = newSetBooking.serviceDTO['indskr_startdate'];
      delete newSetBooking.serviceDTO.indskr_startdate;
    }
    if (newSetBooking.serviceDTO['indskr_enddate']) {
      newSetBooking.serviceDTO['indskr_operationenddate'] = newSetBooking.serviceDTO['indskr_enddate'];
      delete newSetBooking.serviceDTO.indskr_enddate;
    }
  }

  private _setBookingStatus(newSetBooking: SetBookingActivity, data: any, eventTarget: string) {
    if (data.isFormSaved && eventTarget === 'SUBMITKITBOOKING') {
      newSetBooking.serviceDTO['indskr_status'] = SetBookingStatus.PENDINGSYNC;
      newSetBooking.statusString = 'Pending Sync';
    } else {
      newSetBooking.serviceDTO['indskr_status'] = SetBookingStatus.DRAFT;
      newSetBooking.serviceDTO['indskr_source'] = 548910001;
      newSetBooking.statusString = 'Draft';
    }
  }

  private async _saveSetBookingActivity(newSetBooking: SetBookingActivity, data: any, eventTarget: string) {
    const action: OperationDetail = {
      onDynamics: true,
      onLocalDatabase: true,
      onLocalCopy: true,
      operationDetail: {
        code: 'CREATENEWSETBOOKINGACTIVITY',
        message: 'Create New Set Booking Activity'
      }
    };

    const tasks = [this.setBookingDataService.createSetBookingActivity(action, [newSetBooking], new Date().getTime())];
    
    Promise.all(tasks).then(async (res) => {
      if (!res) {
        this.uiService.dismissLoader();
        return;
      }
      await this.setBookingDataService.fetchRealTimeSetBookingDetails(newSetBooking);
      this._handleKitBookingSuccess(newSetBooking, data, eventTarget, res);
      this.uiService.dismissLoader();
    }).catch(() => {
      this.uiService.dismissLoader();
    });
  }

  private async _handleKitBookingCancellation(data: any) {
    if (data?.displayConfirmation) {
      const flag = await this.setBookingDataService.checkSetBookingDiscardConfirmationRequired().catch(err => {});
      if (flag) {
        this._resetFormState();
        this._handleCancelNavigation(data);
      }
    } else {
      this._handleCancelNavigation(data);
    }
  }

  private _resetFormState() {
    this.dynamicFormService.linkedEntityFormIsDirtyTracker = false;
    this.dynamicFormService.okAddressMapper = {};
    this.dynamicFormService.okLookUpMapper = [];
    this.linkEntitiesReqPayload = [];
  }

  private async _handleLinkedEntityEvent(data: any) {
    this.trackingService.tracking('DoneSelected', TrackingEventNames.ACCOUNT_EDIT, true);
    if (data?.entity && data?.values) {
      this.addLinkEntitiesForKitBooking(data);
    }
  }

  private _handleFormDirtyEvent(data: any) {
    this.setBookingDataService._isCreateEditKitBookingFormDirty = data;
  }

  private addLinkEntitiesForKitBooking(linkEntity) {
    if (linkEntity && linkEntity['entity'] == 'indskr_setbookingproducts' && linkEntity['linkedEntityAddedNewDataId']
        && linkEntity['values'] && linkEntity['values']['statecode'] == 1
        && !isEmpty(this.linkEntitiesReqPayload)) {
        let idx = this.linkEntitiesReqPayload.findIndex(le => le.addedNewDataId == linkEntity['linkedEntityAddedNewDataId']);
        if(idx>-1) {
          this.linkEntitiesReqPayload.splice(idx,1);
      }
    } else if (isEmpty(linkEntity))
      this.linkEntitiesReqPayload = [];
    else {
      const linkEntityPayload = {
        "values": linkEntity["values"],
        "entity": linkEntity["entity"],
        "linkedEntityId": linkEntity["linkedEntityExistingDataId"],
        "addedNewDataId": linkEntity["linkedEntityAddedNewDataId"]
      }
      if (!isEmpty(this.linkEntitiesReqPayload)) {
        let index;
          if (linkEntity["linkedEntityExistingDataId"]) {
            index = this.linkEntitiesReqPayload.findIndex(x => x.linkedEntityId == linkEntity["linkedEntityExistingDataId"]);
          } else {
            index = this.linkEntitiesReqPayload.findIndex(x => x.addedNewDataId == linkEntity["linkedEntityAddedNewDataId"]);
          }
          if (index != -1) {
            if(linkEntity["linkedEntityAddedNewDataId"] && !linkEntity["linkedEntityExistingDataId"] && linkEntityPayload.values.statecode == 1) this.linkEntitiesReqPayload.splice(index, 1);
            else this.linkEntitiesReqPayload[index] = linkEntityPayload;
          } else this.linkEntitiesReqPayload.push(linkEntityPayload);
        } else {
          this.linkEntitiesReqPayload.push(linkEntityPayload);
        }
    }
  }

  private async handleNewQuotes() {
    try {
      let options = null;

      if (this.from === 'AccountTool') {
        options = this.createQuotesPreloadDataFromAccountTool();
      } else if (this.from === 'OpportunityManagementTool') {
        options = this.createQuotesPreloadDataFromQpportunity();
        this.quotesOfflineService.createdFrom = PageName.OpportunityManagementPage;
      }else if (this.from == 'MarketingPlanInfoopportunities') {
        options = this.createQuotesPreloadDataFromQpportunity();
        this.quotesOfflineService.createdFrom = PageName.MarketingPlanManagementPageComponent;
      }

      this.quotesOfflineService.preloadedData = options.preloadData;
      this.navService.popChildNavPageWithPageTracking();
      this.pushChildNavPageWithPageTracking(PageName.NewQuoteComponent, PageName.NewQuoteComponent, PageName.QuotePageComponent, {
        nestedRoute: true,
        ...options
      });
    } catch (error) {
      console.error('Error during creation of quote')
    }
  }

  createQuotesPreloadDataFromQpportunity() {
    try {
      const { accountID, accountName, ID, opportunityName, transactionCurrencyID } = this.opportunity;
      const priceLists = this.quotesOfflineService.priceLists;
      const selectedPriceList = priceLists.find((s) => s.currencyId === transactionCurrencyID);

      let preloadData: any = {
        accountId: accountID,
        accountName,
        opportunityId: ID,
        opportunityName,
        transactionCurrencyId: transactionCurrencyID,
      };

      if (selectedPriceList) {
        preloadData = {
          ...preloadData,
          currencyName: selectedPriceList.currencyName,
        }
      }

      return { preloadData };
    } catch (error) {
      console.error('Error while setting preload data for quotes from opporunity tool');
    }
  }

  createQuotesPreloadDataFromAccountTool() {
    const { id, accountName } = this.account;

    let preloadData: any = {
      accountId: id,
      accountName
    }

    return { preloadData };
  }

  openUrl(event:any, contentBody: any) {
    if(event && event.target && (event.target.id == '' || event.target.id == undefined) || this.device.isOffline) return;
    this.activityOfflineService.openUrl(event, contentBody);
  }

  initDescriptions() {
    this.customerInquiryDescription = this.authService.user.buConfigs['indskr_customerinquirydescription'];
  }

  private enableSpecificActivityToShow(activeViewList: string[]) {
    // Reset all properties to false
    this.allProperties.forEach(property => {
      (this as any)[property] = false;
    });
    // Set properties specified in activeViewList to true
    activeViewList.forEach(view => {
      if (this.allProperties.includes(view)) {
        (this as any)[view] = true;
      }
    });
  }

  trackByIndex(index: number): number {
    return index;
  }
}
